import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { Query } from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  jsonb: any;
  name: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};




export type AddressData = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  house_number?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type ChangePasswordOutput = {
  __typename?: 'ChangePasswordOutput';
  success: Scalars['Boolean'];
};

export type CompanyData = {
  address: AddressData;
  ateco_code: Scalars['String'];
  company_category_id?: Maybe<Scalars['String']>;
  company_holder_id?: Maybe<Scalars['String']>;
  company_role: Scalars['String'];
  company_state: Scalars['String'];
  email: Scalars['String'];
  fiscal_code?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector_id: Scalars['String'];
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type RegisterCompanyInput = {
  company: CompanyData;
  dipendentiList?: Maybe<Array<Maybe<DipendentiData>>>;
  documentList?: Maybe<Array<Maybe<DocumentData>>>;
  user: UserData;
  user_company: UserCompanyData;
};

export type RegisterCompanyOutput = {
  __typename?: 'RegisterCompanyOutput';
  data?: Maybe<Scalars['jsonb']>;
  success: Scalars['Boolean'];
};

export type RegisterUserOutput = {
  __typename?: 'RegisterUserOutput';
  data?: Maybe<Scalars['jsonb']>;
  success: Scalars['Boolean'];
};

export type ResetPasswordOutput = {
  __typename?: 'ResetPasswordOutput';
  success: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export type UserData = {
  birth_date?: Maybe<Scalars['String']>;
  fiscal_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  city: Scalars['String'];
  /** An array relationship */
  company: Array<Companies>;
  /** An aggregate relationship */
  company_aggregate: Companies_Aggregate;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  house_number?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  province: Scalars['String'];
  street: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  zip: Scalars['String'];
};


/** columns and relationships of "addresses" */
export type AddressesCompanyArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** aggregated selection of "addresses" */
export type Addresses_Aggregate = {
  __typename?: 'addresses_aggregate';
  aggregate?: Maybe<Addresses_Aggregate_Fields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type Addresses_Aggregate_Fields = {
  __typename?: 'addresses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Addresses_Max_Fields>;
  min?: Maybe<Addresses_Min_Fields>;
};


/** aggregate fields of "addresses" */
export type Addresses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addresses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: Maybe<Array<Addresses_Bool_Exp>>;
  _not?: Maybe<Addresses_Bool_Exp>;
  _or?: Maybe<Array<Addresses_Bool_Exp>>;
  city?: Maybe<String_Comparison_Exp>;
  company?: Maybe<Companies_Bool_Exp>;
  company_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  house_number?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  province?: Maybe<String_Comparison_Exp>;
  street?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  zip?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "addresses" */
export enum Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressesPkey = 'addresses_pkey'
}

/** input type for inserting data into table "addresses" */
export type Addresses_Insert_Input = {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Companies_Arr_Rel_Insert_Input>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Addresses_Max_Fields = {
  __typename?: 'addresses_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Addresses_Min_Fields = {
  __typename?: 'addresses_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "addresses" */
export type Addresses_Mutation_Response = {
  __typename?: 'addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** input type for inserting object relation for remote table "addresses" */
export type Addresses_Obj_Rel_Insert_Input = {
  data: Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Addresses_On_Conflict>;
};

/** on_conflict condition type for table "addresses" */
export type Addresses_On_Conflict = {
  constraint: Addresses_Constraint;
  update_columns?: Array<Addresses_Update_Column>;
  where?: Maybe<Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  city?: Maybe<Order_By>;
  company_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  house_number?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  province?: Maybe<Order_By>;
  street?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  zip?: Maybe<Order_By>;
};

/** primary key columns input for table: addresses */
export type Addresses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Province = 'province',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "addresses" */
export type Addresses_Set_Input = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  house_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  province?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** update columns of table "addresses" */
export enum Addresses_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HouseNumber = 'house_number',
  /** column name */
  Id = 'id',
  /** column name */
  Province = 'province',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

export type Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};

/** columns and relationships of "companies" */
export type Companies = {
  __typename?: 'companies';
  /** An object relationship */
  address: Addresses;
  address_id: Scalars['uuid'];
  ateco_code: Scalars['String'];
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  /** An object relationship */
  company?: Maybe<Companies>;
  /** An object relationship */
  company_category?: Maybe<Company_Categories>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  company_role: Company_Roles_Enum;
  /** An object relationship */
  company_sector?: Maybe<Company_Sector>;
  company_state: Company_States_Enum;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  email: Scalars['String'];
  /** An array relationship */
  events: Array<Course_Events>;
  /** An aggregate relationship */
  events_aggregate: Course_Events_Aggregate;
  fiscal_code?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  issued_documents: Array<Documents>;
  /** An aggregate relationship */
  issued_documents_aggregate: Documents_Aggregate;
  legal_representative?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  legal_representative_user?: Maybe<Users>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pec: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  qualified_at?: Maybe<Scalars['time']>;
  /** An object relationship */
  role: Company_Roles;
  sector_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  state: Company_States;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
  vat: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "companies" */
export type CompaniesCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesEventsArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesEvents_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesIssued_DocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesIssued_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};

/** aggregated selection of "companies" */
export type Companies_Aggregate = {
  __typename?: 'companies_aggregate';
  aggregate?: Maybe<Companies_Aggregate_Fields>;
  nodes: Array<Companies>;
};

export type Companies_Aggregate_Bool_Exp = {
  count?: Maybe<Companies_Aggregate_Bool_Exp_Count>;
};

export type Companies_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Companies_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Companies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "companies" */
export type Companies_Aggregate_Fields = {
  __typename?: 'companies_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Companies_Max_Fields>;
  min?: Maybe<Companies_Min_Fields>;
};


/** aggregate fields of "companies" */
export type Companies_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Companies_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "companies" */
export type Companies_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Companies_Max_Order_By>;
  min?: Maybe<Companies_Min_Order_By>;
};

/** input type for inserting array relation for remote table "companies" */
export type Companies_Arr_Rel_Insert_Input = {
  data: Array<Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Companies_On_Conflict>;
};

/** Boolean expression to filter rows from the table "companies". All fields are combined with a logical 'AND'. */
export type Companies_Bool_Exp = {
  _and?: Maybe<Array<Companies_Bool_Exp>>;
  _not?: Maybe<Companies_Bool_Exp>;
  _or?: Maybe<Array<Companies_Bool_Exp>>;
  address?: Maybe<Addresses_Bool_Exp>;
  address_id?: Maybe<Uuid_Comparison_Exp>;
  ateco_code?: Maybe<String_Comparison_Exp>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  company?: Maybe<Companies_Bool_Exp>;
  company_category?: Maybe<Company_Categories_Bool_Exp>;
  company_category_id?: Maybe<Uuid_Comparison_Exp>;
  company_holder_id?: Maybe<Uuid_Comparison_Exp>;
  company_role?: Maybe<Company_Roles_Enum_Comparison_Exp>;
  company_sector?: Maybe<Company_Sector_Bool_Exp>;
  company_state?: Maybe<Company_States_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  events?: Maybe<Course_Events_Bool_Exp>;
  events_aggregate?: Maybe<Course_Events_Aggregate_Bool_Exp>;
  fiscal_code?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  issued_documents?: Maybe<Documents_Bool_Exp>;
  issued_documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  legal_representative?: Maybe<Uuid_Comparison_Exp>;
  legal_representative_user?: Maybe<Users_Bool_Exp>;
  logo?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  pec?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  qualified_at?: Maybe<Time_Comparison_Exp>;
  role?: Maybe<Company_Roles_Bool_Exp>;
  sector_id?: Maybe<Uuid_Comparison_Exp>;
  state?: Maybe<Company_States_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_companies?: Maybe<User_Companies_Bool_Exp>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Bool_Exp>;
  vat?: Maybe<String_Comparison_Exp>;
  website?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "companies" */
export enum Companies_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompaniesPkey = 'companies_pkey'
}

/** input type for inserting data into table "companies" */
export type Companies_Insert_Input = {
  address?: Maybe<Addresses_Obj_Rel_Insert_Input>;
  address_id?: Maybe<Scalars['uuid']>;
  ateco_code?: Maybe<Scalars['String']>;
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  company_category?: Maybe<Company_Categories_Obj_Rel_Insert_Input>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  company_role?: Maybe<Company_Roles_Enum>;
  company_sector?: Maybe<Company_Sector_Obj_Rel_Insert_Input>;
  company_state?: Maybe<Company_States_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  email?: Maybe<Scalars['String']>;
  events?: Maybe<Course_Events_Arr_Rel_Insert_Input>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issued_documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  legal_representative?: Maybe<Scalars['uuid']>;
  legal_representative_user?: Maybe<Users_Obj_Rel_Insert_Input>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  qualified_at?: Maybe<Scalars['time']>;
  role?: Maybe<Company_Roles_Obj_Rel_Insert_Input>;
  sector_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Company_States_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_companies?: Maybe<User_Companies_Arr_Rel_Insert_Input>;
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Companies_Max_Fields = {
  __typename?: 'companies_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  ateco_code?: Maybe<Scalars['String']>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_representative?: Maybe<Scalars['uuid']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "companies" */
export type Companies_Max_Order_By = {
  address_id?: Maybe<Order_By>;
  ateco_code?: Maybe<Order_By>;
  company_category_id?: Maybe<Order_By>;
  company_holder_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  fiscal_code?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  legal_representative?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  pec?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  sector_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vat?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Companies_Min_Fields = {
  __typename?: 'companies_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  ateco_code?: Maybe<Scalars['String']>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_representative?: Maybe<Scalars['uuid']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "companies" */
export type Companies_Min_Order_By = {
  address_id?: Maybe<Order_By>;
  ateco_code?: Maybe<Order_By>;
  company_category_id?: Maybe<Order_By>;
  company_holder_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  fiscal_code?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  legal_representative?: Maybe<Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  pec?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  sector_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vat?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** response of any mutation on the table "companies" */
export type Companies_Mutation_Response = {
  __typename?: 'companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Companies>;
};

/** input type for inserting object relation for remote table "companies" */
export type Companies_Obj_Rel_Insert_Input = {
  data: Companies_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Companies_On_Conflict>;
};

/** on_conflict condition type for table "companies" */
export type Companies_On_Conflict = {
  constraint: Companies_Constraint;
  update_columns?: Array<Companies_Update_Column>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "companies". */
export type Companies_Order_By = {
  address?: Maybe<Addresses_Order_By>;
  address_id?: Maybe<Order_By>;
  ateco_code?: Maybe<Order_By>;
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  company?: Maybe<Companies_Order_By>;
  company_category?: Maybe<Company_Categories_Order_By>;
  company_category_id?: Maybe<Order_By>;
  company_holder_id?: Maybe<Order_By>;
  company_role?: Maybe<Order_By>;
  company_sector?: Maybe<Company_Sector_Order_By>;
  company_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  email?: Maybe<Order_By>;
  events_aggregate?: Maybe<Course_Events_Aggregate_Order_By>;
  fiscal_code?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issued_documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  legal_representative?: Maybe<Order_By>;
  legal_representative_user?: Maybe<Users_Order_By>;
  logo?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  pec?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  qualified_at?: Maybe<Order_By>;
  role?: Maybe<Company_Roles_Order_By>;
  sector_id?: Maybe<Order_By>;
  state?: Maybe<Company_States_Order_By>;
  updated_at?: Maybe<Order_By>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Order_By>;
  vat?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** primary key columns input for table: companies */
export type Companies_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "companies" */
export enum Companies_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AtecoCode = 'ateco_code',
  /** column name */
  CompanyCategoryId = 'company_category_id',
  /** column name */
  CompanyHolderId = 'company_holder_id',
  /** column name */
  CompanyRole = 'company_role',
  /** column name */
  CompanyState = 'company_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FiscalCode = 'fiscal_code',
  /** column name */
  Id = 'id',
  /** column name */
  LegalRepresentative = 'legal_representative',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Pec = 'pec',
  /** column name */
  Phone = 'phone',
  /** column name */
  QualifiedAt = 'qualified_at',
  /** column name */
  SectorId = 'sector_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Vat = 'vat',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "companies" */
export type Companies_Set_Input = {
  address_id?: Maybe<Scalars['uuid']>;
  ateco_code?: Maybe<Scalars['String']>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  company_role?: Maybe<Company_Roles_Enum>;
  company_state?: Maybe<Company_States_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_representative?: Maybe<Scalars['uuid']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  qualified_at?: Maybe<Scalars['time']>;
  sector_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "companies" */
export type Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Companies_Stream_Cursor_Value_Input = {
  address_id?: Maybe<Scalars['uuid']>;
  ateco_code?: Maybe<Scalars['String']>;
  company_category_id?: Maybe<Scalars['uuid']>;
  company_holder_id?: Maybe<Scalars['uuid']>;
  company_role?: Maybe<Company_Roles_Enum>;
  company_state?: Maybe<Company_States_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_representative?: Maybe<Scalars['uuid']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  qualified_at?: Maybe<Scalars['time']>;
  sector_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** update columns of table "companies" */
export enum Companies_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AtecoCode = 'ateco_code',
  /** column name */
  CompanyCategoryId = 'company_category_id',
  /** column name */
  CompanyHolderId = 'company_holder_id',
  /** column name */
  CompanyRole = 'company_role',
  /** column name */
  CompanyState = 'company_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FiscalCode = 'fiscal_code',
  /** column name */
  Id = 'id',
  /** column name */
  LegalRepresentative = 'legal_representative',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  Pec = 'pec',
  /** column name */
  Phone = 'phone',
  /** column name */
  QualifiedAt = 'qualified_at',
  /** column name */
  SectorId = 'sector_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Vat = 'vat',
  /** column name */
  Website = 'website'
}

export type Companies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Companies_Set_Input>;
  where: Companies_Bool_Exp;
};

/** columns and relationships of "company_categories" */
export type Company_Categories = {
  __typename?: 'company_categories';
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description: Text_Contexts;
  description_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  name: Text_Contexts;
  name_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "company_categories" */
export type Company_CategoriesCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "company_categories" */
export type Company_CategoriesCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** aggregated selection of "company_categories" */
export type Company_Categories_Aggregate = {
  __typename?: 'company_categories_aggregate';
  aggregate?: Maybe<Company_Categories_Aggregate_Fields>;
  nodes: Array<Company_Categories>;
};

/** aggregate fields of "company_categories" */
export type Company_Categories_Aggregate_Fields = {
  __typename?: 'company_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Categories_Max_Fields>;
  min?: Maybe<Company_Categories_Min_Fields>;
};


/** aggregate fields of "company_categories" */
export type Company_Categories_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Categories_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_categories". All fields are combined with a logical 'AND'. */
export type Company_Categories_Bool_Exp = {
  _and?: Maybe<Array<Company_Categories_Bool_Exp>>;
  _not?: Maybe<Company_Categories_Bool_Exp>;
  _or?: Maybe<Array<Company_Categories_Bool_Exp>>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_categories" */
export enum Company_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompanyCategoriesPkey = 'company_categories_pkey'
}

/** input type for inserting data into table "company_categories" */
export type Company_Categories_Insert_Input = {
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Company_Categories_Max_Fields = {
  __typename?: 'company_categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Company_Categories_Min_Fields = {
  __typename?: 'company_categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_categories" */
export type Company_Categories_Mutation_Response = {
  __typename?: 'company_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Categories>;
};

/** input type for inserting object relation for remote table "company_categories" */
export type Company_Categories_Obj_Rel_Insert_Input = {
  data: Company_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Company_Categories_On_Conflict>;
};

/** on_conflict condition type for table "company_categories" */
export type Company_Categories_On_Conflict = {
  constraint: Company_Categories_Constraint;
  update_columns?: Array<Company_Categories_Update_Column>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "company_categories". */
export type Company_Categories_Order_By = {
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: company_categories */
export type Company_Categories_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company_categories" */
export enum Company_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company_categories" */
export type Company_Categories_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_categories" */
export type Company_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Categories_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "company_categories" */
export enum Company_Categories_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Company_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_Categories_Set_Input>;
  where: Company_Categories_Bool_Exp;
};

/** columns and relationships of "company_roles" */
export type Company_Roles = {
  __typename?: 'company_roles';
  comment: Scalars['String'];
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  role: Scalars['String'];
};


/** columns and relationships of "company_roles" */
export type Company_RolesCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "company_roles" */
export type Company_RolesCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** aggregated selection of "company_roles" */
export type Company_Roles_Aggregate = {
  __typename?: 'company_roles_aggregate';
  aggregate?: Maybe<Company_Roles_Aggregate_Fields>;
  nodes: Array<Company_Roles>;
};

/** aggregate fields of "company_roles" */
export type Company_Roles_Aggregate_Fields = {
  __typename?: 'company_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Roles_Max_Fields>;
  min?: Maybe<Company_Roles_Min_Fields>;
};


/** aggregate fields of "company_roles" */
export type Company_Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_roles". All fields are combined with a logical 'AND'. */
export type Company_Roles_Bool_Exp = {
  _and?: Maybe<Array<Company_Roles_Bool_Exp>>;
  _not?: Maybe<Company_Roles_Bool_Exp>;
  _or?: Maybe<Array<Company_Roles_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  role?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_roles" */
export enum Company_Roles_Constraint {
  /** unique or primary key constraint on columns "role" */
  CompanyRolesPkey = 'company_roles_pkey'
}

export enum Company_Roles_Enum {
  /** blue */
  Blue = 'blue',
  /** red */
  Red = 'red',
  /** yellow */
  Yellow = 'yellow'
}

/** Boolean expression to compare columns of type "company_roles_enum". All fields are combined with logical 'AND'. */
export type Company_Roles_Enum_Comparison_Exp = {
  _eq?: Maybe<Company_Roles_Enum>;
  _in?: Maybe<Array<Company_Roles_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Company_Roles_Enum>;
  _nin?: Maybe<Array<Company_Roles_Enum>>;
};

/** input type for inserting data into table "company_roles" */
export type Company_Roles_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  role?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_Roles_Max_Fields = {
  __typename?: 'company_roles_max_fields';
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Company_Roles_Min_Fields = {
  __typename?: 'company_roles_min_fields';
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_roles" */
export type Company_Roles_Mutation_Response = {
  __typename?: 'company_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Roles>;
};

/** input type for inserting object relation for remote table "company_roles" */
export type Company_Roles_Obj_Rel_Insert_Input = {
  data: Company_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Company_Roles_On_Conflict>;
};

/** on_conflict condition type for table "company_roles" */
export type Company_Roles_On_Conflict = {
  constraint: Company_Roles_Constraint;
  update_columns?: Array<Company_Roles_Update_Column>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "company_roles". */
export type Company_Roles_Order_By = {
  comment?: Maybe<Order_By>;
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  role?: Maybe<Order_By>;
};

/** primary key columns input for table: company_roles */
export type Company_Roles_Pk_Columns_Input = {
  role: Scalars['String'];
};

/** select columns of table "company_roles" */
export enum Company_Roles_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "company_roles" */
export type Company_Roles_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "company_roles" */
export type Company_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Roles_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** update columns of table "company_roles" */
export enum Company_Roles_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Role = 'role'
}

export type Company_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_Roles_Set_Input>;
  where: Company_Roles_Bool_Exp;
};

/** columns and relationships of "company_sector" */
export type Company_Sector = {
  __typename?: 'company_sector';
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "company_sector" */
export type Company_SectorCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "company_sector" */
export type Company_SectorCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** aggregated selection of "company_sector" */
export type Company_Sector_Aggregate = {
  __typename?: 'company_sector_aggregate';
  aggregate?: Maybe<Company_Sector_Aggregate_Fields>;
  nodes: Array<Company_Sector>;
};

/** aggregate fields of "company_sector" */
export type Company_Sector_Aggregate_Fields = {
  __typename?: 'company_sector_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Sector_Max_Fields>;
  min?: Maybe<Company_Sector_Min_Fields>;
};


/** aggregate fields of "company_sector" */
export type Company_Sector_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Sector_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_sector". All fields are combined with a logical 'AND'. */
export type Company_Sector_Bool_Exp = {
  _and?: Maybe<Array<Company_Sector_Bool_Exp>>;
  _not?: Maybe<Company_Sector_Bool_Exp>;
  _or?: Maybe<Array<Company_Sector_Bool_Exp>>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_sector" */
export enum Company_Sector_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompanySectorPkey = 'company_sector_pkey'
}

/** input type for inserting data into table "company_sector" */
export type Company_Sector_Insert_Input = {
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Company_Sector_Max_Fields = {
  __typename?: 'company_sector_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Company_Sector_Min_Fields = {
  __typename?: 'company_sector_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_sector" */
export type Company_Sector_Mutation_Response = {
  __typename?: 'company_sector_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Sector>;
};

/** input type for inserting object relation for remote table "company_sector" */
export type Company_Sector_Obj_Rel_Insert_Input = {
  data: Company_Sector_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Company_Sector_On_Conflict>;
};

/** on_conflict condition type for table "company_sector" */
export type Company_Sector_On_Conflict = {
  constraint: Company_Sector_Constraint;
  update_columns?: Array<Company_Sector_Update_Column>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};

/** Ordering options when selecting data from "company_sector". */
export type Company_Sector_Order_By = {
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: company_sector */
export type Company_Sector_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company_sector" */
export enum Company_Sector_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "company_sector" */
export type Company_Sector_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_sector" */
export type Company_Sector_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Sector_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Sector_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "company_sector" */
export enum Company_Sector_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Company_Sector_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_Sector_Set_Input>;
  where: Company_Sector_Bool_Exp;
};

/** columns and relationships of "company_states" */
export type Company_States = {
  __typename?: 'company_states';
  comment: Scalars['String'];
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  state: Scalars['String'];
};


/** columns and relationships of "company_states" */
export type Company_StatesCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "company_states" */
export type Company_StatesCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};

/** aggregated selection of "company_states" */
export type Company_States_Aggregate = {
  __typename?: 'company_states_aggregate';
  aggregate?: Maybe<Company_States_Aggregate_Fields>;
  nodes: Array<Company_States>;
};

/** aggregate fields of "company_states" */
export type Company_States_Aggregate_Fields = {
  __typename?: 'company_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_States_Max_Fields>;
  min?: Maybe<Company_States_Min_Fields>;
};


/** aggregate fields of "company_states" */
export type Company_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_states". All fields are combined with a logical 'AND'. */
export type Company_States_Bool_Exp = {
  _and?: Maybe<Array<Company_States_Bool_Exp>>;
  _not?: Maybe<Company_States_Bool_Exp>;
  _or?: Maybe<Array<Company_States_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  state?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_states" */
export enum Company_States_Constraint {
  /** unique or primary key constraint on columns "state" */
  CompanyStatesPkey = 'company_states_pkey'
}

export enum Company_States_Enum {
  /** active */
  Active = 'active',
  /** disabled */
  Disabled = 'disabled'
}

/** Boolean expression to compare columns of type "company_states_enum". All fields are combined with logical 'AND'. */
export type Company_States_Enum_Comparison_Exp = {
  _eq?: Maybe<Company_States_Enum>;
  _in?: Maybe<Array<Company_States_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Company_States_Enum>;
  _nin?: Maybe<Array<Company_States_Enum>>;
};

/** input type for inserting data into table "company_states" */
export type Company_States_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_States_Max_Fields = {
  __typename?: 'company_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Company_States_Min_Fields = {
  __typename?: 'company_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_states" */
export type Company_States_Mutation_Response = {
  __typename?: 'company_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_States>;
};

/** input type for inserting object relation for remote table "company_states" */
export type Company_States_Obj_Rel_Insert_Input = {
  data: Company_States_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Company_States_On_Conflict>;
};

/** on_conflict condition type for table "company_states" */
export type Company_States_On_Conflict = {
  constraint: Company_States_Constraint;
  update_columns?: Array<Company_States_Update_Column>;
  where?: Maybe<Company_States_Bool_Exp>;
};

/** Ordering options when selecting data from "company_states". */
export type Company_States_Order_By = {
  comment?: Maybe<Order_By>;
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  state?: Maybe<Order_By>;
};

/** primary key columns input for table: company_states */
export type Company_States_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "company_states" */
export enum Company_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "company_states" */
export type Company_States_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "company_states" */
export type Company_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_States_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "company_states" */
export enum Company_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

export type Company_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_States_Set_Input>;
  where: Company_States_Bool_Exp;
};

/** columns and relationships of "course_categories" */
export type Course_Categories = {
  __typename?: 'course_categories';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description?: Maybe<Text_Contexts>;
  description_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  types: Array<Course_Types>;
  /** An aggregate relationship */
  types_aggregate: Course_Types_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "course_categories" */
export type Course_CategoriesTypesArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


/** columns and relationships of "course_categories" */
export type Course_CategoriesTypes_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};

/** aggregated selection of "course_categories" */
export type Course_Categories_Aggregate = {
  __typename?: 'course_categories_aggregate';
  aggregate?: Maybe<Course_Categories_Aggregate_Fields>;
  nodes: Array<Course_Categories>;
};

/** aggregate fields of "course_categories" */
export type Course_Categories_Aggregate_Fields = {
  __typename?: 'course_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Categories_Max_Fields>;
  min?: Maybe<Course_Categories_Min_Fields>;
};


/** aggregate fields of "course_categories" */
export type Course_Categories_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Course_Categories_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_categories". All fields are combined with a logical 'AND'. */
export type Course_Categories_Bool_Exp = {
  _and?: Maybe<Array<Course_Categories_Bool_Exp>>;
  _not?: Maybe<Course_Categories_Bool_Exp>;
  _or?: Maybe<Array<Course_Categories_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  types?: Maybe<Course_Types_Bool_Exp>;
  types_aggregate?: Maybe<Course_Types_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_categories" */
export enum Course_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseCategoriesPkey = 'course_categories_pkey'
}

/** input type for inserting data into table "course_categories" */
export type Course_Categories_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  types?: Maybe<Course_Types_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Categories_Max_Fields = {
  __typename?: 'course_categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Course_Categories_Min_Fields = {
  __typename?: 'course_categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "course_categories" */
export type Course_Categories_Mutation_Response = {
  __typename?: 'course_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Categories>;
};

/** input type for inserting object relation for remote table "course_categories" */
export type Course_Categories_Obj_Rel_Insert_Input = {
  data: Course_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Course_Categories_On_Conflict>;
};

/** on_conflict condition type for table "course_categories" */
export type Course_Categories_On_Conflict = {
  constraint: Course_Categories_Constraint;
  update_columns?: Array<Course_Categories_Update_Column>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "course_categories". */
export type Course_Categories_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  types_aggregate?: Maybe<Course_Types_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: course_categories */
export type Course_Categories_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_categories" */
export enum Course_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "course_categories" */
export type Course_Categories_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "course_categories" */
export type Course_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Categories_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "course_categories" */
export enum Course_Categories_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Course_Categories_Set_Input>;
  where: Course_Categories_Bool_Exp;
};

/** columns and relationships of "course_event_state" */
export type Course_Event_State = {
  __typename?: 'course_event_state';
  /** An array relationship */
  course_events: Array<Course_Events>;
  /** An aggregate relationship */
  course_events_aggregate: Course_Events_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  state: Text_Contexts;
  state_id: Scalars['uuid'];
};


/** columns and relationships of "course_event_state" */
export type Course_Event_StateCourse_EventsArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


/** columns and relationships of "course_event_state" */
export type Course_Event_StateCourse_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};

/** aggregated selection of "course_event_state" */
export type Course_Event_State_Aggregate = {
  __typename?: 'course_event_state_aggregate';
  aggregate?: Maybe<Course_Event_State_Aggregate_Fields>;
  nodes: Array<Course_Event_State>;
};

/** aggregate fields of "course_event_state" */
export type Course_Event_State_Aggregate_Fields = {
  __typename?: 'course_event_state_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Event_State_Max_Fields>;
  min?: Maybe<Course_Event_State_Min_Fields>;
};


/** aggregate fields of "course_event_state" */
export type Course_Event_State_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Course_Event_State_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_event_state". All fields are combined with a logical 'AND'. */
export type Course_Event_State_Bool_Exp = {
  _and?: Maybe<Array<Course_Event_State_Bool_Exp>>;
  _not?: Maybe<Course_Event_State_Bool_Exp>;
  _or?: Maybe<Array<Course_Event_State_Bool_Exp>>;
  course_events?: Maybe<Course_Events_Bool_Exp>;
  course_events_aggregate?: Maybe<Course_Events_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  state?: Maybe<Text_Contexts_Bool_Exp>;
  state_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_event_state" */
export enum Course_Event_State_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseEventStatePkey = 'course_event_state_pkey'
}

/** input type for inserting data into table "course_event_state" */
export type Course_Event_State_Insert_Input = {
  course_events?: Maybe<Course_Events_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Event_State_Max_Fields = {
  __typename?: 'course_event_state_max_fields';
  id?: Maybe<Scalars['uuid']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Course_Event_State_Min_Fields = {
  __typename?: 'course_event_state_min_fields';
  id?: Maybe<Scalars['uuid']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "course_event_state" */
export type Course_Event_State_Mutation_Response = {
  __typename?: 'course_event_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Event_State>;
};

/** input type for inserting object relation for remote table "course_event_state" */
export type Course_Event_State_Obj_Rel_Insert_Input = {
  data: Course_Event_State_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Course_Event_State_On_Conflict>;
};

/** on_conflict condition type for table "course_event_state" */
export type Course_Event_State_On_Conflict = {
  constraint: Course_Event_State_Constraint;
  update_columns?: Array<Course_Event_State_Update_Column>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};

/** Ordering options when selecting data from "course_event_state". */
export type Course_Event_State_Order_By = {
  course_events_aggregate?: Maybe<Course_Events_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  state?: Maybe<Text_Contexts_Order_By>;
  state_id?: Maybe<Order_By>;
};

/** primary key columns input for table: course_event_state */
export type Course_Event_State_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_event_state" */
export enum Course_Event_State_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  StateId = 'state_id'
}

/** input type for updating data in table "course_event_state" */
export type Course_Event_State_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "course_event_state" */
export type Course_Event_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Event_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Event_State_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "course_event_state" */
export enum Course_Event_State_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  StateId = 'state_id'
}

export type Course_Event_State_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Course_Event_State_Set_Input>;
  where: Course_Event_State_Bool_Exp;
};

/** columns and relationships of "course_events" */
export type Course_Events = {
  __typename?: 'course_events';
  /** An object relationship */
  company: Companies;
  company_id: Scalars['uuid'];
  /** An object relationship */
  course: Courses;
  /** An object relationship */
  course_event_state?: Maybe<Course_Event_State>;
  course_id: Scalars['uuid'];
  end_date: Scalars['date'];
  /** An array relationship */
  event_users: Array<Event_Users>;
  /** An aggregate relationship */
  event_users_aggregate: Event_Users_Aggregate;
  id: Scalars['uuid'];
  start_date: Scalars['date'];
  state_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "course_events" */
export type Course_EventsEvent_UsersArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


/** columns and relationships of "course_events" */
export type Course_EventsEvent_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};

/** aggregated selection of "course_events" */
export type Course_Events_Aggregate = {
  __typename?: 'course_events_aggregate';
  aggregate?: Maybe<Course_Events_Aggregate_Fields>;
  nodes: Array<Course_Events>;
};

export type Course_Events_Aggregate_Bool_Exp = {
  count?: Maybe<Course_Events_Aggregate_Bool_Exp_Count>;
};

export type Course_Events_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Course_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Course_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_events" */
export type Course_Events_Aggregate_Fields = {
  __typename?: 'course_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Events_Max_Fields>;
  min?: Maybe<Course_Events_Min_Fields>;
};


/** aggregate fields of "course_events" */
export type Course_Events_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Course_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_events" */
export type Course_Events_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Course_Events_Max_Order_By>;
  min?: Maybe<Course_Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "course_events" */
export type Course_Events_Arr_Rel_Insert_Input = {
  data: Array<Course_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Course_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_events". All fields are combined with a logical 'AND'. */
export type Course_Events_Bool_Exp = {
  _and?: Maybe<Array<Course_Events_Bool_Exp>>;
  _not?: Maybe<Course_Events_Bool_Exp>;
  _or?: Maybe<Array<Course_Events_Bool_Exp>>;
  company?: Maybe<Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  course?: Maybe<Courses_Bool_Exp>;
  course_event_state?: Maybe<Course_Event_State_Bool_Exp>;
  course_id?: Maybe<Uuid_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  event_users?: Maybe<Event_Users_Bool_Exp>;
  event_users_aggregate?: Maybe<Event_Users_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  state_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_events" */
export enum Course_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey'
}

/** input type for inserting data into table "course_events" */
export type Course_Events_Insert_Input = {
  company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  course?: Maybe<Courses_Obj_Rel_Insert_Input>;
  course_event_state?: Maybe<Course_Event_State_Obj_Rel_Insert_Input>;
  course_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  event_users?: Maybe<Event_Users_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Events_Max_Fields = {
  __typename?: 'course_events_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_events" */
export type Course_Events_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  course_id?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Events_Min_Fields = {
  __typename?: 'course_events_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_events" */
export type Course_Events_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  course_id?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "course_events" */
export type Course_Events_Mutation_Response = {
  __typename?: 'course_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Events>;
};

/** input type for inserting object relation for remote table "course_events" */
export type Course_Events_Obj_Rel_Insert_Input = {
  data: Course_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Course_Events_On_Conflict>;
};

/** on_conflict condition type for table "course_events" */
export type Course_Events_On_Conflict = {
  constraint: Course_Events_Constraint;
  update_columns?: Array<Course_Events_Update_Column>;
  where?: Maybe<Course_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "course_events". */
export type Course_Events_Order_By = {
  company?: Maybe<Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  course?: Maybe<Courses_Order_By>;
  course_event_state?: Maybe<Course_Event_State_Order_By>;
  course_id?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  event_users_aggregate?: Maybe<Event_Users_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state_id?: Maybe<Order_By>;
};

/** primary key columns input for table: course_events */
export type Course_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_events" */
export enum Course_Events_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StateId = 'state_id'
}

/** input type for updating data in table "course_events" */
export type Course_Events_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "course_events" */
export type Course_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Events_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
  state_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "course_events" */
export enum Course_Events_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StateId = 'state_id'
}

export type Course_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Course_Events_Set_Input>;
  where: Course_Events_Bool_Exp;
};

/** columns and relationships of "course_types" */
export type Course_Types = {
  __typename?: 'course_types';
  /** An object relationship */
  category: Course_Categories;
  category_id: Scalars['uuid'];
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description?: Maybe<Text_Contexts>;
  description_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  aggiornamento?: Maybe<Scalars['Int']>;
  durata?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "course_types" */
export type Course_TypesCoursesArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};


/** columns and relationships of "course_types" */
export type Course_TypesCourses_AggregateArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};

/** aggregated selection of "course_types" */
export type Course_Types_Aggregate = {
  __typename?: 'course_types_aggregate';
  aggregate?: Maybe<Course_Types_Aggregate_Fields>;
  nodes: Array<Course_Types>;
};

export type Course_Types_Aggregate_Bool_Exp = {
  count?: Maybe<Course_Types_Aggregate_Bool_Exp_Count>;
};

export type Course_Types_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Course_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Course_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_types" */
export type Course_Types_Aggregate_Fields = {
  __typename?: 'course_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Types_Max_Fields>;
  min?: Maybe<Course_Types_Min_Fields>;
};


/** aggregate fields of "course_types" */
export type Course_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Course_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_types" */
export type Course_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Course_Types_Max_Order_By>;
  min?: Maybe<Course_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "course_types" */
export type Course_Types_Arr_Rel_Insert_Input = {
  data: Array<Course_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Course_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_types". All fields are combined with a logical 'AND'. */
export type Course_Types_Bool_Exp = {
  _and?: Maybe<Array<Course_Types_Bool_Exp>>;
  _not?: Maybe<Course_Types_Bool_Exp>;
  _or?: Maybe<Array<Course_Types_Bool_Exp>>;
  category?: Maybe<Course_Categories_Bool_Exp>;
  category_id?: Maybe<Uuid_Comparison_Exp>;
  courses?: Maybe<Courses_Bool_Exp>;
  courses_aggregate?: Maybe<Courses_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_types" */
export enum Course_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseTypesPkey = 'course_types_pkey'
}

/** input type for inserting data into table "course_types" */
export type Course_Types_Insert_Input = {
  category?: Maybe<Course_Categories_Obj_Rel_Insert_Input>;
  category_id?: Maybe<Scalars['uuid']>;
  courses?: Maybe<Courses_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  durata?: Maybe<Scalars['Int']>;
  aggiornamento?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Course_Types_Max_Fields = {
  __typename?: 'course_types_max_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_types" */
export type Course_Types_Max_Order_By = {
  category_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Types_Min_Fields = {
  __typename?: 'course_types_min_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_types" */
export type Course_Types_Min_Order_By = {
  category_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "course_types" */
export type Course_Types_Mutation_Response = {
  __typename?: 'course_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Types>;
};

/** input type for inserting object relation for remote table "course_types" */
export type Course_Types_Obj_Rel_Insert_Input = {
  data: Course_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Course_Types_On_Conflict>;
};

/** on_conflict condition type for table "course_types" */
export type Course_Types_On_Conflict = {
  constraint: Course_Types_Constraint;
  update_columns?: Array<Course_Types_Update_Column>;
  where?: Maybe<Course_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "course_types". */
export type Course_Types_Order_By = {
  category?: Maybe<Course_Categories_Order_By>;
  category_id?: Maybe<Order_By>;
  courses_aggregate?: Maybe<Courses_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: course_types */
export type Course_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_types" */
export enum Course_Types_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "course_types" */
export type Course_Types_Set_Input = {
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "course_types" */
export type Course_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Types_Stream_Cursor_Value_Input = {
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "course_types" */
export enum Course_Types_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Course_Types_Set_Input>;
  where: Course_Types_Bool_Exp;
};

/** columns and relationships of "courses" */
export type Courses = {
  __typename?: 'courses';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description?: Maybe<Text_Contexts>;
  description_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  events: Array<Course_Events>;
  /** An aggregate relationship */
  events_aggregate: Course_Events_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  type: Course_Types;
  type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "courses" */
export type CoursesEventsArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesEvents_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};

/** aggregated selection of "courses" */
export type Courses_Aggregate = {
  __typename?: 'courses_aggregate';
  aggregate?: Maybe<Courses_Aggregate_Fields>;
  nodes: Array<Courses>;
};

export type Courses_Aggregate_Bool_Exp = {
  count?: Maybe<Courses_Aggregate_Bool_Exp_Count>;
};

export type Courses_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Courses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "courses" */
export type Courses_Aggregate_Fields = {
  __typename?: 'courses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Courses_Max_Fields>;
  min?: Maybe<Courses_Min_Fields>;
};


/** aggregate fields of "courses" */
export type Courses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Courses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "courses" */
export type Courses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Courses_Max_Order_By>;
  min?: Maybe<Courses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "courses" */
export type Courses_Arr_Rel_Insert_Input = {
  data: Array<Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export type Courses_Bool_Exp = {
  _and?: Maybe<Array<Courses_Bool_Exp>>;
  _not?: Maybe<Courses_Bool_Exp>;
  _or?: Maybe<Array<Courses_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  events?: Maybe<Course_Events_Bool_Exp>;
  events_aggregate?: Maybe<Course_Events_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  type?: Maybe<Course_Types_Bool_Exp>;
  type_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "courses" */
export enum Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursesPkey = 'courses_pkey'
}

/** input type for inserting data into table "courses" */
export type Courses_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  events?: Maybe<Course_Events_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Course_Types_Obj_Rel_Insert_Input>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Courses_Max_Fields = {
  __typename?: 'courses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "courses" */
export type Courses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Courses_Min_Fields = {
  __typename?: 'courses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "courses" */
export type Courses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "courses" */
export type Courses_Mutation_Response = {
  __typename?: 'courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Courses>;
};

/** input type for inserting object relation for remote table "courses" */
export type Courses_Obj_Rel_Insert_Input = {
  data: Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Courses_On_Conflict>;
};

/** on_conflict condition type for table "courses" */
export type Courses_On_Conflict = {
  constraint: Courses_Constraint;
  update_columns?: Array<Courses_Update_Column>;
  where?: Maybe<Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "courses". */
export type Courses_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  events_aggregate?: Maybe<Course_Events_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  type?: Maybe<Course_Types_Order_By>;
  type_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: courses */
export type Courses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "courses" */
export enum Courses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "courses" */
export type Courses_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "courses" */
export type Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Courses_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "courses" */
export enum Courses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Courses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Courses_Set_Input>;
  where: Courses_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

export type DipendentiData = {
  dipendenti_birth_date?: Maybe<Scalars['String']>;
  dipendenti_email?: Maybe<Scalars['String']>;
  dipendenti_fiscal_code?: Maybe<Scalars['String']>;
  dipendenti_legal_representative?: Maybe<Scalars['Boolean']>;
  dipendenti_name?: Maybe<Scalars['String']>;
  dipendenti_password?: Maybe<Scalars['String']>;
  dipendenti_phone?: Maybe<Scalars['String']>;
  dipendenti_profile_picture?: Maybe<Scalars['String']>;
  dipendenti_role?: Maybe<Scalars['String']>;
  dipendenti_sex?: Maybe<Scalars['String']>;
  dipendenti_state?: Maybe<Scalars['String']>;
  dipendenti_surname?: Maybe<Scalars['String']>;
};

export type DocumentData = {
  company_id?: Maybe<Scalars['String']>;
  document_type_id?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['String']>;
  file_link?: Maybe<Scalars['String']>;
  issuer_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** columns and relationships of "document_categories" */
export type Document_Categories = {
  __typename?: 'document_categories';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description?: Maybe<Text_Contexts>;
  description_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  document_types: Array<Document_Types>;
  /** An aggregate relationship */
  document_types_aggregate: Document_Types_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "document_categories" */
export type Document_CategoriesDocument_TypesArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


/** columns and relationships of "document_categories" */
export type Document_CategoriesDocument_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};

/** aggregated selection of "document_categories" */
export type Document_Categories_Aggregate = {
  __typename?: 'document_categories_aggregate';
  aggregate?: Maybe<Document_Categories_Aggregate_Fields>;
  nodes: Array<Document_Categories>;
};

/** aggregate fields of "document_categories" */
export type Document_Categories_Aggregate_Fields = {
  __typename?: 'document_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Categories_Max_Fields>;
  min?: Maybe<Document_Categories_Min_Fields>;
};


/** aggregate fields of "document_categories" */
export type Document_Categories_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Categories_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_categories". All fields are combined with a logical 'AND'. */
export type Document_Categories_Bool_Exp = {
  _and?: Maybe<Array<Document_Categories_Bool_Exp>>;
  _not?: Maybe<Document_Categories_Bool_Exp>;
  _or?: Maybe<Array<Document_Categories_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  document_types?: Maybe<Document_Types_Bool_Exp>;
  document_types_aggregate?: Maybe<Document_Types_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_categories" */
export enum Document_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentCategoriesPkey = 'document_categories_pkey'
}

/** input type for inserting data into table "document_categories" */
export type Document_Categories_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  document_types?: Maybe<Document_Types_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Document_Categories_Max_Fields = {
  __typename?: 'document_categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Document_Categories_Min_Fields = {
  __typename?: 'document_categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "document_categories" */
export type Document_Categories_Mutation_Response = {
  __typename?: 'document_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Categories>;
};

/** input type for inserting object relation for remote table "document_categories" */
export type Document_Categories_Obj_Rel_Insert_Input = {
  data: Document_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_Categories_On_Conflict>;
};

/** on_conflict condition type for table "document_categories" */
export type Document_Categories_On_Conflict = {
  constraint: Document_Categories_Constraint;
  update_columns?: Array<Document_Categories_Update_Column>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "document_categories". */
export type Document_Categories_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  document_types_aggregate?: Maybe<Document_Types_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: document_categories */
export type Document_Categories_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_categories" */
export enum Document_Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "document_categories" */
export type Document_Categories_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "document_categories" */
export type Document_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Categories_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "document_categories" */
export enum Document_Categories_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  NameId = 'name_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Document_Categories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Categories_Set_Input>;
  where: Document_Categories_Bool_Exp;
};

/** columns and relationships of "document_states" */
export type Document_States = {
  __typename?: 'document_states';
  description: Scalars['String'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  state: Scalars['String'];
};


/** columns and relationships of "document_states" */
export type Document_StatesDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "document_states" */
export type Document_StatesDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** aggregated selection of "document_states" */
export type Document_States_Aggregate = {
  __typename?: 'document_states_aggregate';
  aggregate?: Maybe<Document_States_Aggregate_Fields>;
  nodes: Array<Document_States>;
};

/** aggregate fields of "document_states" */
export type Document_States_Aggregate_Fields = {
  __typename?: 'document_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_States_Max_Fields>;
  min?: Maybe<Document_States_Min_Fields>;
};


/** aggregate fields of "document_states" */
export type Document_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "document_states". All fields are combined with a logical 'AND'. */
export type Document_States_Bool_Exp = {
  _and?: Maybe<Array<Document_States_Bool_Exp>>;
  _not?: Maybe<Document_States_Bool_Exp>;
  _or?: Maybe<Array<Document_States_Bool_Exp>>;
  description?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  state?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_states" */
export enum Document_States_Constraint {
  /** unique or primary key constraint on columns "state" */
  DocumentStatesPkey = 'document_states_pkey'
}

/** input type for inserting data into table "document_states" */
export type Document_States_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_States_Max_Fields = {
  __typename?: 'document_states_max_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_States_Min_Fields = {
  __typename?: 'document_states_min_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_states" */
export type Document_States_Mutation_Response = {
  __typename?: 'document_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_States>;
};

/** input type for inserting object relation for remote table "document_states" */
export type Document_States_Obj_Rel_Insert_Input = {
  data: Document_States_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_States_On_Conflict>;
};

/** on_conflict condition type for table "document_states" */
export type Document_States_On_Conflict = {
  constraint: Document_States_Constraint;
  update_columns?: Array<Document_States_Update_Column>;
  where?: Maybe<Document_States_Bool_Exp>;
};

/** Ordering options when selecting data from "document_states". */
export type Document_States_Order_By = {
  description?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  state?: Maybe<Order_By>;
};

/** primary key columns input for table: document_states */
export type Document_States_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "document_states" */
export enum Document_States_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "document_states" */
export type Document_States_Set_Input = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "document_states" */
export type Document_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_States_Stream_Cursor_Value_Input = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "document_states" */
export enum Document_States_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

export type Document_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_States_Set_Input>;
  where: Document_States_Bool_Exp;
};

/** columns and relationships of "document_types" */
export type Document_Types = {
  __typename?: 'document_types';
  category_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  description?: Maybe<Text_Contexts>;
  description_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  document_category: Document_Categories;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  id: Scalars['uuid'];
  mandatory?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  name?: Maybe<Text_Contexts>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  aggiornamento?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "document_types" */
export type Document_TypesDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "document_types" */
export type Document_TypesDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** aggregated selection of "document_types" */
export type Document_Types_Aggregate = {
  __typename?: 'document_types_aggregate';
  aggregate?: Maybe<Document_Types_Aggregate_Fields>;
  nodes: Array<Document_Types>;
};

export type Document_Types_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Document_Types_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Document_Types_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Document_Types_Aggregate_Bool_Exp_Count>;
};

export type Document_Types_Aggregate_Bool_Exp_Bool_And = {
  arguments: Document_Types_Select_Column_Document_Types_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Types_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Types_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Document_Types_Select_Column_Document_Types_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Types_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Types_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document_types" */
export type Document_Types_Aggregate_Fields = {
  __typename?: 'document_types_aggregate_fields';
  avg?: Maybe<Document_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Types_Max_Fields>;
  min?: Maybe<Document_Types_Min_Fields>;
  stddev?: Maybe<Document_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Types_Sum_Fields>;
  var_pop?: Maybe<Document_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Types_Var_Samp_Fields>;
  variance?: Maybe<Document_Types_Variance_Fields>;
};


/** aggregate fields of "document_types" */
export type Document_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_types" */
export type Document_Types_Aggregate_Order_By = {
  avg?: Maybe<Document_Types_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Document_Types_Max_Order_By>;
  min?: Maybe<Document_Types_Min_Order_By>;
  stddev?: Maybe<Document_Types_Stddev_Order_By>;
  stddev_pop?: Maybe<Document_Types_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Document_Types_Stddev_Samp_Order_By>;
  sum?: Maybe<Document_Types_Sum_Order_By>;
  var_pop?: Maybe<Document_Types_Var_Pop_Order_By>;
  var_samp?: Maybe<Document_Types_Var_Samp_Order_By>;
  variance?: Maybe<Document_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_types" */
export type Document_Types_Arr_Rel_Insert_Input = {
  data: Array<Document_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Types_Avg_Fields = {
  __typename?: 'document_types_avg_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_types" */
export type Document_Types_Avg_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_types". All fields are combined with a logical 'AND'. */
export type Document_Types_Bool_Exp = {
  _and?: Maybe<Array<Document_Types_Bool_Exp>>;
  _not?: Maybe<Document_Types_Bool_Exp>;
  _or?: Maybe<Array<Document_Types_Bool_Exp>>;
  category_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<Text_Contexts_Bool_Exp>;
  description_id?: Maybe<Uuid_Comparison_Exp>;
  document_category?: Maybe<Document_Categories_Bool_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  mandatory?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<Text_Contexts_Bool_Exp>;
  name_id?: Maybe<Uuid_Comparison_Exp>;
  notify_frequency?: Maybe<Int_Comparison_Exp>;
  start_notif_brefore_expire?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_types" */
export enum Document_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentTypesPkey = 'document_types_pkey'
}

/** input type for incrementing numeric columns in table "document_types" */
export type Document_Types_Inc_Input = {
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_types" */
export type Document_Types_Insert_Input = {
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  description_id?: Maybe<Scalars['uuid']>;
  document_category?: Maybe<Document_Categories_Obj_Rel_Insert_Input>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Text_Contexts_Obj_Rel_Insert_Input>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  aggiornamento?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Document_Types_Max_Fields = {
  __typename?: 'document_types_max_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "document_types" */
export type Document_Types_Max_Order_By = {
  category_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Types_Min_Fields = {
  __typename?: 'document_types_min_fields';
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "document_types" */
export type Document_Types_Min_Order_By = {
  category_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name_id?: Maybe<Order_By>;
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "document_types" */
export type Document_Types_Mutation_Response = {
  __typename?: 'document_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Types>;
};

/** input type for inserting object relation for remote table "document_types" */
export type Document_Types_Obj_Rel_Insert_Input = {
  data: Document_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_Types_On_Conflict>;
};

/** on_conflict condition type for table "document_types" */
export type Document_Types_On_Conflict = {
  constraint: Document_Types_Constraint;
  update_columns?: Array<Document_Types_Update_Column>;
  where?: Maybe<Document_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "document_types". */
export type Document_Types_Order_By = {
  category_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Text_Contexts_Order_By>;
  description_id?: Maybe<Order_By>;
  document_category?: Maybe<Document_Categories_Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  mandatory?: Maybe<Order_By>;
  name?: Maybe<Text_Contexts_Order_By>;
  name_id?: Maybe<Order_By>;
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: document_types */
export type Document_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_types" */
export enum Document_Types_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  NameId = 'name_id',
  /** column name */
  NotifyFrequency = 'notify_frequency',
  /** column name */
  StartNotifBreforeExpire = 'start_notif_brefore_expire',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "document_types_aggregate_bool_exp_bool_and_arguments_columns" columns of table "document_types" */
export enum Document_Types_Select_Column_Document_Types_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** select "document_types_aggregate_bool_exp_bool_or_arguments_columns" columns of table "document_types" */
export enum Document_Types_Select_Column_Document_Types_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Mandatory = 'mandatory'
}

/** input type for updating data in table "document_types" */
export type Document_Types_Set_Input = {
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  aggiornamento?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Document_Types_Stddev_Fields = {
  __typename?: 'document_types_stddev_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_types" */
export type Document_Types_Stddev_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Types_Stddev_Pop_Fields = {
  __typename?: 'document_types_stddev_pop_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_types" */
export type Document_Types_Stddev_Pop_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Types_Stddev_Samp_Fields = {
  __typename?: 'document_types_stddev_samp_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_types" */
export type Document_Types_Stddev_Samp_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** Streaming cursor of the table "document_types" */
export type Document_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Types_Stream_Cursor_Value_Input = {
  category_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name_id?: Maybe<Scalars['uuid']>;
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Document_Types_Sum_Fields = {
  __typename?: 'document_types_sum_fields';
  notify_frequency?: Maybe<Scalars['Int']>;
  start_notif_brefore_expire?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document_types" */
export type Document_Types_Sum_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** update columns of table "document_types" */
export enum Document_Types_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionId = 'description_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  NameId = 'name_id',
  /** column name */
  NotifyFrequency = 'notify_frequency',
  /** column name */
  StartNotifBreforeExpire = 'start_notif_brefore_expire',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Document_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Document_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Types_Set_Input>;
  where: Document_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Types_Var_Pop_Fields = {
  __typename?: 'document_types_var_pop_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_types" */
export type Document_Types_Var_Pop_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Types_Var_Samp_Fields = {
  __typename?: 'document_types_var_samp_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_types" */
export type Document_Types_Var_Samp_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Types_Variance_Fields = {
  __typename?: 'document_types_variance_fields';
  notify_frequency?: Maybe<Scalars['Float']>;
  start_notif_brefore_expire?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_types" */
export type Document_Types_Variance_Order_By = {
  notify_frequency?: Maybe<Order_By>;
  start_notif_brefore_expire?: Maybe<Order_By>;
};

/** columns and relationships of "documents" */
export type Documents = {
  __typename?: 'documents';
  /** An object relationship */
  company: Companies;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  document_state: Document_States;
  /** An object relationship */
  document_type: Document_Types;
  document_type_id: Scalars['uuid'];
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  issuer_company?: Maybe<Companies>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
  visible_to_company: Scalars['Boolean'];
  visible_to_user: Scalars['Boolean'];
};

/** aggregated selection of "documents" */
export type Documents_Aggregate = {
  __typename?: 'documents_aggregate';
  aggregate?: Maybe<Documents_Aggregate_Fields>;
  nodes: Array<Documents>;
};

export type Documents_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Documents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Documents_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Documents_Aggregate_Bool_Exp_Count>;
};

export type Documents_Aggregate_Bool_Exp_Bool_And = {
  arguments: Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Documents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Documents_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Documents_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "documents" */
export type Documents_Aggregate_Fields = {
  __typename?: 'documents_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Documents_Max_Fields>;
  min?: Maybe<Documents_Min_Fields>;
};


/** aggregate fields of "documents" */
export type Documents_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Documents_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "documents" */
export type Documents_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Documents_Max_Order_By>;
  min?: Maybe<Documents_Min_Order_By>;
};

/** input type for inserting array relation for remote table "documents" */
export type Documents_Arr_Rel_Insert_Input = {
  data: Array<Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Documents_On_Conflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type Documents_Bool_Exp = {
  _and?: Maybe<Array<Documents_Bool_Exp>>;
  _not?: Maybe<Documents_Bool_Exp>;
  _or?: Maybe<Array<Documents_Bool_Exp>>;
  company?: Maybe<Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document_state?: Maybe<Document_States_Bool_Exp>;
  document_type?: Maybe<Document_Types_Bool_Exp>;
  document_type_id?: Maybe<Uuid_Comparison_Exp>;
  expires_at?: Maybe<Date_Comparison_Exp>;
  file_link?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  issuer_company?: Maybe<Companies_Bool_Exp>;
  issuer_id?: Maybe<Uuid_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  visible_to_company?: Maybe<Boolean_Comparison_Exp>;
  visible_to_user?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey'
}

/** input type for inserting data into table "documents" */
export type Documents_Insert_Input = {
  company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_state?: Maybe<Document_States_Obj_Rel_Insert_Input>;
  document_type?: Maybe<Document_Types_Obj_Rel_Insert_Input>;
  document_type_id?: Maybe<Scalars['uuid']>;
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  visible_to_company?: Maybe<Scalars['Boolean']>;
  visible_to_user?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Documents_Max_Fields = {
  __typename?: 'documents_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_type_id?: Maybe<Scalars['uuid']>;
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "documents" */
export type Documents_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_type_id?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  file_link?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issuer_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Documents_Min_Fields = {
  __typename?: 'documents_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_type_id?: Maybe<Scalars['uuid']>;
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "documents" */
export type Documents_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_type_id?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  file_link?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issuer_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "documents" */
export type Documents_Mutation_Response = {
  __typename?: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** input type for inserting object relation for remote table "documents" */
export type Documents_Obj_Rel_Insert_Input = {
  data: Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Documents_On_Conflict>;
};

/** on_conflict condition type for table "documents" */
export type Documents_On_Conflict = {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: Maybe<Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "documents". */
export type Documents_Order_By = {
  company?: Maybe<Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_state?: Maybe<Document_States_Order_By>;
  document_type?: Maybe<Document_Types_Order_By>;
  document_type_id?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  file_link?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  issuer_company?: Maybe<Companies_Order_By>;
  issuer_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  visible_to_company?: Maybe<Order_By>;
  visible_to_user?: Maybe<Order_By>;
};

/** primary key columns input for table: documents */
export type Documents_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FileLink = 'file_link',
  /** column name */
  Id = 'id',
  /** column name */
  IssuerId = 'issuer_id',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisibleToCompany = 'visible_to_company',
  /** column name */
  VisibleToUser = 'visible_to_user'
}

/** select "documents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "documents" */
export enum Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  VisibleToCompany = 'visible_to_company',
  /** column name */
  VisibleToUser = 'visible_to_user'
}

/** select "documents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "documents" */
export enum Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  VisibleToCompany = 'visible_to_company',
  /** column name */
  VisibleToUser = 'visible_to_user'
}

/** input type for updating data in table "documents" */
export type Documents_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_type_id?: Maybe<Scalars['uuid']>;
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  visible_to_company?: Maybe<Scalars['Boolean']>;
  visible_to_user?: Maybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "documents" */
export type Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Documents_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_type_id?: Maybe<Scalars['uuid']>;
  expires_at?: Maybe<Scalars['date']>;
  file_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  issuer_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  visible_to_company?: Maybe<Scalars['Boolean']>;
  visible_to_user?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  FileLink = 'file_link',
  /** column name */
  Id = 'id',
  /** column name */
  IssuerId = 'issuer_id',
  /** column name */
  State = 'state',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisibleToCompany = 'visible_to_company',
  /** column name */
  VisibleToUser = 'visible_to_user'
}

export type Documents_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};

/** columns and relationships of "event_users" */
export type Event_Users = {
  __typename?: 'event_users';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  event: Course_Events;
  event_id: Scalars['uuid'];
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "event_users" */
export type Event_Users_Aggregate = {
  __typename?: 'event_users_aggregate';
  aggregate?: Maybe<Event_Users_Aggregate_Fields>;
  nodes: Array<Event_Users>;
};

export type Event_Users_Aggregate_Bool_Exp = {
  count?: Maybe<Event_Users_Aggregate_Bool_Exp_Count>;
};

export type Event_Users_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Event_Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Event_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "event_users" */
export type Event_Users_Aggregate_Fields = {
  __typename?: 'event_users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Users_Max_Fields>;
  min?: Maybe<Event_Users_Min_Fields>;
};


/** aggregate fields of "event_users" */
export type Event_Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Event_Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_users" */
export type Event_Users_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Event_Users_Max_Order_By>;
  min?: Maybe<Event_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "event_users" */
export type Event_Users_Arr_Rel_Insert_Input = {
  data: Array<Event_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Event_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export type Event_Users_Bool_Exp = {
  _and?: Maybe<Array<Event_Users_Bool_Exp>>;
  _not?: Maybe<Event_Users_Bool_Exp>;
  _or?: Maybe<Array<Event_Users_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  event?: Maybe<Course_Events_Bool_Exp>;
  event_id?: Maybe<Uuid_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_users" */
export enum Event_Users_Constraint {
  /** unique or primary key constraint on columns "event_id", "user_id" */
  EventUsersPkey = 'event_users_pkey'
}

/** input type for inserting data into table "event_users" */
export type Event_Users_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Course_Events_Obj_Rel_Insert_Input>;
  event_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Users_Max_Fields = {
  __typename?: 'event_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_users" */
export type Event_Users_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  event_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Event_Users_Min_Fields = {
  __typename?: 'event_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_users" */
export type Event_Users_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  event_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "event_users" */
export type Event_Users_Mutation_Response = {
  __typename?: 'event_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Users>;
};

/** on_conflict condition type for table "event_users" */
export type Event_Users_On_Conflict = {
  constraint: Event_Users_Constraint;
  update_columns?: Array<Event_Users_Update_Column>;
  where?: Maybe<Event_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "event_users". */
export type Event_Users_Order_By = {
  created_at?: Maybe<Order_By>;
  event?: Maybe<Course_Events_Order_By>;
  event_id?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: event_users */
export type Event_Users_Pk_Columns_Input = {
  event_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "event_users" */
export enum Event_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "event_users" */
export type Event_Users_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "event_users_states" */
export type Event_Users_States = {
  __typename?: 'event_users_states';
  comment: Scalars['String'];
  state: Scalars['String'];
};

/** aggregated selection of "event_users_states" */
export type Event_Users_States_Aggregate = {
  __typename?: 'event_users_states_aggregate';
  aggregate?: Maybe<Event_Users_States_Aggregate_Fields>;
  nodes: Array<Event_Users_States>;
};

/** aggregate fields of "event_users_states" */
export type Event_Users_States_Aggregate_Fields = {
  __typename?: 'event_users_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Users_States_Max_Fields>;
  min?: Maybe<Event_Users_States_Min_Fields>;
};


/** aggregate fields of "event_users_states" */
export type Event_Users_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Event_Users_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_users_states". All fields are combined with a logical 'AND'. */
export type Event_Users_States_Bool_Exp = {
  _and?: Maybe<Array<Event_Users_States_Bool_Exp>>;
  _not?: Maybe<Event_Users_States_Bool_Exp>;
  _or?: Maybe<Array<Event_Users_States_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_users_states" */
export enum Event_Users_States_Constraint {
  /** unique or primary key constraint on columns "state" */
  EventUsersStatesPkey = 'event_users_states_pkey'
}

/** input type for inserting data into table "event_users_states" */
export type Event_Users_States_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Event_Users_States_Max_Fields = {
  __typename?: 'event_users_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Event_Users_States_Min_Fields = {
  __typename?: 'event_users_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_users_states" */
export type Event_Users_States_Mutation_Response = {
  __typename?: 'event_users_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_Users_States>;
};

/** on_conflict condition type for table "event_users_states" */
export type Event_Users_States_On_Conflict = {
  constraint: Event_Users_States_Constraint;
  update_columns?: Array<Event_Users_States_Update_Column>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};

/** Ordering options when selecting data from "event_users_states". */
export type Event_Users_States_Order_By = {
  comment?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
};

/** primary key columns input for table: event_users_states */
export type Event_Users_States_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "event_users_states" */
export enum Event_Users_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "event_users_states" */
export type Event_Users_States_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_users_states" */
export type Event_Users_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Users_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Users_States_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "event_users_states" */
export enum Event_Users_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

export type Event_Users_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Event_Users_States_Set_Input>;
  where: Event_Users_States_Bool_Exp;
};

/** Streaming cursor of the table "event_users" */
export type Event_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Users_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "event_users" */
export enum Event_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Event_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Event_Users_Set_Input>;
  where: Event_Users_Bool_Exp;
};

/** columns and relationships of "firebase_tokens" */
export type Firebase_Tokens = {
  __typename?: 'firebase_tokens';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "firebase_tokens" */
export type Firebase_Tokens_Aggregate = {
  __typename?: 'firebase_tokens_aggregate';
  aggregate?: Maybe<Firebase_Tokens_Aggregate_Fields>;
  nodes: Array<Firebase_Tokens>;
};

export type Firebase_Tokens_Aggregate_Bool_Exp = {
  count?: Maybe<Firebase_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Firebase_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Firebase_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "firebase_tokens" */
export type Firebase_Tokens_Aggregate_Fields = {
  __typename?: 'firebase_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Firebase_Tokens_Max_Fields>;
  min?: Maybe<Firebase_Tokens_Min_Fields>;
};


/** aggregate fields of "firebase_tokens" */
export type Firebase_Tokens_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "firebase_tokens" */
export type Firebase_Tokens_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Firebase_Tokens_Max_Order_By>;
  min?: Maybe<Firebase_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "firebase_tokens" */
export type Firebase_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Firebase_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Firebase_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "firebase_tokens". All fields are combined with a logical 'AND'. */
export type Firebase_Tokens_Bool_Exp = {
  _and?: Maybe<Array<Firebase_Tokens_Bool_Exp>>;
  _not?: Maybe<Firebase_Tokens_Bool_Exp>;
  _or?: Maybe<Array<Firebase_Tokens_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  token?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "firebase_tokens" */
export enum Firebase_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  FirebaseTokensPkey = 'firebase_tokens_pkey'
}

/** input type for inserting data into table "firebase_tokens" */
export type Firebase_Tokens_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Firebase_Tokens_Max_Fields = {
  __typename?: 'firebase_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "firebase_tokens" */
export type Firebase_Tokens_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Firebase_Tokens_Min_Fields = {
  __typename?: 'firebase_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "firebase_tokens" */
export type Firebase_Tokens_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "firebase_tokens" */
export type Firebase_Tokens_Mutation_Response = {
  __typename?: 'firebase_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Firebase_Tokens>;
};

/** on_conflict condition type for table "firebase_tokens" */
export type Firebase_Tokens_On_Conflict = {
  constraint: Firebase_Tokens_Constraint;
  update_columns?: Array<Firebase_Tokens_Update_Column>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "firebase_tokens". */
export type Firebase_Tokens_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: firebase_tokens */
export type Firebase_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "firebase_tokens" */
export enum Firebase_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "firebase_tokens" */
export type Firebase_Tokens_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "firebase_tokens" */
export type Firebase_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firebase_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firebase_Tokens_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "firebase_tokens" */
export enum Firebase_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Firebase_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Firebase_Tokens_Set_Input>;
  where: Firebase_Tokens_Bool_Exp;
};

/** columns and relationships of "geometry_columns" */
export type Geometry_Columns = {
  __typename?: 'geometry_columns';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "geometry_columns" */
export type Geometry_Columns_Aggregate = {
  __typename?: 'geometry_columns_aggregate';
  aggregate?: Maybe<Geometry_Columns_Aggregate_Fields>;
  nodes: Array<Geometry_Columns>;
};

/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_Fields = {
  __typename?: 'geometry_columns_aggregate_fields';
  avg?: Maybe<Geometry_Columns_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Geometry_Columns_Max_Fields>;
  min?: Maybe<Geometry_Columns_Min_Fields>;
  stddev?: Maybe<Geometry_Columns_Stddev_Fields>;
  stddev_pop?: Maybe<Geometry_Columns_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Geometry_Columns_Stddev_Samp_Fields>;
  sum?: Maybe<Geometry_Columns_Sum_Fields>;
  var_pop?: Maybe<Geometry_Columns_Var_Pop_Fields>;
  var_samp?: Maybe<Geometry_Columns_Var_Samp_Fields>;
  variance?: Maybe<Geometry_Columns_Variance_Fields>;
};


/** aggregate fields of "geometry_columns" */
export type Geometry_Columns_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Geometry_Columns_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Geometry_Columns_Avg_Fields = {
  __typename?: 'geometry_columns_avg_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "geometry_columns". All fields are combined with a logical 'AND'. */
export type Geometry_Columns_Bool_Exp = {
  _and?: Maybe<Array<Geometry_Columns_Bool_Exp>>;
  _not?: Maybe<Geometry_Columns_Bool_Exp>;
  _or?: Maybe<Array<Geometry_Columns_Bool_Exp>>;
  coord_dimension?: Maybe<Int_Comparison_Exp>;
  f_geometry_column?: Maybe<Name_Comparison_Exp>;
  f_table_catalog?: Maybe<String_Comparison_Exp>;
  f_table_name?: Maybe<Name_Comparison_Exp>;
  f_table_schema?: Maybe<Name_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "geometry_columns" */
export type Geometry_Columns_Inc_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "geometry_columns" */
export type Geometry_Columns_Insert_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Geometry_Columns_Max_Fields = {
  __typename?: 'geometry_columns_max_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Geometry_Columns_Min_Fields = {
  __typename?: 'geometry_columns_min_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "geometry_columns" */
export type Geometry_Columns_Mutation_Response = {
  __typename?: 'geometry_columns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Geometry_Columns>;
};

/** Ordering options when selecting data from "geometry_columns". */
export type Geometry_Columns_Order_By = {
  coord_dimension?: Maybe<Order_By>;
  f_geometry_column?: Maybe<Order_By>;
  f_table_catalog?: Maybe<Order_By>;
  f_table_name?: Maybe<Order_By>;
  f_table_schema?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
};

/** select columns of table "geometry_columns" */
export enum Geometry_Columns_Select_Column {
  /** column name */
  CoordDimension = 'coord_dimension',
  /** column name */
  FGeometryColumn = 'f_geometry_column',
  /** column name */
  FTableCatalog = 'f_table_catalog',
  /** column name */
  FTableName = 'f_table_name',
  /** column name */
  FTableSchema = 'f_table_schema',
  /** column name */
  Srid = 'srid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "geometry_columns" */
export type Geometry_Columns_Set_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Geometry_Columns_Stddev_Fields = {
  __typename?: 'geometry_columns_stddev_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Geometry_Columns_Stddev_Pop_Fields = {
  __typename?: 'geometry_columns_stddev_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Geometry_Columns_Stddev_Samp_Fields = {
  __typename?: 'geometry_columns_stddev_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "geometry_columns" */
export type Geometry_Columns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geometry_Columns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geometry_Columns_Stream_Cursor_Value_Input = {
  coord_dimension?: Maybe<Scalars['Int']>;
  f_geometry_column?: Maybe<Scalars['name']>;
  f_table_catalog?: Maybe<Scalars['String']>;
  f_table_name?: Maybe<Scalars['name']>;
  f_table_schema?: Maybe<Scalars['name']>;
  srid?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Geometry_Columns_Sum_Fields = {
  __typename?: 'geometry_columns_sum_fields';
  coord_dimension?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

export type Geometry_Columns_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Geometry_Columns_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Geometry_Columns_Set_Input>;
  where: Geometry_Columns_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Geometry_Columns_Var_Pop_Fields = {
  __typename?: 'geometry_columns_var_pop_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Geometry_Columns_Var_Samp_Fields = {
  __typename?: 'geometry_columns_var_samp_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Geometry_Columns_Variance_Fields = {
  __typename?: 'geometry_columns_variance_fields';
  coord_dimension?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};


/** columns and relationships of "languages" */
export type Languages = {
  __typename?: 'languages';
  comment?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  text_contexts: Array<Text_Contexts>;
  /** An aggregate relationship */
  text_contexts_aggregate: Text_Contexts_Aggregate;
};


/** columns and relationships of "languages" */
export type LanguagesText_ContextsArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


/** columns and relationships of "languages" */
export type LanguagesText_Contexts_AggregateArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};

/** aggregated selection of "languages" */
export type Languages_Aggregate = {
  __typename?: 'languages_aggregate';
  aggregate?: Maybe<Languages_Aggregate_Fields>;
  nodes: Array<Languages>;
};

/** aggregate fields of "languages" */
export type Languages_Aggregate_Fields = {
  __typename?: 'languages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Languages_Max_Fields>;
  min?: Maybe<Languages_Min_Fields>;
};


/** aggregate fields of "languages" */
export type Languages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Languages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "languages". All fields are combined with a logical 'AND'. */
export type Languages_Bool_Exp = {
  _and?: Maybe<Array<Languages_Bool_Exp>>;
  _not?: Maybe<Languages_Bool_Exp>;
  _or?: Maybe<Array<Languages_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  text_contexts?: Maybe<Text_Contexts_Bool_Exp>;
  text_contexts_aggregate?: Maybe<Text_Contexts_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "languages" */
export enum Languages_Constraint {
  /** unique or primary key constraint on columns "name" */
  LanguagesPkey = 'languages_pkey'
}

export enum Languages_Enum {
  /** English */
  En = 'en',
  /** Italian */
  It = 'it'
}

/** Boolean expression to compare columns of type "languages_enum". All fields are combined with logical 'AND'. */
export type Languages_Enum_Comparison_Exp = {
  _eq?: Maybe<Languages_Enum>;
  _in?: Maybe<Array<Languages_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Languages_Enum>;
  _nin?: Maybe<Array<Languages_Enum>>;
};

/** input type for inserting data into table "languages" */
export type Languages_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  text_contexts?: Maybe<Text_Contexts_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Languages_Max_Fields = {
  __typename?: 'languages_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Languages_Min_Fields = {
  __typename?: 'languages_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "languages" */
export type Languages_Mutation_Response = {
  __typename?: 'languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Languages>;
};

/** on_conflict condition type for table "languages" */
export type Languages_On_Conflict = {
  constraint: Languages_Constraint;
  update_columns?: Array<Languages_Update_Column>;
  where?: Maybe<Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "languages". */
export type Languages_Order_By = {
  comment?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  text_contexts_aggregate?: Maybe<Text_Contexts_Aggregate_Order_By>;
};

/** primary key columns input for table: languages */
export type Languages_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "languages" */
export enum Languages_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "languages" */
export type Languages_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "languages" */
export type Languages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Languages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Languages_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "languages" */
export enum Languages_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Languages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  changePassword?: Maybe<ChangePasswordOutput>;
  /** delete data from the table: "addresses" */
  delete_addresses?: Maybe<Addresses_Mutation_Response>;
  /** delete single row from the table: "addresses" */
  delete_addresses_by_pk?: Maybe<Addresses>;
  /** delete data from the table: "companies" */
  delete_companies?: Maybe<Companies_Mutation_Response>;
  /** delete single row from the table: "companies" */
  delete_companies_by_pk?: Maybe<Companies>;
  /** delete data from the table: "company_categories" */
  delete_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** delete single row from the table: "company_categories" */
  delete_company_categories_by_pk?: Maybe<Company_Categories>;
  /** delete data from the table: "company_roles" */
  delete_company_roles?: Maybe<Company_Roles_Mutation_Response>;
  /** delete single row from the table: "company_roles" */
  delete_company_roles_by_pk?: Maybe<Company_Roles>;
  /** delete data from the table: "company_sector" */
  delete_company_sector?: Maybe<Company_Sector_Mutation_Response>;
  /** delete single row from the table: "company_sector" */
  delete_company_sector_by_pk?: Maybe<Company_Sector>;
  /** delete data from the table: "company_states" */
  delete_company_states?: Maybe<Company_States_Mutation_Response>;
  /** delete single row from the table: "company_states" */
  delete_company_states_by_pk?: Maybe<Company_States>;
  /** delete data from the table: "course_categories" */
  delete_course_categories?: Maybe<Course_Categories_Mutation_Response>;
  /** delete single row from the table: "course_categories" */
  delete_course_categories_by_pk?: Maybe<Course_Categories>;
  /** delete data from the table: "course_event_state" */
  delete_course_event_state?: Maybe<Course_Event_State_Mutation_Response>;
  /** delete single row from the table: "course_event_state" */
  delete_course_event_state_by_pk?: Maybe<Course_Event_State>;
  /** delete data from the table: "course_events" */
  delete_course_events?: Maybe<Course_Events_Mutation_Response>;
  /** delete single row from the table: "course_events" */
  delete_course_events_by_pk?: Maybe<Course_Events>;
  /** delete data from the table: "course_types" */
  delete_course_types?: Maybe<Course_Types_Mutation_Response>;
  /** delete single row from the table: "course_types" */
  delete_course_types_by_pk?: Maybe<Course_Types>;
  /** delete data from the table: "courses" */
  delete_courses?: Maybe<Courses_Mutation_Response>;
  /** delete single row from the table: "courses" */
  delete_courses_by_pk?: Maybe<Courses>;
  /** delete data from the table: "document_categories" */
  delete_document_categories?: Maybe<Document_Categories_Mutation_Response>;
  /** delete single row from the table: "document_categories" */
  delete_document_categories_by_pk?: Maybe<Document_Categories>;
  /** delete data from the table: "document_states" */
  delete_document_states?: Maybe<Document_States_Mutation_Response>;
  /** delete single row from the table: "document_states" */
  delete_document_states_by_pk?: Maybe<Document_States>;
  /** delete data from the table: "document_types" */
  delete_document_types?: Maybe<Document_Types_Mutation_Response>;
  /** delete single row from the table: "document_types" */
  delete_document_types_by_pk?: Maybe<Document_Types>;
  /** delete data from the table: "documents" */
  delete_documents?: Maybe<Documents_Mutation_Response>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk?: Maybe<Documents>;
  /** delete data from the table: "event_users" */
  delete_event_users?: Maybe<Event_Users_Mutation_Response>;
  /** delete single row from the table: "event_users" */
  delete_event_users_by_pk?: Maybe<Event_Users>;
  /** delete data from the table: "event_users_states" */
  delete_event_users_states?: Maybe<Event_Users_States_Mutation_Response>;
  /** delete single row from the table: "event_users_states" */
  delete_event_users_states_by_pk?: Maybe<Event_Users_States>;
  /** delete data from the table: "firebase_tokens" */
  delete_firebase_tokens?: Maybe<Firebase_Tokens_Mutation_Response>;
  /** delete single row from the table: "firebase_tokens" */
  delete_firebase_tokens_by_pk?: Maybe<Firebase_Tokens>;
  /** delete data from the table: "geometry_columns" */
  delete_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** delete data from the table: "languages" */
  delete_languages?: Maybe<Languages_Mutation_Response>;
  /** delete single row from the table: "languages" */
  delete_languages_by_pk?: Maybe<Languages>;
  /** delete data from the table: "notification" */
  delete_notification?: Maybe<Notification_Mutation_Response>;
  /** delete single row from the table: "notification" */
  delete_notification_by_pk?: Maybe<Notification>;
  /** delete data from the table: "refresh_tokens" */
  delete_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** delete single row from the table: "refresh_tokens" */
  delete_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** delete data from the table: "text_contexts" */
  delete_text_contexts?: Maybe<Text_Contexts_Mutation_Response>;
  /** delete single row from the table: "text_contexts" */
  delete_text_contexts_by_pk?: Maybe<Text_Contexts>;
  /** delete data from the table: "token_types" */
  delete_token_types?: Maybe<Token_Types_Mutation_Response>;
  /** delete single row from the table: "token_types" */
  delete_token_types_by_pk?: Maybe<Token_Types>;
  /** delete data from the table: "translations" */
  delete_translations?: Maybe<Translations_Mutation_Response>;
  /** delete single row from the table: "translations" */
  delete_translations_by_pk?: Maybe<Translations>;
  /** delete data from the table: "user_companies" */
  delete_user_companies?: Maybe<User_Companies_Mutation_Response>;
  /** delete single row from the table: "user_companies" */
  delete_user_companies_by_pk?: Maybe<User_Companies>;
  /** delete data from the table: "user_company_roles" */
  delete_user_company_roles?: Maybe<User_Company_Roles_Mutation_Response>;
  /** delete single row from the table: "user_company_roles" */
  delete_user_company_roles_by_pk?: Maybe<User_Company_Roles>;
  /** delete data from the table: "user_company_states" */
  delete_user_company_states?: Maybe<User_Company_States_Mutation_Response>;
  /** delete single row from the table: "user_company_states" */
  delete_user_company_states_by_pk?: Maybe<User_Company_States>;
  /** delete data from the table: "user_states" */
  delete_user_states?: Maybe<User_States_Mutation_Response>;
  /** delete single row from the table: "user_states" */
  delete_user_states_by_pk?: Maybe<User_States>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "validation_tokens" */
  delete_validation_tokens?: Maybe<Validation_Tokens_Mutation_Response>;
  /** delete single row from the table: "validation_tokens" */
  delete_validation_tokens_by_pk?: Maybe<Validation_Tokens>;
  /** insert data into the table: "addresses" */
  insert_addresses?: Maybe<Addresses_Mutation_Response>;
  /** insert a single row into the table: "addresses" */
  insert_addresses_one?: Maybe<Addresses>;
  /** insert data into the table: "companies" */
  insert_companies?: Maybe<Companies_Mutation_Response>;
  /** insert a single row into the table: "companies" */
  insert_companies_one?: Maybe<Companies>;
  /** insert data into the table: "company_categories" */
  insert_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** insert a single row into the table: "company_categories" */
  insert_company_categories_one?: Maybe<Company_Categories>;
  /** insert data into the table: "company_roles" */
  insert_company_roles?: Maybe<Company_Roles_Mutation_Response>;
  /** insert a single row into the table: "company_roles" */
  insert_company_roles_one?: Maybe<Company_Roles>;
  /** insert data into the table: "company_sector" */
  insert_company_sector?: Maybe<Company_Sector_Mutation_Response>;
  /** insert a single row into the table: "company_sector" */
  insert_company_sector_one?: Maybe<Company_Sector>;
  /** insert data into the table: "company_states" */
  insert_company_states?: Maybe<Company_States_Mutation_Response>;
  /** insert a single row into the table: "company_states" */
  insert_company_states_one?: Maybe<Company_States>;
  /** insert data into the table: "course_categories" */
  insert_course_categories?: Maybe<Course_Categories_Mutation_Response>;
  /** insert a single row into the table: "course_categories" */
  insert_course_categories_one?: Maybe<Course_Categories>;
  /** insert data into the table: "course_event_state" */
  insert_course_event_state?: Maybe<Course_Event_State_Mutation_Response>;
  /** insert a single row into the table: "course_event_state" */
  insert_course_event_state_one?: Maybe<Course_Event_State>;
  /** insert data into the table: "course_events" */
  insert_course_events?: Maybe<Course_Events_Mutation_Response>;
  /** insert a single row into the table: "course_events" */
  insert_course_events_one?: Maybe<Course_Events>;
  /** insert data into the table: "course_types" */
  insert_course_types?: Maybe<Course_Types_Mutation_Response>;
  /** insert a single row into the table: "course_types" */
  insert_course_types_one?: Maybe<Course_Types>;
  /** insert data into the table: "courses" */
  insert_courses?: Maybe<Courses_Mutation_Response>;
  /** insert a single row into the table: "courses" */
  insert_courses_one?: Maybe<Courses>;
  /** insert data into the table: "document_categories" */
  insert_document_categories?: Maybe<Document_Categories_Mutation_Response>;
  /** insert a single row into the table: "document_categories" */
  insert_document_categories_one?: Maybe<Document_Categories>;
  /** insert data into the table: "document_states" */
  insert_document_states?: Maybe<Document_States_Mutation_Response>;
  /** insert a single row into the table: "document_states" */
  insert_document_states_one?: Maybe<Document_States>;
  /** insert data into the table: "document_types" */
  insert_document_types?: Maybe<Document_Types_Mutation_Response>;
  /** insert a single row into the table: "document_types" */
  insert_document_types_one?: Maybe<Document_Types>;
  /** insert data into the table: "documents" */
  insert_documents?: Maybe<Documents_Mutation_Response>;
  /** insert a single row into the table: "documents" */
  insert_documents_one?: Maybe<Documents>;
  /** insert data into the table: "event_users" */
  insert_event_users?: Maybe<Event_Users_Mutation_Response>;
  /** insert a single row into the table: "event_users" */
  insert_event_users_one?: Maybe<Event_Users>;
  /** insert data into the table: "event_users_states" */
  insert_event_users_states?: Maybe<Event_Users_States_Mutation_Response>;
  /** insert a single row into the table: "event_users_states" */
  insert_event_users_states_one?: Maybe<Event_Users_States>;
  /** insert data into the table: "firebase_tokens" */
  insert_firebase_tokens?: Maybe<Firebase_Tokens_Mutation_Response>;
  /** insert a single row into the table: "firebase_tokens" */
  insert_firebase_tokens_one?: Maybe<Firebase_Tokens>;
  /** insert data into the table: "geometry_columns" */
  insert_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** insert a single row into the table: "geometry_columns" */
  insert_geometry_columns_one?: Maybe<Geometry_Columns>;
  /** insert data into the table: "languages" */
  insert_languages?: Maybe<Languages_Mutation_Response>;
  /** insert a single row into the table: "languages" */
  insert_languages_one?: Maybe<Languages>;
  /** insert data into the table: "notification" */
  insert_notification?: Maybe<Notification_Mutation_Response>;
  /** insert a single row into the table: "notification" */
  insert_notification_one?: Maybe<Notification>;
  /** insert data into the table: "refresh_tokens" */
  insert_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** insert a single row into the table: "refresh_tokens" */
  insert_refresh_tokens_one?: Maybe<Refresh_Tokens>;
  /** insert data into the table: "text_contexts" */
  insert_text_contexts?: Maybe<Text_Contexts_Mutation_Response>;
  /** insert a single row into the table: "text_contexts" */
  insert_text_contexts_one?: Maybe<Text_Contexts>;
  /** insert data into the table: "token_types" */
  insert_token_types?: Maybe<Token_Types_Mutation_Response>;
  /** insert a single row into the table: "token_types" */
  insert_token_types_one?: Maybe<Token_Types>;
  /** insert data into the table: "translations" */
  insert_translations?: Maybe<Translations_Mutation_Response>;
  /** insert a single row into the table: "translations" */
  insert_translations_one?: Maybe<Translations>;
  /** insert data into the table: "user_companies" */
  insert_user_companies?: Maybe<User_Companies_Mutation_Response>;
  /** insert a single row into the table: "user_companies" */
  insert_user_companies_one?: Maybe<User_Companies>;
  /** insert data into the table: "user_company_roles" */
  insert_user_company_roles?: Maybe<User_Company_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_company_roles" */
  insert_user_company_roles_one?: Maybe<User_Company_Roles>;
  /** insert data into the table: "user_company_states" */
  insert_user_company_states?: Maybe<User_Company_States_Mutation_Response>;
  /** insert a single row into the table: "user_company_states" */
  insert_user_company_states_one?: Maybe<User_Company_States>;
  /** insert data into the table: "user_states" */
  insert_user_states?: Maybe<User_States_Mutation_Response>;
  /** insert a single row into the table: "user_states" */
  insert_user_states_one?: Maybe<User_States>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "validation_tokens" */
  insert_validation_tokens?: Maybe<Validation_Tokens_Mutation_Response>;
  /** insert a single row into the table: "validation_tokens" */
  insert_validation_tokens_one?: Maybe<Validation_Tokens>;
  registerBlueCompany?: Maybe<RegisterCompanyOutput>;
  registerCompany?: Maybe<RegisterCompanyOutput>;
  registerUser?: Maybe<RegisterUserOutput>;
  sendNotification?: Maybe<ChangePasswordOutput>;
  /** update data of the table: "addresses" */
  update_addresses?: Maybe<Addresses_Mutation_Response>;
  /** update single row of the table: "addresses" */
  update_addresses_by_pk?: Maybe<Addresses>;
  /** update multiples rows of table: "addresses" */
  update_addresses_many?: Maybe<Array<Maybe<Addresses_Mutation_Response>>>;
  /** update data of the table: "companies" */
  update_companies?: Maybe<Companies_Mutation_Response>;
  /** update single row of the table: "companies" */
  update_companies_by_pk?: Maybe<Companies>;
  /** update multiples rows of table: "companies" */
  update_companies_many?: Maybe<Array<Maybe<Companies_Mutation_Response>>>;
  /** update data of the table: "company_categories" */
  update_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** update single row of the table: "company_categories" */
  update_company_categories_by_pk?: Maybe<Company_Categories>;
  /** update multiples rows of table: "company_categories" */
  update_company_categories_many?: Maybe<Array<Maybe<Company_Categories_Mutation_Response>>>;
  /** update data of the table: "company_roles" */
  update_company_roles?: Maybe<Company_Roles_Mutation_Response>;
  /** update single row of the table: "company_roles" */
  update_company_roles_by_pk?: Maybe<Company_Roles>;
  /** update multiples rows of table: "company_roles" */
  update_company_roles_many?: Maybe<Array<Maybe<Company_Roles_Mutation_Response>>>;
  /** update data of the table: "company_sector" */
  update_company_sector?: Maybe<Company_Sector_Mutation_Response>;
  /** update single row of the table: "company_sector" */
  update_company_sector_by_pk?: Maybe<Company_Sector>;
  /** update multiples rows of table: "company_sector" */
  update_company_sector_many?: Maybe<Array<Maybe<Company_Sector_Mutation_Response>>>;
  /** update data of the table: "company_states" */
  update_company_states?: Maybe<Company_States_Mutation_Response>;
  /** update single row of the table: "company_states" */
  update_company_states_by_pk?: Maybe<Company_States>;
  /** update multiples rows of table: "company_states" */
  update_company_states_many?: Maybe<Array<Maybe<Company_States_Mutation_Response>>>;
  /** update data of the table: "course_categories" */
  update_course_categories?: Maybe<Course_Categories_Mutation_Response>;
  /** update single row of the table: "course_categories" */
  update_course_categories_by_pk?: Maybe<Course_Categories>;
  /** update multiples rows of table: "course_categories" */
  update_course_categories_many?: Maybe<Array<Maybe<Course_Categories_Mutation_Response>>>;
  /** update data of the table: "course_event_state" */
  update_course_event_state?: Maybe<Course_Event_State_Mutation_Response>;
  /** update single row of the table: "course_event_state" */
  update_course_event_state_by_pk?: Maybe<Course_Event_State>;
  /** update multiples rows of table: "course_event_state" */
  update_course_event_state_many?: Maybe<Array<Maybe<Course_Event_State_Mutation_Response>>>;
  /** update data of the table: "course_events" */
  update_course_events?: Maybe<Course_Events_Mutation_Response>;
  /** update single row of the table: "course_events" */
  update_course_events_by_pk?: Maybe<Course_Events>;
  /** update multiples rows of table: "course_events" */
  update_course_events_many?: Maybe<Array<Maybe<Course_Events_Mutation_Response>>>;
  /** update data of the table: "course_types" */
  update_course_types?: Maybe<Course_Types_Mutation_Response>;
  /** update single row of the table: "course_types" */
  update_course_types_by_pk?: Maybe<Course_Types>;
  /** update multiples rows of table: "course_types" */
  update_course_types_many?: Maybe<Array<Maybe<Course_Types_Mutation_Response>>>;
  /** update data of the table: "courses" */
  update_courses?: Maybe<Courses_Mutation_Response>;
  /** update single row of the table: "courses" */
  update_courses_by_pk?: Maybe<Courses>;
  /** update multiples rows of table: "courses" */
  update_courses_many?: Maybe<Array<Maybe<Courses_Mutation_Response>>>;
  /** update data of the table: "document_categories" */
  update_document_categories?: Maybe<Document_Categories_Mutation_Response>;
  /** update single row of the table: "document_categories" */
  update_document_categories_by_pk?: Maybe<Document_Categories>;
  /** update multiples rows of table: "document_categories" */
  update_document_categories_many?: Maybe<Array<Maybe<Document_Categories_Mutation_Response>>>;
  /** update data of the table: "document_states" */
  update_document_states?: Maybe<Document_States_Mutation_Response>;
  /** update single row of the table: "document_states" */
  update_document_states_by_pk?: Maybe<Document_States>;
  /** update multiples rows of table: "document_states" */
  update_document_states_many?: Maybe<Array<Maybe<Document_States_Mutation_Response>>>;
  /** update data of the table: "document_types" */
  update_document_types?: Maybe<Document_Types_Mutation_Response>;
  /** update single row of the table: "document_types" */
  update_document_types_by_pk?: Maybe<Document_Types>;
  /** update multiples rows of table: "document_types" */
  update_document_types_many?: Maybe<Array<Maybe<Document_Types_Mutation_Response>>>;
  /** update data of the table: "documents" */
  update_documents?: Maybe<Documents_Mutation_Response>;
  /** update single row of the table: "documents" */
  update_documents_by_pk?: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many?: Maybe<Array<Maybe<Documents_Mutation_Response>>>;
  /** update data of the table: "event_users" */
  update_event_users?: Maybe<Event_Users_Mutation_Response>;
  /** update single row of the table: "event_users" */
  update_event_users_by_pk?: Maybe<Event_Users>;
  /** update multiples rows of table: "event_users" */
  update_event_users_many?: Maybe<Array<Maybe<Event_Users_Mutation_Response>>>;
  /** update data of the table: "event_users_states" */
  update_event_users_states?: Maybe<Event_Users_States_Mutation_Response>;
  /** update single row of the table: "event_users_states" */
  update_event_users_states_by_pk?: Maybe<Event_Users_States>;
  /** update multiples rows of table: "event_users_states" */
  update_event_users_states_many?: Maybe<Array<Maybe<Event_Users_States_Mutation_Response>>>;
  /** update data of the table: "firebase_tokens" */
  update_firebase_tokens?: Maybe<Firebase_Tokens_Mutation_Response>;
  /** update single row of the table: "firebase_tokens" */
  update_firebase_tokens_by_pk?: Maybe<Firebase_Tokens>;
  /** update multiples rows of table: "firebase_tokens" */
  update_firebase_tokens_many?: Maybe<Array<Maybe<Firebase_Tokens_Mutation_Response>>>;
  /** update data of the table: "geometry_columns" */
  update_geometry_columns?: Maybe<Geometry_Columns_Mutation_Response>;
  /** update multiples rows of table: "geometry_columns" */
  update_geometry_columns_many?: Maybe<Array<Maybe<Geometry_Columns_Mutation_Response>>>;
  /** update data of the table: "languages" */
  update_languages?: Maybe<Languages_Mutation_Response>;
  /** update single row of the table: "languages" */
  update_languages_by_pk?: Maybe<Languages>;
  /** update multiples rows of table: "languages" */
  update_languages_many?: Maybe<Array<Maybe<Languages_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<Notification_Mutation_Response>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<Notification>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<Notification_Mutation_Response>>>;
  /** update data of the table: "refresh_tokens" */
  update_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>;
  /** update single row of the table: "refresh_tokens" */
  update_refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** update multiples rows of table: "refresh_tokens" */
  update_refresh_tokens_many?: Maybe<Array<Maybe<Refresh_Tokens_Mutation_Response>>>;
  /** update data of the table: "text_contexts" */
  update_text_contexts?: Maybe<Text_Contexts_Mutation_Response>;
  /** update single row of the table: "text_contexts" */
  update_text_contexts_by_pk?: Maybe<Text_Contexts>;
  /** update multiples rows of table: "text_contexts" */
  update_text_contexts_many?: Maybe<Array<Maybe<Text_Contexts_Mutation_Response>>>;
  /** update data of the table: "token_types" */
  update_token_types?: Maybe<Token_Types_Mutation_Response>;
  /** update single row of the table: "token_types" */
  update_token_types_by_pk?: Maybe<Token_Types>;
  /** update multiples rows of table: "token_types" */
  update_token_types_many?: Maybe<Array<Maybe<Token_Types_Mutation_Response>>>;
  /** update data of the table: "translations" */
  update_translations?: Maybe<Translations_Mutation_Response>;
  /** update single row of the table: "translations" */
  update_translations_by_pk?: Maybe<Translations>;
  /** update multiples rows of table: "translations" */
  update_translations_many?: Maybe<Array<Maybe<Translations_Mutation_Response>>>;
  /** update data of the table: "user_companies" */
  update_user_companies?: Maybe<User_Companies_Mutation_Response>;
  /** update single row of the table: "user_companies" */
  update_user_companies_by_pk?: Maybe<User_Companies>;
  /** update multiples rows of table: "user_companies" */
  update_user_companies_many?: Maybe<Array<Maybe<User_Companies_Mutation_Response>>>;
  /** update data of the table: "user_company_roles" */
  update_user_company_roles?: Maybe<User_Company_Roles_Mutation_Response>;
  /** update single row of the table: "user_company_roles" */
  update_user_company_roles_by_pk?: Maybe<User_Company_Roles>;
  /** update multiples rows of table: "user_company_roles" */
  update_user_company_roles_many?: Maybe<Array<Maybe<User_Company_Roles_Mutation_Response>>>;
  /** update data of the table: "user_company_states" */
  update_user_company_states?: Maybe<User_Company_States_Mutation_Response>;
  /** update single row of the table: "user_company_states" */
  update_user_company_states_by_pk?: Maybe<User_Company_States>;
  /** update multiples rows of table: "user_company_states" */
  update_user_company_states_many?: Maybe<Array<Maybe<User_Company_States_Mutation_Response>>>;
  /** update data of the table: "user_states" */
  update_user_states?: Maybe<User_States_Mutation_Response>;
  /** update single row of the table: "user_states" */
  update_user_states_by_pk?: Maybe<User_States>;
  /** update multiples rows of table: "user_states" */
  update_user_states_many?: Maybe<Array<Maybe<User_States_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "validation_tokens" */
  update_validation_tokens?: Maybe<Validation_Tokens_Mutation_Response>;
  /** update single row of the table: "validation_tokens" */
  update_validation_tokens_by_pk?: Maybe<Validation_Tokens>;
  /** update multiples rows of table: "validation_tokens" */
  update_validation_tokens_many?: Maybe<Array<Maybe<Validation_Tokens_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AddressesArgs = {
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CompaniesArgs = {
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Companies_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_CategoriesArgs = {
  where: Company_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_RolesArgs = {
  where: Company_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Roles_By_PkArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Company_SectorArgs = {
  where: Company_Sector_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Sector_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_StatesArgs = {
  where: Company_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_States_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_CategoriesArgs = {
  where: Course_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Event_StateArgs = {
  where: Course_Event_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Event_State_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_EventsArgs = {
  where: Course_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_TypesArgs = {
  where: Course_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CoursesArgs = {
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Courses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_CategoriesArgs = {
  where: Document_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_StatesArgs = {
  where: Document_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_States_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypesArgs = {
  where: Document_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentsArgs = {
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Documents_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_UsersArgs = {
  where: Event_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Users_By_PkArgs = {
  event_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_Users_StatesArgs = {
  where: Event_Users_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_Users_States_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Firebase_TokensArgs = {
  where: Firebase_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Firebase_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Geometry_ColumnsArgs = {
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LanguagesArgs = {
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Languages_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationArgs = {
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_By_PkArgs = {
  uuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Refresh_TokensArgs = {
  where: Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refresh_Tokens_By_PkArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Text_ContextsArgs = {
  where: Text_Contexts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Text_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Token_TypesArgs = {
  where: Token_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Token_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TranslationsArgs = {
  where: Translations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Translations_By_PkArgs = {
  language_id: Scalars['uuid'];
  text_context_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_CompaniesArgs = {
  where: User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Companies_By_PkArgs = {
  company_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Company_RolesArgs = {
  where: User_Company_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Company_Roles_By_PkArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Company_StatesArgs = {
  where: User_Company_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Company_States_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_StatesArgs = {
  where: User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_States_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Validation_TokensArgs = {
  where: Validation_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Validation_Tokens_By_PkArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AddressesArgs = {
  objects: Array<Addresses_Insert_Input>;
  on_conflict?: Maybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Addresses_OneArgs = {
  object: Addresses_Insert_Input;
  on_conflict?: Maybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompaniesArgs = {
  objects: Array<Companies_Insert_Input>;
  on_conflict?: Maybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Companies_OneArgs = {
  object: Companies_Insert_Input;
  on_conflict?: Maybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_CategoriesArgs = {
  objects: Array<Company_Categories_Insert_Input>;
  on_conflict?: Maybe<Company_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Categories_OneArgs = {
  object: Company_Categories_Insert_Input;
  on_conflict?: Maybe<Company_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_RolesArgs = {
  objects: Array<Company_Roles_Insert_Input>;
  on_conflict?: Maybe<Company_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Roles_OneArgs = {
  object: Company_Roles_Insert_Input;
  on_conflict?: Maybe<Company_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_SectorArgs = {
  objects: Array<Company_Sector_Insert_Input>;
  on_conflict?: Maybe<Company_Sector_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Sector_OneArgs = {
  object: Company_Sector_Insert_Input;
  on_conflict?: Maybe<Company_Sector_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_StatesArgs = {
  objects: Array<Company_States_Insert_Input>;
  on_conflict?: Maybe<Company_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_States_OneArgs = {
  object: Company_States_Insert_Input;
  on_conflict?: Maybe<Company_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_CategoriesArgs = {
  objects: Array<Course_Categories_Insert_Input>;
  on_conflict?: Maybe<Course_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Categories_OneArgs = {
  object: Course_Categories_Insert_Input;
  on_conflict?: Maybe<Course_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Event_StateArgs = {
  objects: Array<Course_Event_State_Insert_Input>;
  on_conflict?: Maybe<Course_Event_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Event_State_OneArgs = {
  object: Course_Event_State_Insert_Input;
  on_conflict?: Maybe<Course_Event_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_EventsArgs = {
  objects: Array<Course_Events_Insert_Input>;
  on_conflict?: Maybe<Course_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Events_OneArgs = {
  object: Course_Events_Insert_Input;
  on_conflict?: Maybe<Course_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_TypesArgs = {
  objects: Array<Course_Types_Insert_Input>;
  on_conflict?: Maybe<Course_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Types_OneArgs = {
  object: Course_Types_Insert_Input;
  on_conflict?: Maybe<Course_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CoursesArgs = {
  objects: Array<Courses_Insert_Input>;
  on_conflict?: Maybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Courses_OneArgs = {
  object: Courses_Insert_Input;
  on_conflict?: Maybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_CategoriesArgs = {
  objects: Array<Document_Categories_Insert_Input>;
  on_conflict?: Maybe<Document_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Categories_OneArgs = {
  object: Document_Categories_Insert_Input;
  on_conflict?: Maybe<Document_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_StatesArgs = {
  objects: Array<Document_States_Insert_Input>;
  on_conflict?: Maybe<Document_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_States_OneArgs = {
  object: Document_States_Insert_Input;
  on_conflict?: Maybe<Document_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypesArgs = {
  objects: Array<Document_Types_Insert_Input>;
  on_conflict?: Maybe<Document_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Types_OneArgs = {
  object: Document_Types_Insert_Input;
  on_conflict?: Maybe<Document_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentsArgs = {
  objects: Array<Documents_Insert_Input>;
  on_conflict?: Maybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Documents_OneArgs = {
  object: Documents_Insert_Input;
  on_conflict?: Maybe<Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_UsersArgs = {
  objects: Array<Event_Users_Insert_Input>;
  on_conflict?: Maybe<Event_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Users_OneArgs = {
  object: Event_Users_Insert_Input;
  on_conflict?: Maybe<Event_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Users_StatesArgs = {
  objects: Array<Event_Users_States_Insert_Input>;
  on_conflict?: Maybe<Event_Users_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Users_States_OneArgs = {
  object: Event_Users_States_Insert_Input;
  on_conflict?: Maybe<Event_Users_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Firebase_TokensArgs = {
  objects: Array<Firebase_Tokens_Insert_Input>;
  on_conflict?: Maybe<Firebase_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Firebase_Tokens_OneArgs = {
  object: Firebase_Tokens_Insert_Input;
  on_conflict?: Maybe<Firebase_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_ColumnsArgs = {
  objects: Array<Geometry_Columns_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Geometry_Columns_OneArgs = {
  object: Geometry_Columns_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_LanguagesArgs = {
  objects: Array<Languages_Insert_Input>;
  on_conflict?: Maybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Languages_OneArgs = {
  object: Languages_Insert_Input;
  on_conflict?: Maybe<Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationArgs = {
  objects: Array<Notification_Insert_Input>;
  on_conflict?: Maybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OneArgs = {
  object: Notification_Insert_Input;
  on_conflict?: Maybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_TokensArgs = {
  objects: Array<Refresh_Tokens_Insert_Input>;
  on_conflict?: Maybe<Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refresh_Tokens_OneArgs = {
  object: Refresh_Tokens_Insert_Input;
  on_conflict?: Maybe<Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_ContextsArgs = {
  objects: Array<Text_Contexts_Insert_Input>;
  on_conflict?: Maybe<Text_Contexts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_Contexts_OneArgs = {
  object: Text_Contexts_Insert_Input;
  on_conflict?: Maybe<Text_Contexts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Token_TypesArgs = {
  objects: Array<Token_Types_Insert_Input>;
  on_conflict?: Maybe<Token_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Token_Types_OneArgs = {
  object: Token_Types_Insert_Input;
  on_conflict?: Maybe<Token_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TranslationsArgs = {
  objects: Array<Translations_Insert_Input>;
  on_conflict?: Maybe<Translations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Translations_OneArgs = {
  object: Translations_Insert_Input;
  on_conflict?: Maybe<Translations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CompaniesArgs = {
  objects: Array<User_Companies_Insert_Input>;
  on_conflict?: Maybe<User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Companies_OneArgs = {
  object: User_Companies_Insert_Input;
  on_conflict?: Maybe<User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Company_RolesArgs = {
  objects: Array<User_Company_Roles_Insert_Input>;
  on_conflict?: Maybe<User_Company_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Company_Roles_OneArgs = {
  object: User_Company_Roles_Insert_Input;
  on_conflict?: Maybe<User_Company_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Company_StatesArgs = {
  objects: Array<User_Company_States_Insert_Input>;
  on_conflict?: Maybe<User_Company_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Company_States_OneArgs = {
  object: User_Company_States_Insert_Input;
  on_conflict?: Maybe<User_Company_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_StatesArgs = {
  objects: Array<User_States_Insert_Input>;
  on_conflict?: Maybe<User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_States_OneArgs = {
  object: User_States_Insert_Input;
  on_conflict?: Maybe<User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Validation_TokensArgs = {
  objects: Array<Validation_Tokens_Insert_Input>;
  on_conflict?: Maybe<Validation_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Validation_Tokens_OneArgs = {
  object: Validation_Tokens_Insert_Input;
  on_conflict?: Maybe<Validation_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRegisterBlueCompanyArgs = {
  data: CompanyData;
};


/** mutation root */
export type Mutation_RootRegisterCompanyArgs = {
  data: RegisterCompanyInput;
};


/** mutation root */
export type Mutation_RootRegisterUserArgs = {
  data: RegisterUserData;
};


/** mutation root */
export type Mutation_RootSendNotificationArgs = {
  company_id: Array<Scalars['String']>;
  message: Scalars['String'];
  subject: Scalars['String'];
  to_dipendenti: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootUpdate_AddressesArgs = {
  _set?: Maybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_By_PkArgs = {
  _set?: Maybe<Addresses_Set_Input>;
  pk_columns: Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_ManyArgs = {
  updates: Array<Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompaniesArgs = {
  _set?: Maybe<Companies_Set_Input>;
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_By_PkArgs = {
  _set?: Maybe<Companies_Set_Input>;
  pk_columns: Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_ManyArgs = {
  updates: Array<Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_CategoriesArgs = {
  _set?: Maybe<Company_Categories_Set_Input>;
  where: Company_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Categories_By_PkArgs = {
  _set?: Maybe<Company_Categories_Set_Input>;
  pk_columns: Company_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Categories_ManyArgs = {
  updates: Array<Company_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_RolesArgs = {
  _set?: Maybe<Company_Roles_Set_Input>;
  where: Company_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Roles_By_PkArgs = {
  _set?: Maybe<Company_Roles_Set_Input>;
  pk_columns: Company_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Roles_ManyArgs = {
  updates: Array<Company_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_SectorArgs = {
  _set?: Maybe<Company_Sector_Set_Input>;
  where: Company_Sector_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Sector_By_PkArgs = {
  _set?: Maybe<Company_Sector_Set_Input>;
  pk_columns: Company_Sector_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Sector_ManyArgs = {
  updates: Array<Company_Sector_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_StatesArgs = {
  _set?: Maybe<Company_States_Set_Input>;
  where: Company_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_States_By_PkArgs = {
  _set?: Maybe<Company_States_Set_Input>;
  pk_columns: Company_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_States_ManyArgs = {
  updates: Array<Company_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_CategoriesArgs = {
  _set?: Maybe<Course_Categories_Set_Input>;
  where: Course_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Categories_By_PkArgs = {
  _set?: Maybe<Course_Categories_Set_Input>;
  pk_columns: Course_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Categories_ManyArgs = {
  updates: Array<Course_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Event_StateArgs = {
  _set?: Maybe<Course_Event_State_Set_Input>;
  where: Course_Event_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Event_State_By_PkArgs = {
  _set?: Maybe<Course_Event_State_Set_Input>;
  pk_columns: Course_Event_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Event_State_ManyArgs = {
  updates: Array<Course_Event_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_EventsArgs = {
  _set?: Maybe<Course_Events_Set_Input>;
  where: Course_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Events_By_PkArgs = {
  _set?: Maybe<Course_Events_Set_Input>;
  pk_columns: Course_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Events_ManyArgs = {
  updates: Array<Course_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_TypesArgs = {
  _set?: Maybe<Course_Types_Set_Input>;
  where: Course_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Types_By_PkArgs = {
  _set?: Maybe<Course_Types_Set_Input>;
  pk_columns: Course_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Types_ManyArgs = {
  updates: Array<Course_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CoursesArgs = {
  _set?: Maybe<Courses_Set_Input>;
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Courses_By_PkArgs = {
  _set?: Maybe<Courses_Set_Input>;
  pk_columns: Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Courses_ManyArgs = {
  updates: Array<Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_CategoriesArgs = {
  _set?: Maybe<Document_Categories_Set_Input>;
  where: Document_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Categories_By_PkArgs = {
  _set?: Maybe<Document_Categories_Set_Input>;
  pk_columns: Document_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Categories_ManyArgs = {
  updates: Array<Document_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_StatesArgs = {
  _set?: Maybe<Document_States_Set_Input>;
  where: Document_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_States_By_PkArgs = {
  _set?: Maybe<Document_States_Set_Input>;
  pk_columns: Document_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_States_ManyArgs = {
  updates: Array<Document_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypesArgs = {
  _inc?: Maybe<Document_Types_Inc_Input>;
  _set?: Maybe<Document_Types_Set_Input>;
  where: Document_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Types_By_PkArgs = {
  _inc?: Maybe<Document_Types_Inc_Input>;
  _set?: Maybe<Document_Types_Set_Input>;
  pk_columns: Document_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Types_ManyArgs = {
  updates: Array<Document_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentsArgs = {
  _set?: Maybe<Documents_Set_Input>;
  where: Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_By_PkArgs = {
  _set?: Maybe<Documents_Set_Input>;
  pk_columns: Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Documents_ManyArgs = {
  updates: Array<Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_UsersArgs = {
  _set?: Maybe<Event_Users_Set_Input>;
  where: Event_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Users_By_PkArgs = {
  _set?: Maybe<Event_Users_Set_Input>;
  pk_columns: Event_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Users_ManyArgs = {
  updates: Array<Event_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Users_StatesArgs = {
  _set?: Maybe<Event_Users_States_Set_Input>;
  where: Event_Users_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Users_States_By_PkArgs = {
  _set?: Maybe<Event_Users_States_Set_Input>;
  pk_columns: Event_Users_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Users_States_ManyArgs = {
  updates: Array<Event_Users_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_TokensArgs = {
  _set?: Maybe<Firebase_Tokens_Set_Input>;
  where: Firebase_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_Tokens_By_PkArgs = {
  _set?: Maybe<Firebase_Tokens_Set_Input>;
  pk_columns: Firebase_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_Tokens_ManyArgs = {
  updates: Array<Firebase_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_ColumnsArgs = {
  _inc?: Maybe<Geometry_Columns_Inc_Input>;
  _set?: Maybe<Geometry_Columns_Set_Input>;
  where: Geometry_Columns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Geometry_Columns_ManyArgs = {
  updates: Array<Geometry_Columns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguagesArgs = {
  _set?: Maybe<Languages_Set_Input>;
  where: Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_By_PkArgs = {
  _set?: Maybe<Languages_Set_Input>;
  pk_columns: Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Languages_ManyArgs = {
  updates: Array<Languages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationArgs = {
  _set?: Maybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_By_PkArgs = {
  _set?: Maybe<Notification_Set_Input>;
  pk_columns: Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ManyArgs = {
  updates: Array<Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_TokensArgs = {
  _set?: Maybe<Refresh_Tokens_Set_Input>;
  where: Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Tokens_By_PkArgs = {
  _set?: Maybe<Refresh_Tokens_Set_Input>;
  pk_columns: Refresh_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refresh_Tokens_ManyArgs = {
  updates: Array<Refresh_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Text_ContextsArgs = {
  _set?: Maybe<Text_Contexts_Set_Input>;
  where: Text_Contexts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Contexts_By_PkArgs = {
  _set?: Maybe<Text_Contexts_Set_Input>;
  pk_columns: Text_Contexts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Contexts_ManyArgs = {
  updates: Array<Text_Contexts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Token_TypesArgs = {
  _set?: Maybe<Token_Types_Set_Input>;
  where: Token_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Token_Types_By_PkArgs = {
  _set?: Maybe<Token_Types_Set_Input>;
  pk_columns: Token_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Token_Types_ManyArgs = {
  updates: Array<Token_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TranslationsArgs = {
  _set?: Maybe<Translations_Set_Input>;
  where: Translations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Translations_By_PkArgs = {
  _set?: Maybe<Translations_Set_Input>;
  pk_columns: Translations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Translations_ManyArgs = {
  updates: Array<Translations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CompaniesArgs = {
  _set?: Maybe<User_Companies_Set_Input>;
  where: User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Companies_By_PkArgs = {
  _set?: Maybe<User_Companies_Set_Input>;
  pk_columns: User_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Companies_ManyArgs = {
  updates: Array<User_Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_RolesArgs = {
  _set?: Maybe<User_Company_Roles_Set_Input>;
  where: User_Company_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_Roles_By_PkArgs = {
  _set?: Maybe<User_Company_Roles_Set_Input>;
  pk_columns: User_Company_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_Roles_ManyArgs = {
  updates: Array<User_Company_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_StatesArgs = {
  _set?: Maybe<User_Company_States_Set_Input>;
  where: User_Company_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_States_By_PkArgs = {
  _set?: Maybe<User_Company_States_Set_Input>;
  pk_columns: User_Company_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_States_ManyArgs = {
  updates: Array<User_Company_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_StatesArgs = {
  _set?: Maybe<User_States_Set_Input>;
  where: User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_States_By_PkArgs = {
  _set?: Maybe<User_States_Set_Input>;
  pk_columns: User_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_States_ManyArgs = {
  updates: Array<User_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_TokensArgs = {
  _set?: Maybe<Validation_Tokens_Set_Input>;
  where: Validation_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_Tokens_By_PkArgs = {
  _set?: Maybe<Validation_Tokens_Set_Input>;
  pk_columns: Validation_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Validation_Tokens_ManyArgs = {
  updates: Array<Validation_Tokens_Updates>;
};


/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: Maybe<Scalars['name']>;
  _gt?: Maybe<Scalars['name']>;
  _gte?: Maybe<Scalars['name']>;
  _in?: Maybe<Array<Scalars['name']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['name']>;
  _lte?: Maybe<Scalars['name']>;
  _neq?: Maybe<Scalars['name']>;
  _nin?: Maybe<Array<Scalars['name']>>;
};

/** columns and relationships of "notification" */
export type Notification = {
  __typename?: 'notification';
  blue_seen: Scalars['Boolean'];
  /** An object relationship */
  company: Companies;
  company_id: Scalars['uuid'];
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  document?: Maybe<Documents>;
  green_seen: Scalars['Boolean'];
  message: Scalars['String'];
  red_seen: Scalars['Boolean'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
  uuid: Scalars['uuid'];
};

/** aggregated selection of "notification" */
export type Notification_Aggregate = {
  __typename?: 'notification_aggregate';
  aggregate?: Maybe<Notification_Aggregate_Fields>;
  nodes: Array<Notification>;
};

/** aggregate fields of "notification" */
export type Notification_Aggregate_Fields = {
  __typename?: 'notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Max_Fields>;
  min?: Maybe<Notification_Min_Fields>;
};


/** aggregate fields of "notification" */
export type Notification_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Notification_Bool_Exp = {
  _and?: Maybe<Array<Notification_Bool_Exp>>;
  _not?: Maybe<Notification_Bool_Exp>;
  _or?: Maybe<Array<Notification_Bool_Exp>>;
  blue_seen?: Maybe<Boolean_Comparison_Exp>;
  company?: Maybe<Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  date?: Maybe<Timestamp_Comparison_Exp>;
  doc_id?: Maybe<Uuid_Comparison_Exp>;
  document?: Maybe<Documents_Bool_Exp>;
  green_seen?: Maybe<Boolean_Comparison_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  red_seen?: Maybe<Boolean_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  uuid?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification" */
export enum Notification_Constraint {
  /** unique or primary key constraint on columns "uuid" */
  NotificationPkey = 'notification_pkey'
}

/** input type for inserting data into table "notification" */
export type Notification_Insert_Input = {
  blue_seen?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  document?: Maybe<Documents_Obj_Rel_Insert_Input>;
  green_seen?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  red_seen?: Maybe<Scalars['Boolean']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notification_Max_Fields = {
  __typename?: 'notification_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Notification_Min_Fields = {
  __typename?: 'notification_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification" */
export type Notification_Mutation_Response = {
  __typename?: 'notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification>;
};

/** on_conflict condition type for table "notification" */
export type Notification_On_Conflict = {
  constraint: Notification_Constraint;
  update_columns?: Array<Notification_Update_Column>;
  where?: Maybe<Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Notification_Order_By = {
  blue_seen?: Maybe<Order_By>;
  company?: Maybe<Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  doc_id?: Maybe<Order_By>;
  document?: Maybe<Documents_Order_By>;
  green_seen?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  red_seen?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  uuid?: Maybe<Order_By>;
};

/** primary key columns input for table: notification */
export type Notification_Pk_Columns_Input = {
  uuid: Scalars['uuid'];
};

/** select columns of table "notification" */
export enum Notification_Select_Column {
  /** column name */
  BlueSeen = 'blue_seen',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Date = 'date',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  GreenSeen = 'green_seen',
  /** column name */
  Message = 'message',
  /** column name */
  RedSeen = 'red_seen',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "notification" */
export type Notification_Set_Input = {
  blue_seen?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  green_seen?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  red_seen?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification" */
export type Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Stream_Cursor_Value_Input = {
  blue_seen?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamp']>;
  doc_id?: Maybe<Scalars['uuid']>;
  green_seen?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  red_seen?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
  uuid?: Maybe<Scalars['uuid']>;
};

/** update columns of table "notification" */
export enum Notification_Update_Column {
  /** column name */
  BlueSeen = 'blue_seen',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Date = 'date',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  GreenSeen = 'green_seen',
  /** column name */
  Message = 'message',
  /** column name */
  RedSeen = 'red_seen',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  /** fetch data from the table: "company_categories" */
  company_categories: Array<Company_Categories>;
  /** fetch aggregated fields from the table: "company_categories" */
  company_categories_aggregate: Company_Categories_Aggregate;
  /** fetch data from the table: "company_categories" using primary key columns */
  company_categories_by_pk?: Maybe<Company_Categories>;
  /** fetch data from the table: "company_roles" */
  company_roles: Array<Company_Roles>;
  /** fetch aggregated fields from the table: "company_roles" */
  company_roles_aggregate: Company_Roles_Aggregate;
  /** fetch data from the table: "company_roles" using primary key columns */
  company_roles_by_pk?: Maybe<Company_Roles>;
  /** fetch data from the table: "company_sector" */
  company_sector: Array<Company_Sector>;
  /** fetch aggregated fields from the table: "company_sector" */
  company_sector_aggregate: Company_Sector_Aggregate;
  /** fetch data from the table: "company_sector" using primary key columns */
  company_sector_by_pk?: Maybe<Company_Sector>;
  /** fetch data from the table: "company_states" */
  company_states: Array<Company_States>;
  /** fetch aggregated fields from the table: "company_states" */
  company_states_aggregate: Company_States_Aggregate;
  /** fetch data from the table: "company_states" using primary key columns */
  company_states_by_pk?: Maybe<Company_States>;
  /** fetch data from the table: "course_categories" */
  course_categories: Array<Course_Categories>;
  /** fetch aggregated fields from the table: "course_categories" */
  course_categories_aggregate: Course_Categories_Aggregate;
  /** fetch data from the table: "course_categories" using primary key columns */
  course_categories_by_pk?: Maybe<Course_Categories>;
  /** fetch data from the table: "course_event_state" */
  course_event_state: Array<Course_Event_State>;
  /** fetch aggregated fields from the table: "course_event_state" */
  course_event_state_aggregate: Course_Event_State_Aggregate;
  /** fetch data from the table: "course_event_state" using primary key columns */
  course_event_state_by_pk?: Maybe<Course_Event_State>;
  /** An array relationship */
  course_events: Array<Course_Events>;
  /** An aggregate relationship */
  course_events_aggregate: Course_Events_Aggregate;
  /** fetch data from the table: "course_events" using primary key columns */
  course_events_by_pk?: Maybe<Course_Events>;
  /** fetch data from the table: "course_types" */
  course_types: Array<Course_Types>;
  /** fetch aggregated fields from the table: "course_types" */
  course_types_aggregate: Course_Types_Aggregate;
  /** fetch data from the table: "course_types" using primary key columns */
  course_types_by_pk?: Maybe<Course_Types>;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: Maybe<Courses>;
  /** fetch data from the table: "document_categories" */
  document_categories: Array<Document_Categories>;
  /** fetch aggregated fields from the table: "document_categories" */
  document_categories_aggregate: Document_Categories_Aggregate;
  /** fetch data from the table: "document_categories" using primary key columns */
  document_categories_by_pk?: Maybe<Document_Categories>;
  /** fetch data from the table: "document_states" */
  document_states: Array<Document_States>;
  /** fetch aggregated fields from the table: "document_states" */
  document_states_aggregate: Document_States_Aggregate;
  /** fetch data from the table: "document_states" using primary key columns */
  document_states_by_pk?: Maybe<Document_States>;
  /** An array relationship */
  document_types: Array<Document_Types>;
  /** An aggregate relationship */
  document_types_aggregate: Document_Types_Aggregate;
  /** fetch data from the table: "document_types" using primary key columns */
  document_types_by_pk?: Maybe<Document_Types>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** An array relationship */
  event_users: Array<Event_Users>;
  /** An aggregate relationship */
  event_users_aggregate: Event_Users_Aggregate;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: Maybe<Event_Users>;
  /** fetch data from the table: "event_users_states" */
  event_users_states: Array<Event_Users_States>;
  /** fetch aggregated fields from the table: "event_users_states" */
  event_users_states_aggregate: Event_Users_States_Aggregate;
  /** fetch data from the table: "event_users_states" using primary key columns */
  event_users_states_by_pk?: Maybe<Event_Users_States>;
  /** An array relationship */
  firebase_tokens: Array<Firebase_Tokens>;
  /** An aggregate relationship */
  firebase_tokens_aggregate: Firebase_Tokens_Aggregate;
  /** fetch data from the table: "firebase_tokens" using primary key columns */
  firebase_tokens_by_pk?: Maybe<Firebase_Tokens>;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  resetPassword?: Maybe<ResetPasswordOutput>;
  /** An array relationship */
  text_contexts: Array<Text_Contexts>;
  /** An aggregate relationship */
  text_contexts_aggregate: Text_Contexts_Aggregate;
  /** fetch data from the table: "text_contexts" using primary key columns */
  text_contexts_by_pk?: Maybe<Text_Contexts>;
  /** fetch data from the table: "token_types" */
  token_types: Array<Token_Types>;
  /** fetch aggregated fields from the table: "token_types" */
  token_types_aggregate: Token_Types_Aggregate;
  /** fetch data from the table: "token_types" using primary key columns */
  token_types_by_pk?: Maybe<Token_Types>;
  /** fetch data from the table: "translations" */
  translations: Array<Translations>;
  /** fetch aggregated fields from the table: "translations" */
  translations_aggregate: Translations_Aggregate;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
  /** fetch data from the table: "user_companies" using primary key columns */
  user_companies_by_pk?: Maybe<User_Companies>;
  /** fetch data from the table: "user_company_roles" */
  user_company_roles: Array<User_Company_Roles>;
  /** fetch aggregated fields from the table: "user_company_roles" */
  user_company_roles_aggregate: User_Company_Roles_Aggregate;
  /** fetch data from the table: "user_company_roles" using primary key columns */
  user_company_roles_by_pk?: Maybe<User_Company_Roles>;
  /** fetch data from the table: "user_company_states" */
  user_company_states: Array<User_Company_States>;
  /** fetch aggregated fields from the table: "user_company_states" */
  user_company_states_aggregate: User_Company_States_Aggregate;
  /** fetch data from the table: "user_company_states" using primary key columns */
  user_company_states_by_pk?: Maybe<User_Company_States>;
  /** fetch data from the table: "user_states" */
  user_states: Array<User_States>;
  /** fetch aggregated fields from the table: "user_states" */
  user_states_aggregate: User_States_Aggregate;
  /** fetch data from the table: "user_states" using primary key columns */
  user_states_by_pk?: Maybe<User_States>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  validation_tokens: Array<Validation_Tokens>;
  /** An aggregate relationship */
  validation_tokens_aggregate: Validation_Tokens_Aggregate;
  /** fetch data from the table: "validation_tokens" using primary key columns */
  validation_tokens_by_pk?: Maybe<Validation_Tokens>;
};


export type Query_RootAddressesArgs = {
  distinct_on?: Maybe<Array<Addresses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Addresses_Order_By>>;
  where?: Maybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_AggregateArgs = {
  distinct_on?: Maybe<Array<Addresses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Addresses_Order_By>>;
  where?: Maybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_CategoriesArgs = {
  distinct_on?: Maybe<Array<Company_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Categories_Order_By>>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};


export type Query_RootCompany_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Categories_Order_By>>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};


export type Query_RootCompany_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_RolesArgs = {
  distinct_on?: Maybe<Array<Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Roles_Order_By>>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};


export type Query_RootCompany_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Roles_Order_By>>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};


export type Query_RootCompany_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type Query_RootCompany_SectorArgs = {
  distinct_on?: Maybe<Array<Company_Sector_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Sector_Order_By>>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};


export type Query_RootCompany_Sector_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Sector_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Sector_Order_By>>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};


export type Query_RootCompany_Sector_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_StatesArgs = {
  distinct_on?: Maybe<Array<Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_States_Order_By>>;
  where?: Maybe<Company_States_Bool_Exp>;
};


export type Query_RootCompany_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_States_Order_By>>;
  where?: Maybe<Company_States_Bool_Exp>;
};


export type Query_RootCompany_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Query_RootCourse_CategoriesArgs = {
  distinct_on?: Maybe<Array<Course_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Categories_Order_By>>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};


export type Query_RootCourse_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Categories_Order_By>>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};


export type Query_RootCourse_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Event_StateArgs = {
  distinct_on?: Maybe<Array<Course_Event_State_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Event_State_Order_By>>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};


export type Query_RootCourse_Event_State_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Event_State_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Event_State_Order_By>>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};


export type Query_RootCourse_Event_State_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_EventsArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


export type Query_RootCourse_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


export type Query_RootCourse_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_TypesArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


export type Query_RootCourse_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


export type Query_RootCourse_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCoursesArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};


export type Query_RootCourses_AggregateArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};


export type Query_RootCourses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_CategoriesArgs = {
  distinct_on?: Maybe<Array<Document_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Categories_Order_By>>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};


export type Query_RootDocument_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Categories_Order_By>>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};


export type Query_RootDocument_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_StatesArgs = {
  distinct_on?: Maybe<Array<Document_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_States_Order_By>>;
  where?: Maybe<Document_States_Bool_Exp>;
};


export type Query_RootDocument_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_States_Order_By>>;
  where?: Maybe<Document_States_Bool_Exp>;
};


export type Query_RootDocument_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Query_RootDocument_TypesArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


export type Query_RootDocument_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


export type Query_RootDocument_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Query_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_UsersArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


export type Query_RootEvent_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


export type Query_RootEvent_Users_By_PkArgs = {
  event_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootEvent_Users_StatesArgs = {
  distinct_on?: Maybe<Array<Event_Users_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_States_Order_By>>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};


export type Query_RootEvent_Users_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_States_Order_By>>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};


export type Query_RootEvent_Users_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Query_RootFirebase_TokensArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


export type Query_RootFirebase_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


export type Query_RootFirebase_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGeometry_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


export type Query_RootLanguagesArgs = {
  distinct_on?: Maybe<Array<Languages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Languages_Order_By>>;
  where?: Maybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_AggregateArgs = {
  distinct_on?: Maybe<Array<Languages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Languages_Order_By>>;
  where?: Maybe<Languages_Bool_Exp>;
};


export type Query_RootLanguages_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootNotificationArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_By_PkArgs = {
  uuid: Scalars['uuid'];
};


export type Query_RootRefresh_TokensArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


export type Query_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


export type Query_RootRefresh_Tokens_By_PkArgs = {
  token: Scalars['String'];
};


export type Query_RootResetPasswordArgs = {
  email: Scalars['String'];
};


export type Query_RootText_ContextsArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


export type Query_RootText_Contexts_AggregateArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


export type Query_RootText_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootToken_TypesArgs = {
  distinct_on?: Maybe<Array<Token_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Token_Types_Order_By>>;
  where?: Maybe<Token_Types_Bool_Exp>;
};


export type Query_RootToken_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Token_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Token_Types_Order_By>>;
  where?: Maybe<Token_Types_Bool_Exp>;
};


export type Query_RootToken_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTranslationsArgs = {
  distinct_on?: Maybe<Array<Translations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Translations_Order_By>>;
  where?: Maybe<Translations_Bool_Exp>;
};


export type Query_RootTranslations_AggregateArgs = {
  distinct_on?: Maybe<Array<Translations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Translations_Order_By>>;
  where?: Maybe<Translations_Bool_Exp>;
};


export type Query_RootTranslations_By_PkArgs = {
  language_id: Scalars['uuid'];
  text_context_id: Scalars['uuid'];
};


export type Query_RootUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


export type Query_RootUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


export type Query_RootUser_Companies_By_PkArgs = {
  company_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootUser_Company_RolesArgs = {
  distinct_on?: Maybe<Array<User_Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Roles_Order_By>>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};


export type Query_RootUser_Company_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Roles_Order_By>>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};


export type Query_RootUser_Company_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type Query_RootUser_Company_StatesArgs = {
  distinct_on?: Maybe<Array<User_Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_States_Order_By>>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};


export type Query_RootUser_Company_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_States_Order_By>>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};


export type Query_RootUser_Company_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Query_RootUser_StatesArgs = {
  distinct_on?: Maybe<Array<User_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_States_Order_By>>;
  where?: Maybe<User_States_Bool_Exp>;
};


export type Query_RootUser_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_States_Order_By>>;
  where?: Maybe<User_States_Bool_Exp>;
};


export type Query_RootUser_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootValidation_TokensArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


export type Query_RootValidation_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


export type Query_RootValidation_Tokens_By_PkArgs = {
  token: Scalars['String'];
};

/** columns and relationships of "refresh_tokens" */
export type Refresh_Tokens = {
  __typename?: 'refresh_tokens';
  created_at: Scalars['timestamptz'];
  expires_at: Scalars['time'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
  valid: Scalars['Boolean'];
};

/** aggregated selection of "refresh_tokens" */
export type Refresh_Tokens_Aggregate = {
  __typename?: 'refresh_tokens_aggregate';
  aggregate?: Maybe<Refresh_Tokens_Aggregate_Fields>;
  nodes: Array<Refresh_Tokens>;
};

export type Refresh_Tokens_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Refresh_Tokens_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Refresh_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Refresh_Tokens_Aggregate_Bool_Exp_Bool_And = {
  arguments: Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refresh_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Refresh_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Fields = {
  __typename?: 'refresh_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Refresh_Tokens_Max_Fields>;
  min?: Maybe<Refresh_Tokens_Min_Fields>;
};


/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Refresh_Tokens_Max_Order_By>;
  min?: Maybe<Refresh_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "refresh_tokens" */
export type Refresh_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Refresh_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Refresh_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "refresh_tokens". All fields are combined with a logical 'AND'. */
export type Refresh_Tokens_Bool_Exp = {
  _and?: Maybe<Array<Refresh_Tokens_Bool_Exp>>;
  _not?: Maybe<Refresh_Tokens_Bool_Exp>;
  _or?: Maybe<Array<Refresh_Tokens_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  expires_at?: Maybe<Time_Comparison_Exp>;
  token?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  valid?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "refresh_tokens" */
export enum Refresh_Tokens_Constraint {
  /** unique or primary key constraint on columns "token" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** input type for inserting data into table "refresh_tokens" */
export type Refresh_Tokens_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['time']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Refresh_Tokens_Max_Fields = {
  __typename?: 'refresh_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Refresh_Tokens_Min_Fields = {
  __typename?: 'refresh_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "refresh_tokens" */
export type Refresh_Tokens_Mutation_Response = {
  __typename?: 'refresh_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Tokens>;
};

/** on_conflict condition type for table "refresh_tokens" */
export type Refresh_Tokens_On_Conflict = {
  constraint: Refresh_Tokens_Constraint;
  update_columns?: Array<Refresh_Tokens_Update_Column>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "refresh_tokens". */
export type Refresh_Tokens_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  valid?: Maybe<Order_By>;
};

/** primary key columns input for table: refresh_tokens */
export type Refresh_Tokens_Pk_Columns_Input = {
  token: Scalars['String'];
};

/** select columns of table "refresh_tokens" */
export enum Refresh_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Valid = 'valid'
}

/** select "refresh_tokens_aggregate_bool_exp_bool_and_arguments_columns" columns of table "refresh_tokens" */
export enum Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Valid = 'valid'
}

/** select "refresh_tokens_aggregate_bool_exp_bool_or_arguments_columns" columns of table "refresh_tokens" */
export enum Refresh_Tokens_Select_Column_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Valid = 'valid'
}

/** input type for updating data in table "refresh_tokens" */
export type Refresh_Tokens_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['time']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "refresh_tokens" */
export type Refresh_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refresh_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refresh_Tokens_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['time']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "refresh_tokens" */
export enum Refresh_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Valid = 'valid'
}

export type Refresh_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Refresh_Tokens_Set_Input>;
  where: Refresh_Tokens_Bool_Exp;
};

export type RegisterUserData = {
  documents?: Maybe<Array<Maybe<DocumentData>>>;
  userCompany?: Maybe<UserCompanyData>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  /** fetch data from the table in a streaming manner: "companies" */
  companies_stream: Array<Companies>;
  /** fetch data from the table: "company_categories" */
  company_categories: Array<Company_Categories>;
  /** fetch aggregated fields from the table: "company_categories" */
  company_categories_aggregate: Company_Categories_Aggregate;
  /** fetch data from the table: "company_categories" using primary key columns */
  company_categories_by_pk?: Maybe<Company_Categories>;
  /** fetch data from the table in a streaming manner: "company_categories" */
  company_categories_stream: Array<Company_Categories>;
  /** fetch data from the table: "company_roles" */
  company_roles: Array<Company_Roles>;
  /** fetch aggregated fields from the table: "company_roles" */
  company_roles_aggregate: Company_Roles_Aggregate;
  /** fetch data from the table: "company_roles" using primary key columns */
  company_roles_by_pk?: Maybe<Company_Roles>;
  /** fetch data from the table in a streaming manner: "company_roles" */
  company_roles_stream: Array<Company_Roles>;
  /** fetch data from the table: "company_sector" */
  company_sector: Array<Company_Sector>;
  /** fetch aggregated fields from the table: "company_sector" */
  company_sector_aggregate: Company_Sector_Aggregate;
  /** fetch data from the table: "company_sector" using primary key columns */
  company_sector_by_pk?: Maybe<Company_Sector>;
  /** fetch data from the table in a streaming manner: "company_sector" */
  company_sector_stream: Array<Company_Sector>;
  /** fetch data from the table: "company_states" */
  company_states: Array<Company_States>;
  /** fetch aggregated fields from the table: "company_states" */
  company_states_aggregate: Company_States_Aggregate;
  /** fetch data from the table: "company_states" using primary key columns */
  company_states_by_pk?: Maybe<Company_States>;
  /** fetch data from the table in a streaming manner: "company_states" */
  company_states_stream: Array<Company_States>;
  /** fetch data from the table: "course_categories" */
  course_categories: Array<Course_Categories>;
  /** fetch aggregated fields from the table: "course_categories" */
  course_categories_aggregate: Course_Categories_Aggregate;
  /** fetch data from the table: "course_categories" using primary key columns */
  course_categories_by_pk?: Maybe<Course_Categories>;
  /** fetch data from the table in a streaming manner: "course_categories" */
  course_categories_stream: Array<Course_Categories>;
  /** fetch data from the table: "course_event_state" */
  course_event_state: Array<Course_Event_State>;
  /** fetch aggregated fields from the table: "course_event_state" */
  course_event_state_aggregate: Course_Event_State_Aggregate;
  /** fetch data from the table: "course_event_state" using primary key columns */
  course_event_state_by_pk?: Maybe<Course_Event_State>;
  /** fetch data from the table in a streaming manner: "course_event_state" */
  course_event_state_stream: Array<Course_Event_State>;
  /** An array relationship */
  course_events: Array<Course_Events>;
  /** An aggregate relationship */
  course_events_aggregate: Course_Events_Aggregate;
  /** fetch data from the table: "course_events" using primary key columns */
  course_events_by_pk?: Maybe<Course_Events>;
  /** fetch data from the table in a streaming manner: "course_events" */
  course_events_stream: Array<Course_Events>;
  /** fetch data from the table: "course_types" */
  course_types: Array<Course_Types>;
  /** fetch aggregated fields from the table: "course_types" */
  course_types_aggregate: Course_Types_Aggregate;
  /** fetch data from the table: "course_types" using primary key columns */
  course_types_by_pk?: Maybe<Course_Types>;
  /** fetch data from the table in a streaming manner: "course_types" */
  course_types_stream: Array<Course_Types>;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: Maybe<Courses>;
  /** fetch data from the table in a streaming manner: "courses" */
  courses_stream: Array<Courses>;
  /** fetch data from the table: "document_categories" */
  document_categories: Array<Document_Categories>;
  /** fetch aggregated fields from the table: "document_categories" */
  document_categories_aggregate: Document_Categories_Aggregate;
  /** fetch data from the table: "document_categories" using primary key columns */
  document_categories_by_pk?: Maybe<Document_Categories>;
  /** fetch data from the table in a streaming manner: "document_categories" */
  document_categories_stream: Array<Document_Categories>;
  /** fetch data from the table: "document_states" */
  document_states: Array<Document_States>;
  /** fetch aggregated fields from the table: "document_states" */
  document_states_aggregate: Document_States_Aggregate;
  /** fetch data from the table: "document_states" using primary key columns */
  document_states_by_pk?: Maybe<Document_States>;
  /** fetch data from the table in a streaming manner: "document_states" */
  document_states_stream: Array<Document_States>;
  /** An array relationship */
  document_types: Array<Document_Types>;
  /** An aggregate relationship */
  document_types_aggregate: Document_Types_Aggregate;
  /** fetch data from the table: "document_types" using primary key columns */
  document_types_by_pk?: Maybe<Document_Types>;
  /** fetch data from the table in a streaming manner: "document_types" */
  document_types_stream: Array<Document_Types>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk?: Maybe<Documents>;
  /** fetch data from the table in a streaming manner: "documents" */
  documents_stream: Array<Documents>;
  /** An array relationship */
  event_users: Array<Event_Users>;
  /** An aggregate relationship */
  event_users_aggregate: Event_Users_Aggregate;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: Maybe<Event_Users>;
  /** fetch data from the table: "event_users_states" */
  event_users_states: Array<Event_Users_States>;
  /** fetch aggregated fields from the table: "event_users_states" */
  event_users_states_aggregate: Event_Users_States_Aggregate;
  /** fetch data from the table: "event_users_states" using primary key columns */
  event_users_states_by_pk?: Maybe<Event_Users_States>;
  /** fetch data from the table in a streaming manner: "event_users_states" */
  event_users_states_stream: Array<Event_Users_States>;
  /** fetch data from the table in a streaming manner: "event_users" */
  event_users_stream: Array<Event_Users>;
  /** An array relationship */
  firebase_tokens: Array<Firebase_Tokens>;
  /** An aggregate relationship */
  firebase_tokens_aggregate: Firebase_Tokens_Aggregate;
  /** fetch data from the table: "firebase_tokens" using primary key columns */
  firebase_tokens_by_pk?: Maybe<Firebase_Tokens>;
  /** fetch data from the table in a streaming manner: "firebase_tokens" */
  firebase_tokens_stream: Array<Firebase_Tokens>;
  /** fetch data from the table: "geometry_columns" */
  geometry_columns: Array<Geometry_Columns>;
  /** fetch aggregated fields from the table: "geometry_columns" */
  geometry_columns_aggregate: Geometry_Columns_Aggregate;
  /** fetch data from the table in a streaming manner: "geometry_columns" */
  geometry_columns_stream: Array<Geometry_Columns>;
  /** fetch data from the table: "languages" */
  languages: Array<Languages>;
  /** fetch aggregated fields from the table: "languages" */
  languages_aggregate: Languages_Aggregate;
  /** fetch data from the table: "languages" using primary key columns */
  languages_by_pk?: Maybe<Languages>;
  /** fetch data from the table in a streaming manner: "languages" */
  languages_stream: Array<Languages>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table in a streaming manner: "notification" */
  notification_stream: Array<Notification>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  /** fetch data from the table: "refresh_tokens" using primary key columns */
  refresh_tokens_by_pk?: Maybe<Refresh_Tokens>;
  /** fetch data from the table in a streaming manner: "refresh_tokens" */
  refresh_tokens_stream: Array<Refresh_Tokens>;
  /** An array relationship */
  text_contexts: Array<Text_Contexts>;
  /** An aggregate relationship */
  text_contexts_aggregate: Text_Contexts_Aggregate;
  /** fetch data from the table: "text_contexts" using primary key columns */
  text_contexts_by_pk?: Maybe<Text_Contexts>;
  /** fetch data from the table in a streaming manner: "text_contexts" */
  text_contexts_stream: Array<Text_Contexts>;
  /** fetch data from the table: "token_types" */
  token_types: Array<Token_Types>;
  /** fetch aggregated fields from the table: "token_types" */
  token_types_aggregate: Token_Types_Aggregate;
  /** fetch data from the table: "token_types" using primary key columns */
  token_types_by_pk?: Maybe<Token_Types>;
  /** fetch data from the table in a streaming manner: "token_types" */
  token_types_stream: Array<Token_Types>;
  /** fetch data from the table: "translations" */
  translations: Array<Translations>;
  /** fetch aggregated fields from the table: "translations" */
  translations_aggregate: Translations_Aggregate;
  /** fetch data from the table: "translations" using primary key columns */
  translations_by_pk?: Maybe<Translations>;
  /** fetch data from the table in a streaming manner: "translations" */
  translations_stream: Array<Translations>;
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
  /** fetch data from the table: "user_companies" using primary key columns */
  user_companies_by_pk?: Maybe<User_Companies>;
  /** fetch data from the table in a streaming manner: "user_companies" */
  user_companies_stream: Array<User_Companies>;
  /** fetch data from the table: "user_company_roles" */
  user_company_roles: Array<User_Company_Roles>;
  /** fetch aggregated fields from the table: "user_company_roles" */
  user_company_roles_aggregate: User_Company_Roles_Aggregate;
  /** fetch data from the table: "user_company_roles" using primary key columns */
  user_company_roles_by_pk?: Maybe<User_Company_Roles>;
  /** fetch data from the table in a streaming manner: "user_company_roles" */
  user_company_roles_stream: Array<User_Company_Roles>;
  /** fetch data from the table: "user_company_states" */
  user_company_states: Array<User_Company_States>;
  /** fetch aggregated fields from the table: "user_company_states" */
  user_company_states_aggregate: User_Company_States_Aggregate;
  /** fetch data from the table: "user_company_states" using primary key columns */
  user_company_states_by_pk?: Maybe<User_Company_States>;
  /** fetch data from the table in a streaming manner: "user_company_states" */
  user_company_states_stream: Array<User_Company_States>;
  /** fetch data from the table: "user_states" */
  user_states: Array<User_States>;
  /** fetch aggregated fields from the table: "user_states" */
  user_states_aggregate: User_States_Aggregate;
  /** fetch data from the table: "user_states" using primary key columns */
  user_states_by_pk?: Maybe<User_States>;
  /** fetch data from the table in a streaming manner: "user_states" */
  user_states_stream: Array<User_States>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  validation_tokens: Array<Validation_Tokens>;
  /** An aggregate relationship */
  validation_tokens_aggregate: Validation_Tokens_Aggregate;
  /** fetch data from the table: "validation_tokens" using primary key columns */
  validation_tokens_by_pk?: Maybe<Validation_Tokens>;
  /** fetch data from the table in a streaming manner: "validation_tokens" */
  validation_tokens_stream: Array<Validation_Tokens>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: Maybe<Array<Addresses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Addresses_Order_By>>;
  where?: Maybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_AggregateArgs = {
  distinct_on?: Maybe<Array<Addresses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Addresses_Order_By>>;
  where?: Maybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Addresses_Stream_Cursor_Input>>;
  where?: Maybe<Addresses_Bool_Exp>;
};


export type Subscription_RootCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompanies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Companies_Stream_Cursor_Input>>;
  where?: Maybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompany_CategoriesArgs = {
  distinct_on?: Maybe<Array<Company_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Categories_Order_By>>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Categories_Order_By>>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_Categories_Stream_Cursor_Input>>;
  where?: Maybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_RolesArgs = {
  distinct_on?: Maybe<Array<Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Roles_Order_By>>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};


export type Subscription_RootCompany_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Roles_Order_By>>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};


export type Subscription_RootCompany_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type Subscription_RootCompany_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_Roles_Stream_Cursor_Input>>;
  where?: Maybe<Company_Roles_Bool_Exp>;
};


export type Subscription_RootCompany_SectorArgs = {
  distinct_on?: Maybe<Array<Company_Sector_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Sector_Order_By>>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};


export type Subscription_RootCompany_Sector_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Sector_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Sector_Order_By>>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};


export type Subscription_RootCompany_Sector_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_Sector_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_Sector_Stream_Cursor_Input>>;
  where?: Maybe<Company_Sector_Bool_Exp>;
};


export type Subscription_RootCompany_StatesArgs = {
  distinct_on?: Maybe<Array<Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_States_Order_By>>;
  where?: Maybe<Company_States_Bool_Exp>;
};


export type Subscription_RootCompany_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_States_Order_By>>;
  where?: Maybe<Company_States_Bool_Exp>;
};


export type Subscription_RootCompany_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Subscription_RootCompany_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_States_Stream_Cursor_Input>>;
  where?: Maybe<Company_States_Bool_Exp>;
};


export type Subscription_RootCourse_CategoriesArgs = {
  distinct_on?: Maybe<Array<Course_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Categories_Order_By>>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};


export type Subscription_RootCourse_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Categories_Order_By>>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};


export type Subscription_RootCourse_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Course_Categories_Stream_Cursor_Input>>;
  where?: Maybe<Course_Categories_Bool_Exp>;
};


export type Subscription_RootCourse_Event_StateArgs = {
  distinct_on?: Maybe<Array<Course_Event_State_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Event_State_Order_By>>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};


export type Subscription_RootCourse_Event_State_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Event_State_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Event_State_Order_By>>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};


export type Subscription_RootCourse_Event_State_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Event_State_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Course_Event_State_Stream_Cursor_Input>>;
  where?: Maybe<Course_Event_State_Bool_Exp>;
};


export type Subscription_RootCourse_EventsArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


export type Subscription_RootCourse_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Events_Order_By>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


export type Subscription_RootCourse_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Course_Events_Stream_Cursor_Input>>;
  where?: Maybe<Course_Events_Bool_Exp>;
};


export type Subscription_RootCourse_TypesArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


export type Subscription_RootCourse_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Course_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Course_Types_Order_By>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


export type Subscription_RootCourse_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Course_Types_Stream_Cursor_Input>>;
  where?: Maybe<Course_Types_Bool_Exp>;
};


export type Subscription_RootCoursesArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_AggregateArgs = {
  distinct_on?: Maybe<Array<Courses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Courses_Order_By>>;
  where?: Maybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Courses_Stream_Cursor_Input>>;
  where?: Maybe<Courses_Bool_Exp>;
};


export type Subscription_RootDocument_CategoriesArgs = {
  distinct_on?: Maybe<Array<Document_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Categories_Order_By>>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};


export type Subscription_RootDocument_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Categories_Order_By>>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};


export type Subscription_RootDocument_Categories_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Categories_Stream_Cursor_Input>>;
  where?: Maybe<Document_Categories_Bool_Exp>;
};


export type Subscription_RootDocument_StatesArgs = {
  distinct_on?: Maybe<Array<Document_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_States_Order_By>>;
  where?: Maybe<Document_States_Bool_Exp>;
};


export type Subscription_RootDocument_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_States_Order_By>>;
  where?: Maybe<Document_States_Bool_Exp>;
};


export type Subscription_RootDocument_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Subscription_RootDocument_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_States_Stream_Cursor_Input>>;
  where?: Maybe<Document_States_Bool_Exp>;
};


export type Subscription_RootDocument_TypesArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


export type Subscription_RootDocument_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Types_Order_By>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


export type Subscription_RootDocument_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Types_Stream_Cursor_Input>>;
  where?: Maybe<Document_Types_Bool_Exp>;
};


export type Subscription_RootDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootDocuments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocuments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Documents_Stream_Cursor_Input>>;
  where?: Maybe<Documents_Bool_Exp>;
};


export type Subscription_RootEvent_UsersArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


export type Subscription_RootEvent_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


export type Subscription_RootEvent_Users_By_PkArgs = {
  event_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootEvent_Users_StatesArgs = {
  distinct_on?: Maybe<Array<Event_Users_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_States_Order_By>>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};


export type Subscription_RootEvent_Users_States_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_States_Order_By>>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};


export type Subscription_RootEvent_Users_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Subscription_RootEvent_Users_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Event_Users_States_Stream_Cursor_Input>>;
  where?: Maybe<Event_Users_States_Bool_Exp>;
};


export type Subscription_RootEvent_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Event_Users_Stream_Cursor_Input>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


export type Subscription_RootFirebase_TokensArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


export type Subscription_RootFirebase_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


export type Subscription_RootFirebase_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFirebase_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Firebase_Tokens_Stream_Cursor_Input>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


export type Subscription_RootGeometry_ColumnsArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_AggregateArgs = {
  distinct_on?: Maybe<Array<Geometry_Columns_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geometry_Columns_Order_By>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootGeometry_Columns_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Geometry_Columns_Stream_Cursor_Input>>;
  where?: Maybe<Geometry_Columns_Bool_Exp>;
};


export type Subscription_RootLanguagesArgs = {
  distinct_on?: Maybe<Array<Languages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Languages_Order_By>>;
  where?: Maybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_AggregateArgs = {
  distinct_on?: Maybe<Array<Languages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Languages_Order_By>>;
  where?: Maybe<Languages_Bool_Exp>;
};


export type Subscription_RootLanguages_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootLanguages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Languages_Stream_Cursor_Input>>;
  where?: Maybe<Languages_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_By_PkArgs = {
  uuid: Scalars['uuid'];
};


export type Subscription_RootNotification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Notification_Stream_Cursor_Input>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootRefresh_TokensArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootRefresh_Tokens_By_PkArgs = {
  token: Scalars['String'];
};


export type Subscription_RootRefresh_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Refresh_Tokens_Stream_Cursor_Input>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootText_ContextsArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


export type Subscription_RootText_Contexts_AggregateArgs = {
  distinct_on?: Maybe<Array<Text_Contexts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Text_Contexts_Order_By>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


export type Subscription_RootText_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootText_Contexts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Text_Contexts_Stream_Cursor_Input>>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};


export type Subscription_RootToken_TypesArgs = {
  distinct_on?: Maybe<Array<Token_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Token_Types_Order_By>>;
  where?: Maybe<Token_Types_Bool_Exp>;
};


export type Subscription_RootToken_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Token_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Token_Types_Order_By>>;
  where?: Maybe<Token_Types_Bool_Exp>;
};


export type Subscription_RootToken_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootToken_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Token_Types_Stream_Cursor_Input>>;
  where?: Maybe<Token_Types_Bool_Exp>;
};


export type Subscription_RootTranslationsArgs = {
  distinct_on?: Maybe<Array<Translations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Translations_Order_By>>;
  where?: Maybe<Translations_Bool_Exp>;
};


export type Subscription_RootTranslations_AggregateArgs = {
  distinct_on?: Maybe<Array<Translations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Translations_Order_By>>;
  where?: Maybe<Translations_Bool_Exp>;
};


export type Subscription_RootTranslations_By_PkArgs = {
  language_id: Scalars['uuid'];
  text_context_id: Scalars['uuid'];
};


export type Subscription_RootTranslations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Translations_Stream_Cursor_Input>>;
  where?: Maybe<Translations_Bool_Exp>;
};


export type Subscription_RootUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


export type Subscription_RootUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


export type Subscription_RootUser_Companies_By_PkArgs = {
  company_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Companies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Companies_Stream_Cursor_Input>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


export type Subscription_RootUser_Company_RolesArgs = {
  distinct_on?: Maybe<Array<User_Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Roles_Order_By>>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Company_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Roles_Order_By>>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Company_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type Subscription_RootUser_Company_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Company_Roles_Stream_Cursor_Input>>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Company_StatesArgs = {
  distinct_on?: Maybe<Array<User_Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_States_Order_By>>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};


export type Subscription_RootUser_Company_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_States_Order_By>>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};


export type Subscription_RootUser_Company_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Subscription_RootUser_Company_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Company_States_Stream_Cursor_Input>>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};


export type Subscription_RootUser_StatesArgs = {
  distinct_on?: Maybe<Array<User_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_States_Order_By>>;
  where?: Maybe<User_States_Bool_Exp>;
};


export type Subscription_RootUser_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_States_Order_By>>;
  where?: Maybe<User_States_Bool_Exp>;
};


export type Subscription_RootUser_States_By_PkArgs = {
  state: Scalars['String'];
};


export type Subscription_RootUser_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_States_Stream_Cursor_Input>>;
  where?: Maybe<User_States_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Users_Stream_Cursor_Input>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootValidation_TokensArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


export type Subscription_RootValidation_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


export type Subscription_RootValidation_Tokens_By_PkArgs = {
  token: Scalars['String'];
};


export type Subscription_RootValidation_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Validation_Tokens_Stream_Cursor_Input>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};

/** columns and relationships of "text_contexts" */
export type Text_Contexts = {
  __typename?: 'text_contexts';
  id: Scalars['uuid'];
  original_language: Languages_Enum;
  original_text: Scalars['String'];
};

/** aggregated selection of "text_contexts" */
export type Text_Contexts_Aggregate = {
  __typename?: 'text_contexts_aggregate';
  aggregate?: Maybe<Text_Contexts_Aggregate_Fields>;
  nodes: Array<Text_Contexts>;
};

export type Text_Contexts_Aggregate_Bool_Exp = {
  count?: Maybe<Text_Contexts_Aggregate_Bool_Exp_Count>;
};

export type Text_Contexts_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Text_Contexts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Text_Contexts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "text_contexts" */
export type Text_Contexts_Aggregate_Fields = {
  __typename?: 'text_contexts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Text_Contexts_Max_Fields>;
  min?: Maybe<Text_Contexts_Min_Fields>;
};


/** aggregate fields of "text_contexts" */
export type Text_Contexts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Text_Contexts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "text_contexts" */
export type Text_Contexts_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Text_Contexts_Max_Order_By>;
  min?: Maybe<Text_Contexts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "text_contexts" */
export type Text_Contexts_Arr_Rel_Insert_Input = {
  data: Array<Text_Contexts_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Text_Contexts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "text_contexts". All fields are combined with a logical 'AND'. */
export type Text_Contexts_Bool_Exp = {
  _and?: Maybe<Array<Text_Contexts_Bool_Exp>>;
  _not?: Maybe<Text_Contexts_Bool_Exp>;
  _or?: Maybe<Array<Text_Contexts_Bool_Exp>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  original_language?: Maybe<Languages_Enum_Comparison_Exp>;
  original_text?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "text_contexts" */
export enum Text_Contexts_Constraint {
  /** unique or primary key constraint on columns "id" */
  TextContextsPkey = 'text_contexts_pkey'
}

/** input type for inserting data into table "text_contexts" */
export type Text_Contexts_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  original_language?: Maybe<Languages_Enum>;
  original_text?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Text_Contexts_Max_Fields = {
  __typename?: 'text_contexts_max_fields';
  id?: Maybe<Scalars['uuid']>;
  original_text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "text_contexts" */
export type Text_Contexts_Max_Order_By = {
  id?: Maybe<Order_By>;
  original_text?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Text_Contexts_Min_Fields = {
  __typename?: 'text_contexts_min_fields';
  id?: Maybe<Scalars['uuid']>;
  original_text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "text_contexts" */
export type Text_Contexts_Min_Order_By = {
  id?: Maybe<Order_By>;
  original_text?: Maybe<Order_By>;
};

/** response of any mutation on the table "text_contexts" */
export type Text_Contexts_Mutation_Response = {
  __typename?: 'text_contexts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Text_Contexts>;
};

/** input type for inserting object relation for remote table "text_contexts" */
export type Text_Contexts_Obj_Rel_Insert_Input = {
  data: Text_Contexts_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Text_Contexts_On_Conflict>;
};

/** on_conflict condition type for table "text_contexts" */
export type Text_Contexts_On_Conflict = {
  constraint: Text_Contexts_Constraint;
  update_columns?: Array<Text_Contexts_Update_Column>;
  where?: Maybe<Text_Contexts_Bool_Exp>;
};

/** Ordering options when selecting data from "text_contexts". */
export type Text_Contexts_Order_By = {
  id?: Maybe<Order_By>;
  original_language?: Maybe<Order_By>;
  original_text?: Maybe<Order_By>;
};

/** primary key columns input for table: text_contexts */
export type Text_Contexts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "text_contexts" */
export enum Text_Contexts_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OriginalLanguage = 'original_language',
  /** column name */
  OriginalText = 'original_text'
}

/** input type for updating data in table "text_contexts" */
export type Text_Contexts_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  original_language?: Maybe<Languages_Enum>;
  original_text?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "text_contexts" */
export type Text_Contexts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Text_Contexts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Text_Contexts_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  original_language?: Maybe<Languages_Enum>;
  original_text?: Maybe<Scalars['String']>;
};

/** update columns of table "text_contexts" */
export enum Text_Contexts_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OriginalLanguage = 'original_language',
  /** column name */
  OriginalText = 'original_text'
}

export type Text_Contexts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Text_Contexts_Set_Input>;
  where: Text_Contexts_Bool_Exp;
};


/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: Maybe<Scalars['time']>;
  _gt?: Maybe<Scalars['time']>;
  _gte?: Maybe<Scalars['time']>;
  _in?: Maybe<Array<Scalars['time']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['time']>;
  _lte?: Maybe<Scalars['time']>;
  _neq?: Maybe<Scalars['time']>;
  _nin?: Maybe<Array<Scalars['time']>>;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "token_types" */
export type Token_Types = {
  __typename?: 'token_types';
  comment: Scalars['String'];
  /** An array relationship */
  validation_tokens: Array<Validation_Tokens>;
  /** An aggregate relationship */
  validation_tokens_aggregate: Validation_Tokens_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "token_types" */
export type Token_TypesValidation_TokensArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


/** columns and relationships of "token_types" */
export type Token_TypesValidation_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};

/** aggregated selection of "token_types" */
export type Token_Types_Aggregate = {
  __typename?: 'token_types_aggregate';
  aggregate?: Maybe<Token_Types_Aggregate_Fields>;
  nodes: Array<Token_Types>;
};

/** aggregate fields of "token_types" */
export type Token_Types_Aggregate_Fields = {
  __typename?: 'token_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Token_Types_Max_Fields>;
  min?: Maybe<Token_Types_Min_Fields>;
};


/** aggregate fields of "token_types" */
export type Token_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Token_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "token_types". All fields are combined with a logical 'AND'. */
export type Token_Types_Bool_Exp = {
  _and?: Maybe<Array<Token_Types_Bool_Exp>>;
  _not?: Maybe<Token_Types_Bool_Exp>;
  _or?: Maybe<Array<Token_Types_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  validation_tokens?: Maybe<Validation_Tokens_Bool_Exp>;
  validation_tokens_aggregate?: Maybe<Validation_Tokens_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "token_types" */
export enum Token_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  TokenTypesPkey = 'token_types_pkey'
}

export enum Token_Types_Enum {
  /** email_change */
  EmailChange = 'email_change',
  /** email_validation */
  EmailValidation = 'email_validation',
  /** password_change */
  PasswordChange = 'password_change',
  /** password_reset */
  PasswordReset = 'password_reset'
}

/** Boolean expression to compare columns of type "token_types_enum". All fields are combined with logical 'AND'. */
export type Token_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Token_Types_Enum>;
  _in?: Maybe<Array<Token_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Token_Types_Enum>;
  _nin?: Maybe<Array<Token_Types_Enum>>;
};

/** input type for inserting data into table "token_types" */
export type Token_Types_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  validation_tokens?: Maybe<Validation_Tokens_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Token_Types_Max_Fields = {
  __typename?: 'token_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Token_Types_Min_Fields = {
  __typename?: 'token_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "token_types" */
export type Token_Types_Mutation_Response = {
  __typename?: 'token_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Token_Types>;
};

/** input type for inserting object relation for remote table "token_types" */
export type Token_Types_Obj_Rel_Insert_Input = {
  data: Token_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Token_Types_On_Conflict>;
};

/** on_conflict condition type for table "token_types" */
export type Token_Types_On_Conflict = {
  constraint: Token_Types_Constraint;
  update_columns?: Array<Token_Types_Update_Column>;
  where?: Maybe<Token_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "token_types". */
export type Token_Types_Order_By = {
  comment?: Maybe<Order_By>;
  validation_tokens_aggregate?: Maybe<Validation_Tokens_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: token_types */
export type Token_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "token_types" */
export enum Token_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "token_types" */
export type Token_Types_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "token_types" */
export type Token_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Token_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Token_Types_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "token_types" */
export enum Token_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Token_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Token_Types_Set_Input>;
  where: Token_Types_Bool_Exp;
};

/** columns and relationships of "translations" */
export type Translations = {
  __typename?: 'translations';
  language_id: Scalars['uuid'];
  text_context_id: Scalars['uuid'];
  translation: Scalars['String'];
};

/** aggregated selection of "translations" */
export type Translations_Aggregate = {
  __typename?: 'translations_aggregate';
  aggregate?: Maybe<Translations_Aggregate_Fields>;
  nodes: Array<Translations>;
};

/** aggregate fields of "translations" */
export type Translations_Aggregate_Fields = {
  __typename?: 'translations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Translations_Max_Fields>;
  min?: Maybe<Translations_Min_Fields>;
};


/** aggregate fields of "translations" */
export type Translations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Translations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "translations". All fields are combined with a logical 'AND'. */
export type Translations_Bool_Exp = {
  _and?: Maybe<Array<Translations_Bool_Exp>>;
  _not?: Maybe<Translations_Bool_Exp>;
  _or?: Maybe<Array<Translations_Bool_Exp>>;
  language_id?: Maybe<Uuid_Comparison_Exp>;
  text_context_id?: Maybe<Uuid_Comparison_Exp>;
  translation?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "translations" */
export enum Translations_Constraint {
  /** unique or primary key constraint on columns "language_id", "text_context_id" */
  TranslationsPkey = 'translations_pkey'
}

/** input type for inserting data into table "translations" */
export type Translations_Insert_Input = {
  language_id?: Maybe<Scalars['uuid']>;
  text_context_id?: Maybe<Scalars['uuid']>;
  translation?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Translations_Max_Fields = {
  __typename?: 'translations_max_fields';
  language_id?: Maybe<Scalars['uuid']>;
  text_context_id?: Maybe<Scalars['uuid']>;
  translation?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Translations_Min_Fields = {
  __typename?: 'translations_min_fields';
  language_id?: Maybe<Scalars['uuid']>;
  text_context_id?: Maybe<Scalars['uuid']>;
  translation?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "translations" */
export type Translations_Mutation_Response = {
  __typename?: 'translations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Translations>;
};

/** on_conflict condition type for table "translations" */
export type Translations_On_Conflict = {
  constraint: Translations_Constraint;
  update_columns?: Array<Translations_Update_Column>;
  where?: Maybe<Translations_Bool_Exp>;
};

/** Ordering options when selecting data from "translations". */
export type Translations_Order_By = {
  language_id?: Maybe<Order_By>;
  text_context_id?: Maybe<Order_By>;
  translation?: Maybe<Order_By>;
};

/** primary key columns input for table: translations */
export type Translations_Pk_Columns_Input = {
  language_id: Scalars['uuid'];
  text_context_id: Scalars['uuid'];
};

/** select columns of table "translations" */
export enum Translations_Select_Column {
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  TextContextId = 'text_context_id',
  /** column name */
  Translation = 'translation'
}

/** input type for updating data in table "translations" */
export type Translations_Set_Input = {
  language_id?: Maybe<Scalars['uuid']>;
  text_context_id?: Maybe<Scalars['uuid']>;
  translation?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "translations" */
export type Translations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Translations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Translations_Stream_Cursor_Value_Input = {
  language_id?: Maybe<Scalars['uuid']>;
  text_context_id?: Maybe<Scalars['uuid']>;
  translation?: Maybe<Scalars['String']>;
};

/** update columns of table "translations" */
export enum Translations_Update_Column {
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  TextContextId = 'text_context_id',
  /** column name */
  Translation = 'translation'
}

export type Translations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Translations_Set_Input>;
  where: Translations_Bool_Exp;
};

export type UserCompanyData = {
  company_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  legal_representative?: Maybe<Scalars['Boolean']>;
  see_settings: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  user?: Maybe<UserData>;
};

/** columns and relationships of "user_companies" */
export type User_Companies = {
  __typename?: 'user_companies';
  /** An object relationship */
  company: Companies;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  legal_representative?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  role: User_Company_Roles_Enum;
  state: User_Company_States_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  user_company_role: User_Company_Roles;
  /** An object relationship */
  user_company_state: User_Company_States;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_companies" */
export type User_Companies_Aggregate = {
  __typename?: 'user_companies_aggregate';
  aggregate?: Maybe<User_Companies_Aggregate_Fields>;
  nodes: Array<User_Companies>;
};

export type User_Companies_Aggregate_Bool_Exp = {
  bool_and?: Maybe<User_Companies_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<User_Companies_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<User_Companies_Aggregate_Bool_Exp_Count>;
};

export type User_Companies_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Companies_Select_Column_User_Companies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Companies_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Companies_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Companies_Select_Column_User_Companies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Companies_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Companies_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Companies_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Companies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_companies" */
export type User_Companies_Aggregate_Fields = {
  __typename?: 'user_companies_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Companies_Max_Fields>;
  min?: Maybe<User_Companies_Min_Fields>;
};


/** aggregate fields of "user_companies" */
export type User_Companies_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Companies_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_companies" */
export type User_Companies_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Companies_Max_Order_By>;
  min?: Maybe<User_Companies_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_companies" */
export type User_Companies_Arr_Rel_Insert_Input = {
  data: Array<User_Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Companies_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_companies". All fields are combined with a logical 'AND'. */
export type User_Companies_Bool_Exp = {
  _and?: Maybe<Array<User_Companies_Bool_Exp>>;
  _not?: Maybe<User_Companies_Bool_Exp>;
  _or?: Maybe<Array<User_Companies_Bool_Exp>>;
  company?: Maybe<Companies_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  legal_representative?: Maybe<Boolean_Comparison_Exp>;
  password?: Maybe<String_Comparison_Exp>;
  role?: Maybe<User_Company_Roles_Enum_Comparison_Exp>;
  state?: Maybe<User_Company_States_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_company_role?: Maybe<User_Company_Roles_Bool_Exp>;
  user_company_state?: Maybe<User_Company_States_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_companies" */
export enum User_Companies_Constraint {
  /** unique or primary key constraint on columns "user_id", "company_id" */
  UserCompaniesPkey = 'user_companies_pkey'
}

/** input type for inserting data into table "user_companies" */
export type User_Companies_Insert_Input = {
  company?: Maybe<Companies_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  legal_representative?: Maybe<Scalars['Boolean']>;
  see_settings?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<User_Company_Roles_Enum>;
  state?: Maybe<User_Company_States_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_company_role?: Maybe<User_Company_Roles_Obj_Rel_Insert_Input>;
  user_company_state?: Maybe<User_Company_States_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Companies_Max_Fields = {
  __typename?: 'user_companies_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_companies" */
export type User_Companies_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Companies_Min_Fields = {
  __typename?: 'user_companies_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_companies" */
export type User_Companies_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_companies" */
export type User_Companies_Mutation_Response = {
  __typename?: 'user_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Companies>;
};

/** on_conflict condition type for table "user_companies" */
export type User_Companies_On_Conflict = {
  constraint: User_Companies_Constraint;
  update_columns?: Array<User_Companies_Update_Column>;
  where?: Maybe<User_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "user_companies". */
export type User_Companies_Order_By = {
  company?: Maybe<Companies_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  legal_representative?: Maybe<Order_By>;
  password?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_company_role?: Maybe<User_Company_Roles_Order_By>;
  user_company_state?: Maybe<User_Company_States_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_companies */
export type User_Companies_Pk_Columns_Input = {
  company_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "user_companies" */
export enum User_Companies_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  LegalRepresentative = 'legal_representative',
  /** column name */
  Password = 'password',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_companies_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_companies" */
export enum User_Companies_Select_Column_User_Companies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  LegalRepresentative = 'legal_representative'
}

/** select "user_companies_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_companies" */
export enum User_Companies_Select_Column_User_Companies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  LegalRepresentative = 'legal_representative'
}

/** input type for updating data in table "user_companies" */
export type User_Companies_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  legal_representative?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<User_Company_Roles_Enum>;
  state?: Maybe<User_Company_States_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_companies" */
export type User_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Companies_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  legal_representative?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<User_Company_Roles_Enum>;
  state?: Maybe<User_Company_States_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_companies" */
export enum User_Companies_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  LegalRepresentative = 'legal_representative',
  /** column name */
  Password = 'password',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Companies_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Companies_Set_Input>;
  where: User_Companies_Bool_Exp;
};

/** columns and relationships of "user_company_roles" */
export type User_Company_Roles = {
  __typename?: 'user_company_roles';
  comment: Scalars['String'];
  role: Scalars['String'];
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
};


/** columns and relationships of "user_company_roles" */
export type User_Company_RolesUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


/** columns and relationships of "user_company_roles" */
export type User_Company_RolesUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};

/** aggregated selection of "user_company_roles" */
export type User_Company_Roles_Aggregate = {
  __typename?: 'user_company_roles_aggregate';
  aggregate?: Maybe<User_Company_Roles_Aggregate_Fields>;
  nodes: Array<User_Company_Roles>;
};

/** aggregate fields of "user_company_roles" */
export type User_Company_Roles_Aggregate_Fields = {
  __typename?: 'user_company_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Company_Roles_Max_Fields>;
  min?: Maybe<User_Company_Roles_Min_Fields>;
};


/** aggregate fields of "user_company_roles" */
export type User_Company_Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Company_Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_company_roles". All fields are combined with a logical 'AND'. */
export type User_Company_Roles_Bool_Exp = {
  _and?: Maybe<Array<User_Company_Roles_Bool_Exp>>;
  _not?: Maybe<User_Company_Roles_Bool_Exp>;
  _or?: Maybe<Array<User_Company_Roles_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  user_companies?: Maybe<User_Companies_Bool_Exp>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_company_roles" */
export enum User_Company_Roles_Constraint {
  /** unique or primary key constraint on columns "role" */
  UserCompanyRolesPkey = 'user_company_roles_pkey'
}

export enum User_Company_Roles_Enum {
  /** blueAdmin */
  BlueAdmin = 'blueAdmin',
  /** blueOperator */
  BlueOperator = 'blueOperator',
  /** green */
  Green = 'green',
  /** redAdmin */
  RedAdmin = 'redAdmin',
  /** redOperator */
  RedOperator = 'redOperator',
  /** yellow */
  Yellow = 'yellow'
}

/** Boolean expression to compare columns of type "user_company_roles_enum". All fields are combined with logical 'AND'. */
export type User_Company_Roles_Enum_Comparison_Exp = {
  _eq?: Maybe<User_Company_Roles_Enum>;
  _in?: Maybe<Array<User_Company_Roles_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<User_Company_Roles_Enum>;
  _nin?: Maybe<Array<User_Company_Roles_Enum>>;
};

/** input type for inserting data into table "user_company_roles" */
export type User_Company_Roles_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_companies?: Maybe<User_Companies_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Company_Roles_Max_Fields = {
  __typename?: 'user_company_roles_max_fields';
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Company_Roles_Min_Fields = {
  __typename?: 'user_company_roles_min_fields';
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_company_roles" */
export type User_Company_Roles_Mutation_Response = {
  __typename?: 'user_company_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Company_Roles>;
};

/** input type for inserting object relation for remote table "user_company_roles" */
export type User_Company_Roles_Obj_Rel_Insert_Input = {
  data: User_Company_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Company_Roles_On_Conflict>;
};

/** on_conflict condition type for table "user_company_roles" */
export type User_Company_Roles_On_Conflict = {
  constraint: User_Company_Roles_Constraint;
  update_columns?: Array<User_Company_Roles_Update_Column>;
  where?: Maybe<User_Company_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_company_roles". */
export type User_Company_Roles_Order_By = {
  comment?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Order_By>;
};

/** primary key columns input for table: user_company_roles */
export type User_Company_Roles_Pk_Columns_Input = {
  role: Scalars['String'];
};

/** select columns of table "user_company_roles" */
export enum User_Company_Roles_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "user_company_roles" */
export type User_Company_Roles_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_company_roles" */
export type User_Company_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Company_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Company_Roles_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** update columns of table "user_company_roles" */
export enum User_Company_Roles_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Role = 'role'
}

export type User_Company_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Company_Roles_Set_Input>;
  where: User_Company_Roles_Bool_Exp;
};

/** columns and relationships of "user_company_states" */
export type User_Company_States = {
  __typename?: 'user_company_states';
  comment: Scalars['String'];
  state: Scalars['String'];
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
};


/** columns and relationships of "user_company_states" */
export type User_Company_StatesUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


/** columns and relationships of "user_company_states" */
export type User_Company_StatesUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};

/** aggregated selection of "user_company_states" */
export type User_Company_States_Aggregate = {
  __typename?: 'user_company_states_aggregate';
  aggregate?: Maybe<User_Company_States_Aggregate_Fields>;
  nodes: Array<User_Company_States>;
};

/** aggregate fields of "user_company_states" */
export type User_Company_States_Aggregate_Fields = {
  __typename?: 'user_company_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Company_States_Max_Fields>;
  min?: Maybe<User_Company_States_Min_Fields>;
};


/** aggregate fields of "user_company_states" */
export type User_Company_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Company_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_company_states". All fields are combined with a logical 'AND'. */
export type User_Company_States_Bool_Exp = {
  _and?: Maybe<Array<User_Company_States_Bool_Exp>>;
  _not?: Maybe<User_Company_States_Bool_Exp>;
  _or?: Maybe<Array<User_Company_States_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  user_companies?: Maybe<User_Companies_Bool_Exp>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_company_states" */
export enum User_Company_States_Constraint {
  /** unique or primary key constraint on columns "state" */
  UserCompanyStatesPkey = 'user_company_states_pkey'
}

export enum User_Company_States_Enum {
  /** active */
  Active = 'active',
  /** disabled */
  Disabled = 'disabled',
  /** registration_pending */
  RegistrationPending = 'registration_pending'
}

/** Boolean expression to compare columns of type "user_company_states_enum". All fields are combined with logical 'AND'. */
export type User_Company_States_Enum_Comparison_Exp = {
  _eq?: Maybe<User_Company_States_Enum>;
  _in?: Maybe<Array<User_Company_States_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<User_Company_States_Enum>;
  _nin?: Maybe<Array<User_Company_States_Enum>>;
};

/** input type for inserting data into table "user_company_states" */
export type User_Company_States_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  user_companies?: Maybe<User_Companies_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Company_States_Max_Fields = {
  __typename?: 'user_company_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Company_States_Min_Fields = {
  __typename?: 'user_company_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_company_states" */
export type User_Company_States_Mutation_Response = {
  __typename?: 'user_company_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Company_States>;
};

/** input type for inserting object relation for remote table "user_company_states" */
export type User_Company_States_Obj_Rel_Insert_Input = {
  data: User_Company_States_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Company_States_On_Conflict>;
};

/** on_conflict condition type for table "user_company_states" */
export type User_Company_States_On_Conflict = {
  constraint: User_Company_States_Constraint;
  update_columns?: Array<User_Company_States_Update_Column>;
  where?: Maybe<User_Company_States_Bool_Exp>;
};

/** Ordering options when selecting data from "user_company_states". */
export type User_Company_States_Order_By = {
  comment?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Order_By>;
};

/** primary key columns input for table: user_company_states */
export type User_Company_States_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "user_company_states" */
export enum User_Company_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "user_company_states" */
export type User_Company_States_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_company_states" */
export type User_Company_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Company_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Company_States_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "user_company_states" */
export enum User_Company_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

export type User_Company_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Company_States_Set_Input>;
  where: User_Company_States_Bool_Exp;
};

/** columns and relationships of "user_states" */
export type User_States = {
  __typename?: 'user_states';
  comment: Scalars['String'];
  state: Scalars['String'];
};

/** aggregated selection of "user_states" */
export type User_States_Aggregate = {
  __typename?: 'user_states_aggregate';
  aggregate?: Maybe<User_States_Aggregate_Fields>;
  nodes: Array<User_States>;
};

/** aggregate fields of "user_states" */
export type User_States_Aggregate_Fields = {
  __typename?: 'user_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_States_Max_Fields>;
  min?: Maybe<User_States_Min_Fields>;
};


/** aggregate fields of "user_states" */
export type User_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_states". All fields are combined with a logical 'AND'. */
export type User_States_Bool_Exp = {
  _and?: Maybe<Array<User_States_Bool_Exp>>;
  _not?: Maybe<User_States_Bool_Exp>;
  _or?: Maybe<Array<User_States_Bool_Exp>>;
  comment?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_states" */
export enum User_States_Constraint {
  /** unique or primary key constraint on columns "state" */
  UserStatePkey = 'user_state_pkey'
}

/** input type for inserting data into table "user_states" */
export type User_States_Insert_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_States_Max_Fields = {
  __typename?: 'user_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_States_Min_Fields = {
  __typename?: 'user_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_states" */
export type User_States_Mutation_Response = {
  __typename?: 'user_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_States>;
};

/** on_conflict condition type for table "user_states" */
export type User_States_On_Conflict = {
  constraint: User_States_Constraint;
  update_columns?: Array<User_States_Update_Column>;
  where?: Maybe<User_States_Bool_Exp>;
};

/** Ordering options when selecting data from "user_states". */
export type User_States_Order_By = {
  comment?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
};

/** primary key columns input for table: user_states */
export type User_States_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "user_states" */
export enum User_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "user_states" */
export type User_States_Set_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_states" */
export type User_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_States_Stream_Cursor_Value_Input = {
  comment?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "user_states" */
export enum User_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  State = 'state'
}

export type User_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_States_Set_Input>;
  where: User_States_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  birth_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  companies: Array<Companies>;
  /** An aggregate relationship */
  companies_aggregate: Companies_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: Documents_Aggregate;
  /** An array relationship */
  event_users: Array<Event_Users>;
  /** An aggregate relationship */
  event_users_aggregate: Event_Users_Aggregate;
  /** An array relationship */
  firebase_tokens: Array<Firebase_Tokens>;
  /** An aggregate relationship */
  firebase_tokens_aggregate: Firebase_Tokens_Aggregate;
  fiscal_code: Scalars['String'];
  id: Scalars['uuid'];
  last_access?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate;
  sex?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_companies: Array<User_Companies>;
  /** An aggregate relationship */
  user_companies_aggregate: User_Companies_Aggregate;
  /** An array relationship */
  validation_tokens: Array<Validation_Tokens>;
  /** An aggregate relationship */
  validation_tokens_aggregate: Validation_Tokens_Aggregate;
};


/** columns and relationships of "users" */
export type UsersCompaniesArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Companies_Order_By>>;
  where?: Maybe<Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocumentsArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Documents_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Documents_Order_By>>;
  where?: Maybe<Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEvent_UsersArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEvent_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Event_Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Event_Users_Order_By>>;
  where?: Maybe<Event_Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFirebase_TokensArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFirebase_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Firebase_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Firebase_Tokens_Order_By>>;
  where?: Maybe<Firebase_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefresh_TokensArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRefresh_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Refresh_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Refresh_Tokens_Order_By>>;
  where?: Maybe<Refresh_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_CompaniesArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Companies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Companies_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Companies_Order_By>>;
  where?: Maybe<User_Companies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersValidation_TokensArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersValidation_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Validation_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Validation_Tokens_Order_By>>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Users_Bool_Exp>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Users_Bool_Exp>>;
  birth_date?: Maybe<Date_Comparison_Exp>;
  companies?: Maybe<Companies_Bool_Exp>;
  companies_aggregate?: Maybe<Companies_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  documents?: Maybe<Documents_Bool_Exp>;
  documents_aggregate?: Maybe<Documents_Aggregate_Bool_Exp>;
  event_users?: Maybe<Event_Users_Bool_Exp>;
  event_users_aggregate?: Maybe<Event_Users_Aggregate_Bool_Exp>;
  firebase_tokens?: Maybe<Firebase_Tokens_Bool_Exp>;
  firebase_tokens_aggregate?: Maybe<Firebase_Tokens_Aggregate_Bool_Exp>;
  fiscal_code?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last_access?: Maybe<Timestamptz_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  profile_picture?: Maybe<String_Comparison_Exp>;
  refresh_tokens?: Maybe<Refresh_Tokens_Bool_Exp>;
  refresh_tokens_aggregate?: Maybe<Refresh_Tokens_Aggregate_Bool_Exp>;
  sex?: Maybe<String_Comparison_Exp>;
  surname?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_companies?: Maybe<User_Companies_Bool_Exp>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Bool_Exp>;
  validation_tokens?: Maybe<Validation_Tokens_Bool_Exp>;
  validation_tokens_aggregate?: Maybe<Validation_Tokens_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  birth_date?: Maybe<Scalars['date']>;
  companies?: Maybe<Companies_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  documents?: Maybe<Documents_Arr_Rel_Insert_Input>;
  event_users?: Maybe<Event_Users_Arr_Rel_Insert_Input>;
  firebase_tokens?: Maybe<Firebase_Tokens_Arr_Rel_Insert_Input>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_access?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<Refresh_Tokens_Arr_Rel_Insert_Input>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_companies?: Maybe<User_Companies_Arr_Rel_Insert_Input>;
  validation_tokens?: Maybe<Validation_Tokens_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  birth_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_access?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  birth_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_access?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  birth_date?: Maybe<Order_By>;
  companies_aggregate?: Maybe<Companies_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Documents_Aggregate_Order_By>;
  event_users_aggregate?: Maybe<Event_Users_Aggregate_Order_By>;
  firebase_tokens_aggregate?: Maybe<Firebase_Tokens_Aggregate_Order_By>;
  fiscal_code?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last_access?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  profile_picture?: Maybe<Order_By>;
  refresh_tokens_aggregate?: Maybe<Refresh_Tokens_Aggregate_Order_By>;
  sex?: Maybe<Order_By>;
  surname?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_companies_aggregate?: Maybe<User_Companies_Aggregate_Order_By>;
  validation_tokens_aggregate?: Maybe<Validation_Tokens_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalCode = 'fiscal_code',
  /** column name */
  Id = 'id',
  /** column name */
  LastAccess = 'last_access',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Sex = 'sex',
  /** column name */
  Surname = 'surname',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  birth_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_access?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  birth_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_access?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalCode = 'fiscal_code',
  /** column name */
  Id = 'id',
  /** column name */
  LastAccess = 'last_access',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Sex = 'sex',
  /** column name */
  Surname = 'surname',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "validation_tokens" */
export type Validation_Tokens = {
  __typename?: 'validation_tokens';
  created_at: Scalars['timestamptz'];
  expires_at?: Maybe<Scalars['timestamptz']>;
  token: Scalars['String'];
  /** An object relationship */
  token_type_value: Token_Types;
  type: Token_Types_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "validation_tokens" */
export type Validation_Tokens_Aggregate = {
  __typename?: 'validation_tokens_aggregate';
  aggregate?: Maybe<Validation_Tokens_Aggregate_Fields>;
  nodes: Array<Validation_Tokens>;
};

export type Validation_Tokens_Aggregate_Bool_Exp = {
  count?: Maybe<Validation_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Validation_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Validation_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Validation_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "validation_tokens" */
export type Validation_Tokens_Aggregate_Fields = {
  __typename?: 'validation_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Validation_Tokens_Max_Fields>;
  min?: Maybe<Validation_Tokens_Min_Fields>;
};


/** aggregate fields of "validation_tokens" */
export type Validation_Tokens_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Validation_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "validation_tokens" */
export type Validation_Tokens_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Validation_Tokens_Max_Order_By>;
  min?: Maybe<Validation_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "validation_tokens" */
export type Validation_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Validation_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Validation_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "validation_tokens". All fields are combined with a logical 'AND'. */
export type Validation_Tokens_Bool_Exp = {
  _and?: Maybe<Array<Validation_Tokens_Bool_Exp>>;
  _not?: Maybe<Validation_Tokens_Bool_Exp>;
  _or?: Maybe<Array<Validation_Tokens_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  expires_at?: Maybe<Timestamptz_Comparison_Exp>;
  token?: Maybe<String_Comparison_Exp>;
  token_type_value?: Maybe<Token_Types_Bool_Exp>;
  type?: Maybe<Token_Types_Enum_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "validation_tokens" */
export enum Validation_Tokens_Constraint {
  /** unique or primary key constraint on columns "token" */
  ValidationTokensPkey = 'validation_tokens_pkey'
}

/** input type for inserting data into table "validation_tokens" */
export type Validation_Tokens_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  token_type_value?: Maybe<Token_Types_Obj_Rel_Insert_Input>;
  type?: Maybe<Token_Types_Enum>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Validation_Tokens_Max_Fields = {
  __typename?: 'validation_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "validation_tokens" */
export type Validation_Tokens_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Validation_Tokens_Min_Fields = {
  __typename?: 'validation_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "validation_tokens" */
export type Validation_Tokens_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "validation_tokens" */
export type Validation_Tokens_Mutation_Response = {
  __typename?: 'validation_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Validation_Tokens>;
};

/** on_conflict condition type for table "validation_tokens" */
export type Validation_Tokens_On_Conflict = {
  constraint: Validation_Tokens_Constraint;
  update_columns?: Array<Validation_Tokens_Update_Column>;
  where?: Maybe<Validation_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "validation_tokens". */
export type Validation_Tokens_Order_By = {
  created_at?: Maybe<Order_By>;
  expires_at?: Maybe<Order_By>;
  token?: Maybe<Order_By>;
  token_type_value?: Maybe<Token_Types_Order_By>;
  type?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: validation_tokens */
export type Validation_Tokens_Pk_Columns_Input = {
  token: Scalars['String'];
};

/** select columns of table "validation_tokens" */
export enum Validation_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "validation_tokens" */
export type Validation_Tokens_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Token_Types_Enum>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "validation_tokens" */
export type Validation_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Validation_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Validation_Tokens_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Token_Types_Enum>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "validation_tokens" */
export enum Validation_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Validation_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Validation_Tokens_Set_Input>;
  where: Validation_Tokens_Bool_Exp;
};

export type ResetPasswordQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordQuery = (
  { __typename?: 'query_root' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordOutput' }
    & Pick<ResetPasswordOutput, 'success'>
  )> }
);

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'mutation_root' }
  & { changePassword?: Maybe<(
    { __typename?: 'ChangePasswordOutput' }
    & Pick<ChangePasswordOutput, 'success'>
  )> }
);

export type GetCompaniesQueryVariables = Exact<{
  _neq?: Maybe<Scalars['uuid']>;
}>;


export type GetCompaniesQuery = (
  { __typename?: 'query_root' }
  & { companies: Array<(
    { __typename?: 'companies' }
    & Pick<Companies, 'ateco_code' | 'company_role' | 'company_state' | 'email' | 'fiscal_code' | 'id' | 'logo' | 'name' | 'pec' | 'phone' | 'vat' | 'website'>
    & { address: (
      { __typename?: 'addresses' }
      & Pick<Addresses, 'city' | 'country' | 'house_number' | 'id' | 'province' | 'street' | 'zip'>
    ), company_category?: Maybe<(
      { __typename?: 'company_categories' }
      & Pick<Company_Categories, 'id'>
      & { name: (
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      ) }
    )>, company_sector?: Maybe<(
      { __typename?: 'company_sector' }
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_language'>
      )> }
    )>, user_companies: Array<(
      { __typename?: 'user_companies' }
      & Pick<User_Companies, 'role' | 'state' | 'email'>
      & { user: (
        { __typename?: 'users' }
        & Pick<Users, 'birth_date' | 'id' | 'fiscal_code' | 'name' | 'phone' | 'profile_picture' | 'sex' | 'surname'>
      ) }
    )>, documents: Array<(
      { __typename?: 'documents' }
      & Pick<Documents, 'expires_at' | 'file_link' | 'id' | 'title' | 'state'>
      & { user?: Maybe<(
        { __typename?: 'users' }
        & Pick<Users, 'name' | 'surname' | 'fiscal_code'>
        & { user_companies: Array<(
          { __typename?: 'user_companies' }
          & Pick<User_Companies, 'legal_representative'>
        )> }
      )>, document_type: (
        { __typename?: 'document_types' }
        & Pick<Document_Types, 'mandatory'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )>, document_category: (
          { __typename?: 'document_categories' }
          & { name?: Maybe<(
            { __typename?: 'text_contexts' }
            & Pick<Text_Contexts, 'original_text'>
          )> }
        ) }
      ) }
    )>, legal_representative_user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'birth_date' | 'fiscal_code' | 'id' | 'name' | 'phone' | 'profile_picture' | 'sex' | 'surname'>
      & { user_companies: Array<(
        { __typename?: 'user_companies' }
        & Pick<User_Companies, 'email' | 'role' | 'state'>
      )> }
    )> }
  )> }
);

export type GetCompanyByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCompanyByIdQuery = (
  { __typename?: 'query_root' }
  & { companies_by_pk?: Maybe<(
    { __typename?: 'companies' }
    & Pick<Companies, 'ateco_code' | 'company_role' | 'company_state' | 'email' | 'fiscal_code' | 'id' | 'logo' | 'name' | 'pec' | 'phone' | 'vat' | 'website'>
    & { address: (
      { __typename?: 'addresses' }
      & Pick<Addresses, 'city' | 'country' | 'house_number' | 'id' | 'province' | 'street' | 'zip'>
    ), company_category?: Maybe<(
      { __typename?: 'company_categories' }
      & { name: (
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      ) }
    )>, company_sector?: Maybe<(
      { __typename?: 'company_sector' }
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      )> }
    )>, user_companies: Array<(
      { __typename?: 'user_companies' }
      & Pick<User_Companies, 'role' | 'state' | 'email'>
      & { user: (
        { __typename?: 'users' }
        & Pick<Users, 'birth_date' | 'id' | 'fiscal_code' | 'name' | 'phone' | 'profile_picture' | 'sex' | 'surname'>
      ) }
    )> }
  )> }
);

export type GetCompanyCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyCategoriesQuery = (
  { __typename?: 'query_root' }
  & { company_categories: Array<(
    { __typename?: 'company_categories' }
    & Pick<Company_Categories, 'id'>
    & { description: (
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    ), name: (
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    ) }
  )> }
);

export type RegisterCompanyMutationVariables = Exact<{
  company: CompanyData;
  user: UserData;
  user_company: UserCompanyData;
  dipendenti?: Maybe<DipendentiData>;
  dipendentiList?: Maybe<Array<Maybe<DipendentiData>> | Maybe<DipendentiData>>;
  documentList?: Maybe<Array<Maybe<DocumentData>> | Maybe<DocumentData>>;
}>;


export type RegisterCompanyMutation = (
  { __typename?: 'mutation_root' }
  & { registerCompany?: Maybe<(
    { __typename?: 'RegisterCompanyOutput' }
    & Pick<RegisterCompanyOutput, 'data' | 'success'>
  )> }
);

export type InsertCompanyOneMutationVariables = Exact<{
  object: Companies_Insert_Input;
}>;


export type InsertCompanyOneMutation = (
  { __typename?: 'mutation_root' }
  & { insert_companies_one?: Maybe<(
    { __typename?: 'companies' }
    & Pick<Companies, 'id'>
  )> }
);

export type RegisterBlueCompanyMutationVariables = Exact<{
  data: CompanyData;
}>;


export type RegisterBlueCompanyMutation = (
  { __typename?: 'mutation_root' }
  & { registerBlueCompany?: Maybe<(
    { __typename?: 'RegisterCompanyOutput' }
    & Pick<RegisterCompanyOutput, 'data'>
  )> }
);

export type GetCourseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseCategoriesQuery = (
  { __typename?: 'query_root' }
  & { course_categories: Array<(
    { __typename?: 'course_categories' }
    & Pick<Course_Categories, 'id'>
    & { description?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )>, name?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )> }
  )> }
);

export type InsertCourseCategoryMutationVariables = Exact<{
  object: Course_Categories_Insert_Input;
}>;


export type InsertCourseCategoryMutation = (
  { __typename?: 'mutation_root' }
  & { insert_course_categories_one?: Maybe<(
    { __typename?: 'course_categories' }
    & Pick<Course_Categories, 'id'>
  )> }
);

export type GetCourseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseTypesQuery = (
  { __typename?: 'query_root' }
  & { course_types: Array<(
    { __typename?: 'course_types' }
    & Pick<Course_Types, 'id' | 'category_id'>
    & { category: (
      { __typename?: 'course_categories' }
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text' | 'id'>
      )> }
    ), description?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )>, name?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )> }
  )> }
);

export type InsertCourseTypeMutationVariables = Exact<{
  object: Course_Types_Insert_Input;
}>;


export type InsertCourseTypeMutation = (
  { __typename?: 'mutation_root' }
  & { insert_course_types_one?: Maybe<(
    { __typename?: 'course_types' }
    & Pick<Course_Types, 'id'>
  )> }
);

export type UpdateCourseTypeMutationVariables = Exact<{
  id: Scalars['uuid'];
  category_id: Scalars['uuid'];
  aggiornamento: Scalars['Int'];
  durata: Scalars['Int'];
}>;


export type UpdateCourseTypeMutation = (
  { __typename?: 'mutation_root' }
  & { update_course_types_by_pk?: Maybe<(
    { __typename?: 'course_types' }
    & Pick<Course_Types, 'id'>
  )> }
);

export type GetInPartenzaCourseEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInPartenzaCourseEventsQuery = (
  { __typename?: 'query_root' }
  & { course_events: Array<(
    { __typename?: 'course_events' }
    & Pick<Course_Events, 'start_date' | 'end_date' | 'id'>
    & { course: (
      { __typename?: 'courses' }
      & Pick<Courses, 'id'>
      & { description?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      )>, name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      )>, type: (
        { __typename?: 'course_types' }
        & Pick<Course_Types, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'id' | 'original_text'>
        )>, category: (
          { __typename?: 'course_categories' }
          & Pick<Course_Categories, 'id'>
          & { name?: Maybe<(
            { __typename?: 'text_contexts' }
            & Pick<Text_Contexts, 'original_text'>
          )> }
        ) }
      ) }
    ), course_event_state?: Maybe<(
      { __typename?: 'course_event_state' }
      & { state: (
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      ) }
    )> }
  )> }
);

export type GetArchivioCourseEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArchivioCourseEventsQuery = (
  { __typename?: 'query_root' }
  & { course_events: Array<(
    { __typename?: 'course_events' }
    & Pick<Course_Events, 'start_date' | 'end_date' | 'id'>
    & { course: (
      { __typename?: 'courses' }
      & Pick<Courses, 'id'>
      & { description?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      )>, name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      )>, type: (
        { __typename?: 'course_types' }
        & Pick<Course_Types, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'id' | 'original_text'>
        )>, category: (
          { __typename?: 'course_categories' }
          & Pick<Course_Categories, 'id'>
          & { name?: Maybe<(
            { __typename?: 'text_contexts' }
            & Pick<Text_Contexts, 'original_text'>
          )> }
        ) }
      ) }
    ), course_event_state?: Maybe<(
      { __typename?: 'course_event_state' }
      & { state: (
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'id' | 'original_text'>
      ) }
    )> }
  )> }
);

export type InsertCourseEventsMutationVariables = Exact<{
  object: Course_Events_Insert_Input;
}>;


export type InsertCourseEventsMutation = (
  { __typename?: 'mutation_root' }
  & { insert_course_events_one?: Maybe<(
    { __typename?: 'course_events' }
    & Pick<Course_Events, 'id'>
  )> }
);

export type DeleteCourseMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteCourseMutation = (
  { __typename?: 'mutation_root' }
  & { delete_courses_by_pk?: Maybe<(
    { __typename?: 'courses' }
    & Pick<Courses, 'id'>
  )> }
);

export type GetDocumentCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentCategoriesQuery = (
  { __typename?: 'query_root' }
  & { document_categories: Array<(
    { __typename?: 'document_categories' }
    & Pick<Document_Categories, 'id'>
    & { description?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )>, name?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )> }
  )> }
);

export type InsertDocumentCategoryMutationVariables = Exact<{
  object: Document_Categories_Insert_Input;
}>;


export type InsertDocumentCategoryMutation = (
  { __typename?: 'mutation_root' }
  & { insert_document_categories_one?: Maybe<(
    { __typename?: 'document_categories' }
    & Pick<Document_Categories, 'id'>
  )> }
);

export type GetDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentTypesQuery = (
  { __typename?: 'query_root' }
  & { document_types: Array<(
    { __typename?: 'document_types' }
    & Pick<Document_Types, 'id' | 'category_id' | 'mandatory' | 'notify_frequency' | 'start_notif_brefore_expire'>
    & { document_category: (
      { __typename?: 'document_categories' }
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text' | 'id'>
      )> }
    ), description?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )>, name?: Maybe<(
      { __typename?: 'text_contexts' }
      & Pick<Text_Contexts, 'id' | 'original_text'>
    )> }
  )> }
);

export type InsertDocumentTypeMutationVariables = Exact<{
  object: Document_Types_Insert_Input;
}>;


export type InsertDocumentTypeMutation = (
  { __typename?: 'mutation_root' }
  & { insert_document_types_one?: Maybe<(
    { __typename?: 'document_types' }
    & Pick<Document_Types, 'id'>
  )> }
);

export type UpdateDocumentTypeMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Document_Types_Set_Input;
}>;


export type UpdateDocumentTypeMutation = (
  { __typename?: 'mutation_root' }
  & { update_document_types_by_pk?: Maybe<(
    { __typename?: 'document_types' }
    & Pick<Document_Types, 'id'>
  )> }
);

export type DeleteDocumentByIdMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteDocumentByIdMutation = (
  { __typename?: 'mutation_root' }
  & { delete_documents_by_pk?: Maybe<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id'>
  )> }
);

export type InsertDocumentsMutationVariables = Exact<{
  objects: Array<Documents_Insert_Input> | Documents_Insert_Input;
}>;


export type InsertDocumentsMutation = (
  { __typename?: 'mutation_root' }
  & { insert_documents?: Maybe<(
    { __typename?: 'documents_mutation_response' }
    & Pick<Documents_Mutation_Response, 'affected_rows'>
  )> }
);

export type GetBlueDocumentsQueryVariables = Exact<{
  company_id: Scalars['uuid'];
}>;


export type GetBlueDocumentsQuery = (
  { __typename?: 'query_root' }
  & { documents: Array<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id' | 'issuer_id' | 'title' | 'file_link' | 'expires_at' | 'state'>
    & { document_type: (
      { __typename?: 'document_types' }
      & Pick<Document_Types, 'id'>
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      )>, document_category: (
        { __typename?: 'document_categories' }
        & Pick<Document_Categories, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )> }
      ) }
    ), company: (
      { __typename?: 'companies' }
      & Pick<Companies, 'id' | 'name' | 'phone' | 'fiscal_code' | 'email'>
    ), user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'fiscal_code' | 'name' | 'phone' | 'surname'>
      & { user_companies: Array<(
        { __typename?: 'user_companies' }
        & Pick<User_Companies, 'email' | 'legal_representative'>
      )> }
    )> }
  )> }
);

export type GetBlueValidDocumentsQueryVariables = Exact<{
  company_id: Scalars['uuid'];
}>;


export type GetBlueValidDocumentsQuery = (
  { __typename?: 'query_root' }
  & { documents: Array<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id' | 'issuer_id' | 'title' | 'file_link' | 'expires_at' | 'state'>
    & { document_type: (
      { __typename?: 'document_types' }
      & Pick<Document_Types, 'id'>
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      )>, document_category: (
        { __typename?: 'document_categories' }
        & Pick<Document_Categories, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )> }
      ) }
    ), company: (
      { __typename?: 'companies' }
      & Pick<Companies, 'id' | 'name' | 'phone' | 'fiscal_code' | 'email'>
    ), user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'fiscal_code' | 'name' | 'phone' | 'surname'>
      & { user_companies: Array<(
        { __typename?: 'user_companies' }
        & Pick<User_Companies, 'email' | 'legal_representative'>
      )> }
    )> }
  )> }
);

export type GetExpiredDocumentsQueryVariables = Exact<{
  _lt?: Maybe<Scalars['date']>;
}>;


export type GetExpiredDocumentsQuery = (
  { __typename?: 'query_root' }
  & { documents: Array<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id' | 'issuer_id' | 'title' | 'file_link' | 'expires_at' | 'state'>
    & { document_type: (
      { __typename?: 'document_types' }
      & Pick<Document_Types, 'id'>
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      )>, document_category: (
        { __typename?: 'document_categories' }
        & Pick<Document_Categories, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )> }
      ) }
    ), company: (
      { __typename?: 'companies' }
      & Pick<Companies, 'id' | 'name' | 'phone' | 'fiscal_code' | 'email'>
    ), user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'fiscal_code' | 'name' | 'phone' | 'surname'>
      & { user_companies: Array<(
        { __typename?: 'user_companies' }
        & Pick<User_Companies, 'email' | 'legal_representative'>
      )> }
    )> }
  )> }
);

export type GetDipendentiDocumentsQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;


export type GetDipendentiDocumentsQuery = (
  { __typename?: 'query_root' }
  & { documents: Array<(
    { __typename?: 'documents' }
    & Pick<Documents, 'company_id' | 'expires_at' | 'file_link' | 'id' | 'state' | 'title' | 'user_id'>
    & { document_type: (
      { __typename?: 'document_types' }
      & { document_category: (
        { __typename?: 'document_categories' }
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )> }
      ), name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      )> }
    ) }
  )> }
);

export type GetExpiredDocumentsByCategoryQueryVariables = Exact<{
  _lt?: Maybe<Scalars['date']>;
  category_id: Scalars['uuid'];
}>;


export type GetExpiredDocumentsByCategoryQuery = (
  { __typename?: 'query_root' }
  & { documents: Array<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id' | 'issuer_id' | 'title' | 'file_link' | 'expires_at' | 'state'>
    & { document_type: (
      { __typename?: 'document_types' }
      & Pick<Document_Types, 'id'>
      & { name?: Maybe<(
        { __typename?: 'text_contexts' }
        & Pick<Text_Contexts, 'original_text'>
      )>, document_category: (
        { __typename?: 'document_categories' }
        & Pick<Document_Categories, 'id'>
        & { name?: Maybe<(
          { __typename?: 'text_contexts' }
          & Pick<Text_Contexts, 'original_text'>
        )> }
      ) }
    ), company: (
      { __typename?: 'companies' }
      & Pick<Companies, 'id' | 'name' | 'phone' | 'fiscal_code' | 'email'>
    ), user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'fiscal_code' | 'name' | 'phone' | 'surname'>
      & { user_companies: Array<(
        { __typename?: 'user_companies' }
        & Pick<User_Companies, 'email' | 'legal_representative'>
      )> }
    )> }
  )> }
);

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Documents_Set_Input;
}>;


export type UpdateDocumentMutation = (
  { __typename?: 'mutation_root' }
  & { update_documents_by_pk?: Maybe<(
    { __typename?: 'documents' }
    & Pick<Documents, 'id'>
  )> }
);

export type GetNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationQuery = (
  { __typename?: 'query_root' }
  & { notification: Array<(
    { __typename?: 'notification' }
    & Pick<Notification, 'uuid' | 'blue_seen' | 'green_seen' | 'red_seen' | 'message' | 'date'>
    & { company: (
      { __typename?: 'companies' }
      & Pick<Companies, 'name'>
    ) }
  )> }
);

export type UpdateNotificationMutationVariables = Exact<{
  uuid: Scalars['uuid'];
  _set?: Maybe<Notification_Set_Input>;
}>;


export type UpdateNotificationMutation = (
  { __typename?: 'mutation_root' }
  & { update_notification_by_pk?: Maybe<(
    { __typename?: 'notification' }
    & Pick<Notification, 'uuid'>
  )> }
);

export type SendNotificationMutationVariables = Exact<{
  company_id: Array<Scalars['String']> | Scalars['String'];
  message: Scalars['String'];
  subject: Scalars['String'];
  to_dipendenti: Scalars['Boolean'];
}>;


export type SendNotificationMutation = (
  { __typename?: 'mutation_root' }
  & { sendNotification?: Maybe<(
    { __typename?: 'ChangePasswordOutput' }
    & Pick<ChangePasswordOutput, 'success'>
  )> }
);

export type UpdateTextContextMutationVariables = Exact<{
  id: Scalars['uuid'];
  original_text: Scalars['String'];
}>;


export type UpdateTextContextMutation = (
  { __typename?: 'mutation_root' }
  & { update_text_contexts_by_pk?: Maybe<(
    { __typename?: 'text_contexts' }
    & Pick<Text_Contexts, 'id'>
  )> }
);

export type DeleteTextContextMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteTextContextMutation = (
  { __typename?: 'mutation_root' }
  & { delete_text_contexts_by_pk?: Maybe<(
    { __typename?: 'text_contexts' }
    & Pick<Text_Contexts, 'id'>
  )> }
);

export type GetUserByIdQueryVariables1 = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserByIdQuery1 = (
  { __typename?: 'query_root' }
  & { users: Array<(
    { __typename?: 'users' }
    & Pick<Users, 'name' | 'surname'>
    & { companies: Array<(
      { __typename?: 'companies' }
      & Pick<Companies, 'logo'>
    )> }
  )> }
);

export type GetUserCompanyQueryVariables = Exact<{
  _eq: User_Company_Roles_Enum;
}>;


export type GetUserCompanyQuery = (
  { __typename?: 'query_root' }
  & { user_companies: Array<(
    { __typename?: 'user_companies' }
    & Pick<User_Companies, 'email'>
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'id' | 'name' | 'phone' | 'surname' | 'fiscal_code'>
    ) }
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  _set: Users_Set_Input;
}>;


export type UpdateUserMutation = (
  { __typename?: 'mutation_root' }
  & { update_users_by_pk?: Maybe<(
    { __typename?: 'users' }
    & Pick<Users, 'id'>
  )> }
);

export type InsertUserCompanyMutationVariables = Exact<{
  object: User_Companies_Insert_Input;
}>;


export type InsertUserCompanyMutation = (
  { __typename?: 'mutation_root' }
  & { insert_user_companies_one?: Maybe<(
    { __typename?: 'user_companies' }
    & Pick<User_Companies, 'email' | 'user_id'>
  )> }
);

export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  resetPassword(email: $email) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordQuery, ResetPasswordQueryVariables> {
    document = ResetPasswordDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation changePassword($newPassword: String!, $oldPassword: String!) {
  changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompaniesDocument = gql`
    query getCompanies($_neq: uuid) {
  companies(where: {id: {_neq: $_neq}}) {
    address {
      city
      country
      house_number
      id
      province
      street
      zip
    }
    ateco_code
    company_role
    company_state
    email
    fiscal_code
    id
    logo
    name
    pec
    phone
    vat
    website
    company_category {
      id
      name {
        original_text
      }
    }
    company_sector {
      name {
        id
        original_language
      }
    }
    user_companies(where: {role: {_eq: green}}) {
      role
      state
      email
      user {
        birth_date
        id
        fiscal_code
        name
        phone
        profile_picture
        sex
        surname
      }
    }
    documents {
      expires_at
      file_link
      id
      title
      state
      user {
        user_companies {
          legal_representative
        }
        name
        surname
        fiscal_code
      }
      document_type {
        name {
          original_text
        }
        document_category {
          name {
            original_text
          }
        }
        mandatory
      }
    }
    legal_representative_user {
      birth_date
      fiscal_code
      id
      name
      phone
      profile_picture
      sex
      surname
      user_companies {
        email
        role
        state
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompaniesGQL extends Query<GetCompaniesQuery, GetCompaniesQueryVariables> {
    document = GetCompaniesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyByIdDocument = gql`
    query getCompanyById($id: uuid!) {
  companies_by_pk(id: $id) {
    address {
      city
      country
      house_number
      id
      province
      street
      zip
    }
    ateco_code
    company_role
    company_state
    email
    fiscal_code
    id
    logo
    name
    pec
    phone
    vat
    website
    company_category {
      name {
        id
        original_text
      }
    }
    company_sector {
      name {
        id
        original_text
      }
    }
    user_companies(where: {legal_representative: {_neq: true}}) {
      role
      state
      email
      see_settings
      user {
        birth_date
        id
        fiscal_code
        name
        phone
        profile_picture
        sex
        surname
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyByIdGQL extends Apollo.Query<GetCompanyByIdQuery, GetCompanyByIdQueryVariables> {
    document = GetCompanyByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyCategoriesDocument = gql`
    query getCompanyCategories {
  company_categories {
    id
    description {
      id
      original_text
    }
    name {
      id
      original_text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyCategoriesGQL extends Apollo.Query<GetCompanyCategoriesQuery, GetCompanyCategoriesQueryVariables> {
    document = GetCompanyCategoriesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterCompanyDocument = gql`
    mutation registerCompany($company: CompanyData!, $user: UserData!, $user_company: userCompanyData!, $dipendenti: dipendentiData, $dipendentiList: [dipendentiData], $documentList: [documentData]) {
  registerCompany(
    data: {company: $company, user: $user, user_company: $user_company, dipendentiList: $dipendentiList, documentList: $documentList}
  ) {
    data
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterCompanyGQL extends Apollo.Mutation<RegisterCompanyMutation, RegisterCompanyMutationVariables> {
    document = RegisterCompanyDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

export const InsertCompanyOneDocument = gql`
    mutation insertCompanyOne($object: companies_insert_input!) {
  insert_companies_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCompanyOneGQL extends Apollo.Mutation<InsertCompanyOneMutation, InsertCompanyOneMutationVariables> {
    document = InsertCompanyOneDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterBlueCompanyDocument = gql`
    mutation registerBlueCompany($data: CompanyData!) {
  registerBlueCompany(data: $data) {
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterBlueCompanyGQL extends Apollo.Mutation<RegisterBlueCompanyMutation, RegisterBlueCompanyMutationVariables> {
    document = RegisterBlueCompanyDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCourseCategoriesDocument = gql`
    query getCourseCategories {
  course_categories {
    id
    description {
      id
      original_text
    }
    name {
      id
      original_text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCourseCategoriesGQL extends Apollo.Query<GetCourseCategoriesQuery, GetCourseCategoriesQueryVariables> {
    document = GetCourseCategoriesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCourseCategoryDocument = gql`
    mutation insertCourseCategory($object: course_categories_insert_input!) {
  insert_course_categories_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCourseCategoryGQL extends Apollo.Mutation<InsertCourseCategoryMutation, InsertCourseCategoryMutationVariables> {
    document = InsertCourseCategoryDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }


export const GetCourseTypesDocument = gql`
    query getCourseTypes {
  course_types {
    id
    category_id
    durata
    aggiornamento
    category {
      name {
        original_text
        id
      }
    }
    description {
      id
      original_text
    }
    name {
      id
      original_text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCourseTypesGQL extends Apollo.Query<GetCourseTypesQuery, GetCourseTypesQueryVariables> {
    document = GetCourseTypesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCourseTypeDocument = gql`
    mutation insertCourseType($object: course_types_insert_input!) {
  insert_course_types_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCourseTypeGQL extends Apollo.Mutation<InsertCourseTypeMutation, InsertCourseTypeMutationVariables> {
    document = InsertCourseTypeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseTypeDocument = gql`
    mutation updateCourseType($id: uuid!, $category_id: uuid!, $aggiornamento: Int, $durata: Int) {
      update_course_types_by_pk(pk_columns: {id: $id}, _set: {category_id: $category_id, aggiornamento: $aggiornamento, durata: $durata}) {
        id
      }
    }
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseTypeGQL extends Apollo.Mutation<UpdateCourseTypeMutation, UpdateCourseTypeMutationVariables> {
    document = UpdateCourseTypeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }


export const GetInPartenzaCourseEventsDocument = gql`
    query getInPartenzaCourseEvents {
  course_events(where: {end_date: {_gte: "now()"}}, order_by: {start_date: asc}) {
    start_date
    end_date
    id
    course {
      description {
        id
        original_text
      }
      id
      name {
        id
        original_text
      }
      type {
        id
        name {
          id
          original_text
        }
        category {
          id
          name {
            original_text
          }
        }
      }
    }
    course_event_state {
      state {
        id
        original_text
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInPartenzaCourseEventsGQL extends Apollo.Query<GetInPartenzaCourseEventsQuery, GetInPartenzaCourseEventsQueryVariables> {
    document = GetInPartenzaCourseEventsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetArchivioCourseEventsDocument = gql`
    query getArchivioCourseEvents {
  course_events(where: {end_date: {_lt: "now()"}}) {
    start_date
    end_date
    id
    course {
      description {
        id
        original_text
      }
      id
      name {
        id
        original_text
      }
      type {
        id
        name {
          id
          original_text
        }
        category {
          id
          name {
            original_text
          }
        }
      }
    }
    course_event_state {
      state {
        id
        original_text
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetArchivioCourseEventsGQL extends Apollo.Query<GetArchivioCourseEventsQuery, GetArchivioCourseEventsQueryVariables> {
    document = GetArchivioCourseEventsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCourseEventsDocument = gql`
    mutation insertCourseEvents($object: course_events_insert_input!) {
  insert_course_events_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCourseEventsGQL extends Apollo.Mutation<InsertCourseEventsMutation, InsertCourseEventsMutationVariables> {
    document = InsertCourseEventsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseDocument = gql`
    mutation deleteCourse($id: uuid!) {
  delete_courses_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseGQL extends Apollo.Mutation<DeleteCourseMutation, DeleteCourseMutationVariables> {
    document = DeleteCourseDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentCategoriesDocument = gql`
    query getDocumentCategories {
  document_categories {
    id
    description {
      id
      original_text
    }
    name {
      id
      original_text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentCategoriesGQL extends Apollo.Query<GetDocumentCategoriesQuery, GetDocumentCategoriesQueryVariables> {
    document = GetDocumentCategoriesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertDocumentCategoryDocument = gql`
    mutation insertDocumentCategory($object: document_categories_insert_input!) {
  insert_document_categories_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertDocumentCategoryGQL extends Apollo.Mutation<InsertDocumentCategoryMutation, InsertDocumentCategoryMutationVariables> {
    document = InsertDocumentCategoryDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentTypesDocument = gql`
    query getDocumentTypes {
  document_types {
    id
    category_id
    mandatory
    notify_frequency
    aggiornamento
    start_notif_brefore_expire
    document_category {
      name {
        original_text
        id
      }
    }
    description {
      id
      original_text
    }
    name {
      id
      original_text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentTypesGQL extends Apollo.Query<GetDocumentTypesQuery, GetDocumentTypesQueryVariables> {
    document = GetDocumentTypesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertDocumentTypeDocument = gql`
    mutation insertDocumentType($object: document_types_insert_input!) {
  insert_document_types_one(object: $object) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertDocumentTypeGQL extends Apollo.Mutation<InsertDocumentTypeMutation, InsertDocumentTypeMutationVariables> {
    document = InsertDocumentTypeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentTypeDocument = gql`
    mutation updateDocumentType($id: uuid!, $_set: document_types_set_input!) {
  update_document_types_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentTypeGQL extends Apollo.Mutation<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables> {
    document = UpdateDocumentTypeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentByIdDocument = gql`
    mutation deleteDocumentById($id: uuid!) {
  delete_documents_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentByIdGQL extends Apollo.Mutation<DeleteDocumentByIdMutation, DeleteDocumentByIdMutationVariables> {
    document = DeleteDocumentByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

export const GetBlueDocumentsDocument = gql`
    query getBlueDocuments($company_id: uuid!) {
  documents(where: {company_id: {_eq: $company_id}, state: {_nin: "Caricato"}}) {
    id
    issuer_id
    title
    document_type {
      id
      name {
        original_text
      }
      document_category {
        name {
          original_text
        }
        id
      }
    }
    company {
      id
      name
      phone
      fiscal_code
      email
    }
    user {
      fiscal_code
      name
      phone
      surname
      user_companies {
        email
        legal_representative
      }
    }
    file_link
    expires_at
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlueDocumentsGQL extends Apollo.Query<GetBlueDocumentsQuery, GetBlueDocumentsQueryVariables> {
    document = GetBlueDocumentsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBlueValidDocumentsDocument = gql`
    query getBlueValidDocuments($company_id: uuid!) {
  documents(where: {company_id: {_eq: $company_id}, state: {_eq: "Caricato"}}, order_by: {created_at: desc}) {
    id
    issuer_id
    title
    document_type {
      id
      name {
        original_text
      }
      document_category {
        name {
          original_text
        }
        id
      }
    }
    company {
      id
      name
      phone
      fiscal_code
      email
    }
    user {
      fiscal_code
      name
      phone
      surname
      user_companies {
        email
        legal_representative
      }
    }
    file_link
    expires_at
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlueValidDocumentsGQL extends Apollo.Query<GetBlueValidDocumentsQuery, GetBlueValidDocumentsQueryVariables> {
    document = GetBlueValidDocumentsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpiredDocumentsDocument = gql`
    query getExpiredDocuments($_lt: date) {
  documents(where: {expires_at: {_lte: $_lt}}) {
    id
    issuer_id
    title
    document_type {
      id
      name {
        original_text
      }
      document_category {
        name {
          original_text
        }
        id
      }
    }
    company {
      id
      name
      phone
      fiscal_code
      email
    }
    user {
      fiscal_code
      name
      phone
      surname
      user_companies {
        email
        legal_representative
      }
    }
    file_link
    expires_at
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpiredDocumentsGQL extends Apollo.Query<GetExpiredDocumentsQuery, GetExpiredDocumentsQueryVariables> {
    document = GetExpiredDocumentsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDipendentiDocumentsDocument = gql`
    query getDipendentiDocuments($_eq: uuid!) {
  documents(where: {user_id: {_eq: $_eq}}) {
    company_id
    expires_at
    file_link
    id
    state
    title
    user_id
    document_type {
      document_category {
        name {
          original_text
        }
      }
      name {
        original_text
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDipendentiDocumentsGQL extends Apollo.Query<GetDipendentiDocumentsQuery, GetDipendentiDocumentsQueryVariables> {
    document = GetDipendentiDocumentsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpiredDocumentsByCategoryDocument = gql`
    query getExpiredDocumentsByCategory($_lt: date, $category_id: uuid!) {
  documents(
    where: {expires_at: {_lte: $_lt}, document_type: {category_id: {_eq: $category_id}}}
  ) {
    id
    issuer_id
    title
    document_type {
      id
      name {
        original_text
      }
      document_category {
        name {
          original_text
        }
        id
      }
    }
    company {
      id
      name
      phone
      fiscal_code
      email
    }
    user {
      fiscal_code
      name
      phone
      surname
      user_companies {
        email
        legal_representative
      }
    }
    file_link
    expires_at
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpiredDocumentsByCategoryGQL extends Apollo.Query<GetExpiredDocumentsByCategoryQuery, GetExpiredDocumentsByCategoryQueryVariables> {
    document = GetExpiredDocumentsByCategoryDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentDocument = gql`
    mutation updateDocument($id: uuid!, $_set: documents_set_input!) {
  update_documents_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentGQL extends Apollo.Mutation<UpdateDocumentMutation, UpdateDocumentMutationVariables> {
    document = UpdateDocumentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationDocument = gql`
    query getNotification {
  notification {
    uuid
    blue_seen
    company {
      name
    }
    green_seen
    red_seen
    message
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationGQL extends Apollo.Query<GetNotificationQuery, GetNotificationQueryVariables> {
    document = GetNotificationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationDocument = gql`
    mutation updateNotification($uuid: uuid!, $_set: notification_set_input) {
  update_notification_by_pk(pk_columns: {uuid: $uuid}, _set: $_set) {
    uuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationGQL extends Apollo.Mutation<UpdateNotificationMutation, UpdateNotificationMutationVariables> {
    document = UpdateNotificationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendNotificationDocument = gql`
    mutation SendNotification($company_id: [String!]!, $message: String!, $subject: String!, $to_dipendenti: Boolean!) {
  sendNotification(
    to_dipendenti: $to_dipendenti
    message: $message
    subject: $subject
    company_id: $company_id
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendNotificationGQL extends Apollo.Mutation<SendNotificationMutation, SendNotificationMutationVariables> {
    document = SendNotificationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTextContextDocument = gql`
    mutation updateTextContext($id: uuid!, $original_text: String!) {
  update_text_contexts_by_pk(
    pk_columns: {id: $id}
    _set: {original_text: $original_text}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTextContextGQL extends Apollo.Mutation<UpdateTextContextMutation, UpdateTextContextMutationVariables> {
    document = UpdateTextContextDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTextContextDocument = gql`
    mutation deleteTextContext($id: uuid!) {
  delete_text_contexts_by_pk(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTextContextGQL extends Apollo.Mutation<DeleteTextContextMutation, DeleteTextContextMutationVariables> {
    document = DeleteTextContextDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserByIdDocument1 = gql`
    query getUserById($id: uuid!) {
      users(order_by: {created_at: asc}, where: {id: {_eq: $id}}) {
        name
        surname
        companies {
          logo
        }
      }
    }
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByIdGQL1 extends Apollo.Query<GetUserByIdQuery, GetUserByIdQueryVariables> {
    document = GetUserByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserCompanyDocument = gql`
    query getUserCompany($_eq: user_company_roles_enum!) {
  user_companies(where: {role: {_eq: $_eq}}) {
    email
    state
    see_settings
    user {
      id
      name
      phone
      surname
      fiscal_code
    }
  }
}
    `;

 @Injectable({
    providedIn: 'root'
  })
  export class GetUserCompanyGQL extends Apollo.Query<GetUserCompanyQuery, GetUserCompanyQueryVariables> {
    document = GetUserCompanyDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($id: uuid!, $_set: users_set_input!) {
  update_users_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertUserCompanyDocument = gql`
    mutation insertUserCompany($object: user_companies_insert_input!) {
  insert_user_companies_one(object: $object) {
    email
    user_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertUserCompanyGQL extends Apollo.Mutation<InsertUserCompanyMutation, InsertUserCompanyMutationVariables> {
    document = InsertUserCompanyDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

  //-----
export const UpdateCourseEventsDocument = gql`
  mutation update_course_events($id: uuid!, $end_date: date!, $start_date: date!) {
    update_course_events_by_pk(
      pk_columns: { id: $id }
      _set: { end_date: $end_date, start_date: $start_date }
    ) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCourseEventsGQL extends Apollo.Mutation<
  UpdateCourseEventsMutation,
  UpdateCourseEventsMutationVariables
> {
  document = UpdateCourseEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateCourseEventsMutation = {
  __typename?: 'mutation_root';
} & {
  update_course_events_by_pk?: Maybe<{ __typename?: 'course_events' } & Pick<Course_Events, 'id'>>;
};

export type UpdateCourseEventsMutationVariables = {
  id: Scalars['uuid'];
  end_date: Scalars['date'];
  start_date: Scalars['date'];
};
//-----



export const UpdateCoursesDocument = gql`
  mutation update_course($id: uuid!, $type_id: uuid!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: { type_id: $type_id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCoursesGQL extends Apollo.Mutation<
  UpdateCoursesMutation,
  UpdateCoursesMutationVariables
> {
  document = UpdateCoursesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateCoursesMutation = {
  __typename?: 'mutation_root';
} & {
  update_courses_by_pk?: Maybe<{ __typename?: 'courses' } & Pick<Courses, 'id'>>;
};

export type UpdateCoursesMutationVariables = {
  id: Scalars['uuid'];
  type_id: Scalars['uuid'];
};
//------

export const GetUserSeeSettingIdDocument = gql`
  query getUserSeeSettingId($_eq: uuid!) {
    user_companies(where: { user_id: { _eq: $_eq } }) {
      see_settings
      user_id
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetUserSeeSettingIdGQL extends Apollo.Query<GetUserSeeSettingIdQuery, GetUserSeeSettingIdQueryVariables> {
  document = GetUserSeeSettingIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetUserSeeSettingIdQuery = (
  { __typename?: 'query_root' }
  & { user_companies: Array<(
    { __typename?: 'user_companies' }
    & Pick<User_Companies, 'user_id'>
  )> }
);

export type GetUserSeeSettingIdQueryVariables = Exact<{
  _eq: Scalars['uuid'];
}>;

//------

export const UpdateSeeSettingsDocument = gql`
  mutation updateSeeSettings($_eq: uuid!, $see_settings: Boolean!) {
    update_user_companies(where: { user_id: { _eq: $_eq } }, _set: { see_settings: $see_settings }) {
      affected_rows
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateSeeSettingsGQL extends Apollo.Mutation<UpdateSeeSettingsMutation, UpdateSeeSettingsMutationVariables> {
  document = UpdateSeeSettingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateSeeSettingsMutation = (
  { __typename?: 'mutation_root' }
  & { update_user_companies?: Maybe<(
    { __typename?: 'user_companies_mutation_response' }
    & Pick<User_Companies_Mutation_Response, 'affected_rows'>
  )> }
);

export type UpdateSeeSettingsMutationVariables = Exact<{
  _eq: Scalars['uuid'];
  see_settings: Scalars['Boolean'];
}>;


//------

export const RegisterDipDocument = gql`
  mutation registerDip($dipendentiList: [dipendentiData]!) {
    registerDip(data: { dipendentiList: $dipendentiList }) {
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RegisterDipGQL extends Apollo.Mutation<RegisterDipMutation, RegisterDipMutationVariables> {
  document = RegisterDipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type RegisterDipMutation = {
  __typename?: 'mutation_root';
  registerDip?: Maybe<{
    __typename?: 'response';
    success: boolean;
  }>;
};

export type RegisterDipMutationVariables = {
  dipendentiList: Array<DipendentiData>;
};





























// ##################### AZ INJA SHURU MISHE

// Define the GraphQL mutation
export const InsertDeviceDocument = gql`
  mutation InsertDevice($object: devices_insert_input!) {
    insert_devices_one(object: $object) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertDeviceGQL extends Apollo.Mutation<InsertDeviceMutation, InsertDeviceMutationVariables> {
  document = InsertDeviceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertDeviceMutation = {
  __typename?: 'mutation_root';
} & {
  insert_devices_one: {
    __typename?: 'devices';
    uuid: Scalars['uuid'];
  };
};

export type InsertDeviceMutationVariables = {
  object: DevicesInsertInput;
};

// Define the input type for the "devices_insert_input" object
export interface DevicesInsertInput {
  connection_name?: Scalars['String'];
  device_name?: Scalars['String'];
  impianti_id?: Scalars['uuid'];
  system_name?: Scalars['String'];
  system_type?: Scalars['String'];
  type_id?: Scalars['uuid'];
  station_id?: Scalars['uuid'];
  type_charger?: Scalars['String'];
  max_power?: Scalars['Int'];
  status?: Scalars['String'];
  connector_id?: Scalars['Int'];
  cost_per_kwh?: Scalars['String'];
  order?: Scalars['Int'];
  provider_id?: Scalars['uuid'];
  serial_number?: Scalars['String'];
  deye_station?: Scalars['String'];
  userid?: Scalars['uuid'];
  public?: Scalars['Boolean'];
  public_lat?: Scalars['String'];
  public_lngt?: Scalars['String'];
  description?: Scalars['String'];
  start_since?: Scalars['String'];
  related_device_id?: Scalars['uuid'];
  credential?: Scalars['String'];
}

//------

// Define the GraphQL mutation
export const DeleteDeviceDocument = gql`
  mutation deleteDevice($uuid: uuid!) {
    delete_devices_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteDeviceGQL extends Apollo.Mutation<DeleteDeviceMutation, DeleteDeviceMutationVariables> {
  document = DeleteDeviceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteDeviceMutation = {
  __typename?: 'mutation_root';
} & {
  delete_devices_by_pk: {
    __typename?: 'devices';
    uuid: Scalars['uuid'];
  };
};

export type DeleteDeviceMutationVariables = {
  uuid: Scalars['uuid'];
};
//------

// Define the GraphQL mutation
export const UpdateDeviceDocument = gql`
  mutation updateDevice($uuid: uuid!, $_set: devices_set_input!) {
    update_devices_by_pk(pk_columns: { uuid: $uuid }, _set: $_set) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateDeviceGQL extends Apollo.Mutation<UpdateDeviceMutation, UpdateDeviceMutationVariables> {
  document = UpdateDeviceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateDeviceMutation = {
  __typename?: 'mutation_root';
} & {
  update_devices_by_pk: {
    __typename?: 'devices';
    uuid: Scalars['uuid'];
  };
};

export type UpdateDeviceMutationVariables = {
  uuid: Scalars['uuid'];
  _set: DevicesInsertInput;
};

//--------


// Define the GraphQL query
export const GetMetricsDocument = gql`
  query getMetrics {
    device_metrics {
      affix
      blue
      decimalDigits
      green
      label
      maxValue
      minValue
      timeSeries_period
      uuid
      var_name
      widget_type
      device {
        device_name
        system_name
        uuid
        devices_impianti {
          impianti_name
        }
      }
      red
      function
      receive_notifications
      unit_conversion
      visible
      widgetTypeByWidgetType {
        comment
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricsGQL extends Apollo.Query<GetMetricsQuery, GetMetricsQueryVariables> {
  document = GetMetricsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricsQuery = {
  __typename?: 'query_root';
} & {
  device_metrics: Array<{
    __typename?: 'device_metrics';
    metric_type: Scalars['String'];
    affix: Scalars['String'];
    function: Scalars['String'];
    visible: Scalars['Boolean'];
    receive_notifications: Scalars['Boolean'];
    unit_conversion: Scalars['String'];
    blue: Scalars['Int'];
    decimalDigits: Scalars['Int'];
    green: Scalars['Int'];
    label: Scalars['String'];
    maxValue: Scalars['Int'];
    minValue: Scalars['Int'];
    timeSeries_period: Scalars['Int'];
    uuid: Scalars['String'];
    var_name: Scalars['String'];
    widget_type: Scalars['String'];
    type_id: Scalars['String'];
    device: {
      __typename?: 'devices';
      device_name: Scalars['String'];
      system_name: Scalars['String'];
      uuid: Scalars['uuid'];
      devices_impianti:{
        __typename?: 'devices_impianti';
        impianti_name: Scalars['String'];
      }
    };
    widgetTypeByWidgetType: {
      __typename?: 'widgetTypeByWidgetType';
      comment: Scalars['String'];
    };
    red: Scalars['Int'];
  }>;
};

export type GetMetricsQueryVariables = {};

//------------


// Define the GraphQL mutation
export const InsertMetricDocument = gql`
  mutation insertMetric($object: device_metrics_insert_input!) {
    insert_device_metrics_one(object: $object) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertMetricGQL extends Apollo.Mutation<InsertMetricMutation, InsertMetricMutationVariables> {
  document = InsertMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertMetricMutation = {
  __typename?: 'mutation_root';
} & {
  insert_device_metrics_one: {
    __typename?: 'device_metrics';
    uuid: Scalars['uuid'];
  };
};

export type InsertMetricMutationVariables = {
  object: DeviceMetricsInsertInput;
};

// Define the input type for the "device_metrics_insert_input" object
export interface DeviceMetricsInsertInput {
  affix: Scalars['String'];
  blue: Scalars['Int'];
  decimalDigits: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
  label: Scalars['String'];
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  timeSeries_period: Scalars['String'];
  var_name: Scalars['String'];
  device_id: Scalars['String'];
  widget_type: Scalars['String'];
  type_id: Scalars['String'];
  function: Scalars['String'];
  visible: Scalars['Boolean'];
  receive_notifications: Scalars['Boolean'];
  unit_conversion: Scalars['String'];
  // Add more fields as needed
}


//----------------


// Define the GraphQL mutation
export const UpdateMetricDocument = gql`
  mutation updateMetric($uuid: uuid!, $_set: device_metrics_set_input!) {
    update_device_metrics_by_pk(pk_columns: { uuid: $uuid }, _set: $_set) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateMetricGQL extends Apollo.Mutation<UpdateMetricMutation, UpdateMetricMutationVariables> {
  document = UpdateMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateMetricMutation = {
  __typename?: 'mutation_root';
} & {
  update_device_metrics_by_pk: {
    __typename?: 'device_metrics';
    uuid: Scalars['uuid'];
  };
};

export type UpdateMetricMutationVariables = {
  uuid: Scalars['uuid'];
  _set: DeviceMetricsSetInput;
};

// Define the input type for the "device_metrics_set_input" object
export interface DeviceMetricsSetInput {
  affix: Scalars['String'];
  blue: Scalars['Int'];
  decimalDigits: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
  label: Scalars['String'];
  maxValue: Scalars['Int'];
  minValue: Scalars['Int'];
  timeSeries_period: Scalars['String'];
  var_name: Scalars['String'];
  widget_type: Scalars['String'];
  device_id: Scalars['String'];
  type_id: Scalars['String'];
  function: Scalars['String'];
  visible: Scalars['Boolean'];
  receive_notifications: Scalars['Boolean'];
  unit_conversion: Scalars['String'];
  // Add more fields as needed
}

// --------------

// Define the GraphQL mutation
export const DeleteMetricDocument = gql`
  mutation deleteMetric($uuid: uuid!) {
    delete_device_metrics_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteMetricGQL extends Apollo.Mutation<DeleteMetricMutation, DeleteMetricMutationVariables> {
  document = DeleteMetricDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteMetricMutation = {
  __typename?: 'mutation_root';
} & {
  delete_device_metrics_by_pk: {
    __typename?: 'device_metrics';
    uuid: Scalars['uuid'];
  };
};

export type DeleteMetricMutationVariables = {
  uuid: Scalars['uuid'];
};

// -------------

// Define the GraphQL query
export const GetUserImpiantiDocument = gql`
  query getUserImpianti($_eq: uuid!) {
    user_impianti(where: { user_id: { _eq: $_eq } }) {
      impianti {
        impianti_name
        latitude
        longitude
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserImpiantiGQL extends Apollo.Query<
  GetUserImpiantiQuery,
  GetUserImpiantiQueryVariables
> {
  document = GetUserImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetUserImpiantiQuery = {
  __typename?: 'query_root';
} & {
  user_impianti: Array<{
    __typename?: 'user_impianti';
    impianti: Array<{
      __typename?: 'impianti';
      impianti_name: Scalars['String'];
      latitude: Scalars['Float'];
      longitude: Scalars['Float'];
      description: Scalars['String'];
    }>;
  }>;
};

export type GetUserImpiantiQueryVariables = {
  _eq: Scalars['uuid'];
};

// -------------

// Define the GraphQL mutation
export const InsertUserImpiantiDocument = gql`
  mutation insertUserImpianti(
    $impianti_id: uuid!,
    $user_id: uuid!
  ) {
    insert_user_impianti_one(object: {
      impianti_id: $impianti_id,
      user_id: $user_id
    }) {
      impianti_id
      user_id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertUserImpiantiGQL extends Apollo.Mutation<
  InsertUserImpiantiMutation,
  InsertUserImpiantiMutationVariables
> {
  document = InsertUserImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertUserImpiantiMutation = {
  __typename?: 'mutation_root';
} & {
  insert_user_impianti_one: {
    __typename?: 'user_impianti';
    impianti_id: Scalars['uuid'];
    user_id: Scalars['uuid'];
  };
};

export type InsertUserImpiantiMutationVariables = {
  impianti_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

// -------------
// Define the GraphQL query
export const GetAllUserImpiantiDocument = gql`
  query getAllUserImpianti {
    user_impianti {
      uuid
      impianti {
        description
        latitude
        longitude
        impianti_name
        uuid
      }
      user {
        email
        role
        state
        users_registry {
          name
          phone
          surname
          fiscal_code
        }
        users_company {
          company_name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllUserImpiantiGQL extends Apollo.Query<
  GetAllUserImpiantiQuery,
  GetAllUserImpiantiQueryVariables
> {
  document = GetAllUserImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllUserImpiantiQuery = {
  __typename?: 'query_root';
} & {
  user_impianti: Array<{
    __typename?: 'user_impianti';
    uuid: Scalars['uuid'];
    impianti: Array<{
      __typename?: 'impianti';
      description: Scalars['String'];
      latitude: Scalars['Float'];
      longitude: Scalars['Float'];
      impianti_name: Scalars['String'];
      uuid: Scalars['uuid'];
    }>;
    user: {
      __typename?: 'users';
      email: Scalars['String'];
      role: Scalars['String'];
      state: Scalars['String'];
      users_registry: Array<{
        __typename?: 'users_registry';
        name: Scalars['String'];
        phone: Scalars['String'];
        surname: Scalars['String'];
        fiscal_code: Scalars['String'];
      }>;
      users_company: Array<{
        __typename?: 'users_company';
        company_name: Scalars['String'];
      }>;
    };
  }>;
};

export type GetAllUserImpiantiQueryVariables = {};

// -------------

// Define the GraphQL mutation
export const DeleteUserImpDocument = gql`
  mutation deleteUserImp($uuid: uuid!) {
    delete_user_impianti_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteUserImpGQL extends Apollo.Mutation<
  DeleteUserImpMutation,
  DeleteUserImpMutationVariables
> {
  document = DeleteUserImpDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteUserImpMutation = {
  __typename?: 'mutation_root';
} & {
  delete_user_impianti_by_pk: {
    __typename?: 'user_impianti';
    uuid: Scalars['uuid'];
  };
};

export type DeleteUserImpMutationVariables = {
  uuid: Scalars['uuid'];
};

// -------------

// Define the GraphQL mutation
export const DeleteImpDocument = gql`
  mutation deleteImp($uuid: uuid = "") {
    delete_impianti_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteImpGQL extends Apollo.Mutation<
  DeleteImpMutation,
  DeleteImpMutationVariables
> {
  document = DeleteImpDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteImpMutation = {
  __typename?: 'mutation_root';
} & {
  delete_impianti_by_pk: {
    __typename?: 'impianti';
    uuid: Scalars['uuid'];
  };
};

export type DeleteImpMutationVariables = {
  uuid?: Maybe<Scalars['uuid']>;
};

// -------------

// Define the GraphQL query
export const GetRolesDocument = gql`
  query getRoles {
    roles {
      comment
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetRolesGQL extends Apollo.Query<
  GetRolesQuery,
  GetRolesQueryVariables
> {
  document = GetRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetRolesQuery = {
  __typename?: 'query_root';
} & {
  roles: Array<{
    __typename?: 'roles';
    comment: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetRolesQueryVariables = {};

//---------------

// Define the GraphQL query
export const GetAllManagersDocument = gql`
  query getAllManagers {
    users(where: {role: {_eq: manager}}) {
      email
      id
      role
      state
      users_registry {
        name
        phone
        surname
        fiscal_code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllManagersGQL extends Apollo.Query<
  GetAllManagersQuery,
  GetAllManagersQueryVariables
> {
  document = GetAllManagersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllManagersQuery = {
  __typename?: 'query_root';
} & {
  users: Array<{
    __typename?: 'users';
    email: Scalars['String'];
    id: Scalars['uuid'];
    role: Scalars['String'];
    state: Scalars['String'];
    users_registry: Array<{
      __typename?: 'users_registry';
      name: Scalars['String'];
      phone: Scalars['String'];
      surname: Scalars['String'];
      fiscal_code: Scalars['String'];
    }>;
  }>;
};

export type GetAllManagersQueryVariables = {};


//--------
// Define the GraphQL query
export const GetUserByIdDocument = gql`
  query getUserById($id: String!) {
    getUserInfo(data: {id: $id}) {
      name
      surname
      address
      city
      cap
      province
      nationality
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserByIdGQL extends Apollo.Query<
  GetUserByIdQuery,
  GetUserByIdQueryVariables
> {
  document = GetUserByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetUserByIdQuery = {
  __typename?: 'query_root';
} & {
  getUserInfo: {
    __typename?: 'users_registry';
    name: Scalars['String'];
    surname: Scalars['String'];
    address?: Maybe<Scalars['String']>;
    city?: Maybe<Scalars['String']>;
    cap?: Maybe<Scalars['String']>;
    province?: Maybe<Scalars['String']>;
    nationality?: Maybe<Scalars['String']>;
  };
};

export type GetUserByIdQueryVariables = {
  id: Scalars['String'];
};
//--------
@Injectable({
  providedIn: 'root',
})
export class GetoccupieduserGQL extends Apollo.Query<
  GetUserByIdQuery,
  GetUserByIdQueryVariables
> {
  document = GetUserByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetoccupieduserQuery = {
  __typename?: 'query_root';
} & {
  getUserInfo: {
    __typename?: 'users_registry';
    name: Scalars['String'];
    surname: Scalars['String'];
    address?: Maybe<Scalars['String']>;
    city?: Maybe<Scalars['String']>;
    cap?: Maybe<Scalars['String']>;
    province?: Maybe<Scalars['String']>;
    nationality?: Maybe<Scalars['String']>;
  };
};

export type GetoccupieduserVariables = {
  id: Scalars['String'];
};
//--------------
// Define the GraphQL query
export const GetWidgetsDocument = gql`
  query getWidgets {
    widget_types {
      comment
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWidgetsGQL extends Apollo.Query<
  GetWidgetsQuery,
  GetWidgetsQueryVariables
> {
  document = GetWidgetsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetWidgetsQuery = {
  __typename?: 'query_root';
} & {
  widget_types: Array<{
    __typename?: 'widget_types';
    comment: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetWidgetsQueryVariables = {};

// --------------

@Injectable({
  providedIn: 'root',
})
export class UpdateUserStateGQL extends Apollo.Mutation<
  UpdateUserStateMutation,
  UpdateUserStateMutationVariables
> {
  document = UpdateUserStateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const UpdateUserStateDocument = gql`
  mutation updateUserState($id: uuid!, $state: user_state_enum!) {
    update_users_by_pk(pk_columns: {id: $id}, _set: {state: $state}) {
      id
    }
  }
`;

export type UpdateUserStateMutation = {
  __typename?: 'mutation_root';
} & {
  update_users_by_pk: {
    __typename?: 'users';
    id: Scalars['uuid'];
  };
};

export type UpdateUserStateMutationVariables = {
  id: Scalars['uuid'];
  state: User_States;
};


//-----------

//----------------------------
// Mutation for updating impianti
//----------------------------

export const UpdateImpDocument = gql`
  mutation updateImp(
    $uuid: uuid!
    $description: String!
    $impianti_name: String!
    $latitude: String!
    $longitude: String!
    $technician_id: uuid
    $manager_id: uuid
    $user_id: uuid
    $company_id: uuid
    $provincia: String
    $indirizzo: String
    $citta: String
    $cap: String
  ) {
    update_impianti_by_pk(
      pk_columns: { uuid: $uuid }
      _set: {
        description: $description
        impianti_name: $impianti_name
        latitude: $latitude
        longitude: $longitude
        technician_id: $technician_id
        manager_id: $manager_id
        user_id: $user_id
        company_id: $company_id
        provincia: $provincia
        indirizzo: $indirizzo
        citta: $citta
        cap: $cap
      }
    ) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateImpGQL extends Apollo.Mutation<
  UpdateImpMutation,
  UpdateImpMutationVariables
> {
  document = UpdateImpDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateImpMutation = {
  __typename?: 'mutation_root';
} & {
  update_impianti_by_pk?: {
    __typename?: 'impianti';
    uuid: Scalars['uuid'];
  };
};

export type UpdateImpMutationVariables = {
  uuid: Scalars['uuid'];
  description: Scalars['String'];
  impianti_name: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  technician_id?: Scalars['uuid'];
  manager_id?: Scalars['uuid'];
  user_id?: Scalars['uuid'];
  company_id?: Scalars['uuid'];
  provincia?: Scalars['String'];
  indirizzo?: Scalars['String'];
  citta?: Scalars['String'];
  cap?: Scalars['String'];
};

//---------------

@Injectable({
  providedIn: 'root',
})
export class DeleteUserGQL extends Apollo.Mutation<
  DeleteUserMutation,
  DeleteUserMutationVariables
> {
  document = DeleteUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const DeleteUserDocument = gql`
  mutation deleteUser($id: uuid!) {
    delete_registries_by_pk(id: $id) {
      id
    }
  }
`;

export type DeleteUserMutation = {
  __typename?: 'mutation_root';
} & {
  delete_registries_by_pk: {
    __typename?: 'registries';
    id: Scalars['uuid'];
  };
};

export type DeleteUserMutationVariables = {
  id: Scalars['uuid'];
};
//--------------

// Define the GraphQL mutation
export const GetImpiantoDeviceMetricsDocument = gql`
  mutation getImpiantoDeviceMetrics($id: String!) {
    getImpiantoDevicesMetrics(data: {id: $id}) {
      data
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetImpiantoDeviceMetricsGQL extends Apollo.Mutation<
  GetImpiantoDeviceMetricsMutation,
  GetImpiantoDeviceMetricsMutationVariables
> {
  document = GetImpiantoDeviceMetricsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetImpiantoDeviceMetricsMutation = {
  __typename?: 'mutation_root';
} & {
  getImpiantoDevicesMetrics: {
    __typename?: 'metrics_response';
    data: Scalars['String'];
  };
};

export type GetImpiantoDeviceMetricsMutationVariables = {
  id: Scalars['String'];
};



//-----------------

export const InsertLinkDocument = gql`
  mutation insertLink($link: String!, $title: String!, $user_id: uuid!, $role: roles_enum) {
    insert_links_one(object: {link: $link, title: $title, user_id: $user_id, role: $role}) {
      uuid
    }
  }
`;

export const InsertLinkDocument1 = gql`
  mutation insertLink1($link: String!, $title: String!, $user_id: uuid) {
    insert_links_one(object: {link: $link, title: $title, user_id: $user_id}) {
      uuid
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class InsertLinkGQL extends Apollo.Mutation<InsertLinkMutation, InsertLinkMutationVariables> {
  document = InsertLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root',
})
export class InsertLinkGQL1 extends Apollo.Mutation<InsertLink1Mutation, InsertLinkMutationVariables1> {
  document = InsertLinkDocument1;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertLinkMutation = {
  __typename?: 'mutation_root';
} & {
  insert_links_one: {
    __typename?: 'links';
    uuid: Scalars['uuid'];
  };
};
export type InsertLink1Mutation = {
  __typename?: 'mutation_root';
} & {
  insert_links_one: {
    __typename?: 'links';
    uuid: Scalars['uuid'];
  };
};

export type InsertLinkMutationVariables = {
  link: Scalars['String'];
  title: Scalars['String'];
  user_id: Scalars['uuid'];
  role: Scalars['String'];
};

export type InsertLinkMutationVariables1 = {
  link: Scalars['String'];
  title: Scalars['String'];
  user_id: Scalars['uuid'];
  //role: Scalars['String'];
};


//-----------------

export const GetAllLinksDocument = gql`
  query getLinks {
  links{
    link
    title
    jpg
    order
    uuid
    role
    isHomeLink
    links_role {
      comment
      id
    }
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllLinksGQL extends Apollo.Query<GetAllLinksQuery, GetAllLinksQueryVariables> {
  document = GetAllLinksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllLinksQuery = {
  __typename?: 'query_root';
} & {
  links: Array<{
    __typename?: 'links';
    uuid: Scalars['uuid'];
    link: Scalars['String'];
    jpg?: Maybe<Scalars['String']>;
    isHomeLink: Scalars['Boolean'];
    order: Scalars['Int'];
    title: Scalars['String'];
  }>;
};

export type GetAllLinksQueryVariables = {};

//-----------------

//-----------------

export const GetLinksDocument = gql`
  query getLinks($_eq: uuid!) {
    links(where: {user_id: {_eq: $_eq}}) {
      link
      title
      uuid
      jpg

      role
      links_role {
        comment
        id
      }
    }
  }
  `;

@Injectable({
  providedIn: 'root',
})
export class GetLinksGQL extends Apollo.Query<GetLinksQuery, GetLinksQueryVariables> {
  document = GetLinksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetLinksQuery = {
  __typename?: 'query_root';
} & {
  links: Array<{
    __typename?: 'links';
    uuid: Scalars['uuid'];
    link: Scalars['String'];
    title: Scalars['String'];
    jpg?: Maybe<Scalars['String']>;
  }>;
};

export type GetLinksQueryVariables = {
  _eq: Scalars['uuid'];
};

//-----------------



// Define the GraphQL mutation
export const DeleteLinkDocument = gql`
  mutation deleteLink($uuid: uuid!) {
    delete_links_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteLinkGQL extends Apollo.Mutation<DeleteLinkMutation, DeleteLinkMutationVariables> {
  document = DeleteLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteLinkMutation = {
  __typename?: 'mutation_root';
} & {
  delete_links_by_pk: {
    __typename?: 'links';
    uuid: Scalars['uuid'];
  };
};

export type DeleteLinkMutationVariables = {
  uuid: Scalars['uuid'];
};

//--------------

// Define the GraphQL query
export const GetDocumentsDocument = gql`
  query getDocs($_eq: uuid!) {
    documents(where: {user_id: {_eq: $_eq}}) {
      file_link
      title
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDocumentsGQL extends Apollo.Query<GetDocumentsQuery, GetDocumentsQueryVariables> {
  document = GetDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetDocumentsQuery = {
  __typename?: 'query_root';
} & {
  documents: Array<{
    __typename?: 'documents';
    file_link: string;
    title: string;
    uuid: Scalars['uuid'];
  }>;
};

export type GetDocumentsQueryVariables = {
  _eq: Scalars['uuid'];
};

//-------------

// Define the GraphQL query
export const GetAllDocumentsDocument = gql`
  query getDocs {
    documents{
      file_link
      title
      uuid
      role
      documents_role {
        comment
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllDocumentsGQL extends Apollo.Query<GetAllDocumentsQuery, GetAllDocumentsQueryVariables> {
  document = GetAllDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllDocumentsQuery = {
  __typename?: 'query_root';
} & {
  documents: Array<{
    __typename?: 'documents';
    file_link: string;
    title: string;
    uuid: Scalars['uuid'];
  }>;
};

export type GetAllDocumentsQueryVariables = {
};

//-------------


// Define the GraphQL mutation
export const UploadFileDocument = gql`
    mutation uploadFile($pdf: String!, $title: String!, $role: String, $user_id: String!) {
    uploadPDFToBucket(input: {pdf: $pdf, title: $title, user_id: $user_id, role: $role}) {
      message
      success
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UploadFileGQL extends Apollo.Mutation<UploadFileMutation, UploadFileMutationVariables> {
  document = UploadFileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UploadFileMutation = {
  __typename?: 'mutation_root';
} & {
  uploadPDFToBucket: {
    __typename?: 'documents';
    message: string;
    success: boolean;
  };
};

export type UploadFileMutationVariables = {
  pdf: string;
  title: string;
  user_id: Scalars['uuid'];
  role: string;
};

//-------------
export const CustomNotifDocument = gql`
    mutation CustomNotif($subject: String!, $message: String!, $user_id: String, $role: String) {
    sendCustomNotif(input: {subject: $subject, message: $message, user_id: $user_id, role: $role}) {
      message
      success
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CustomNotifGQL extends Apollo.Mutation<CustomNotifMutation, CustomNotifMutationVariables> {
  document = CustomNotifDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type CustomNotifMutation = {
  __typename?: 'mutation_root';
} & {
  sendCustomNotif: {
    __typename?: 'SendCustomNotifOutput';
    message: string;
    success: boolean;
  };
};

export type CustomNotifMutationVariables = {
  subject: string;
  message: string;
  user_id?: string;
  role?: string;
};

//----------

// Define the GraphQL mutation
export const UploadEvRicevutaDocument = gql`
  mutation uploadEVricevuta(
    $pdf: String!
    $rivecuta_number: String!
    $wallet_id: String!
  ) {
    uploadEVricevuta(
      input: {
        pdf: $pdf
        rivecuta_number: $rivecuta_number
        wallet_id: $wallet_id
      }
    ) {
      message
      success
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UploadEvRicevutaGQL extends Apollo.Mutation<
  UploadEvRicevutaMutation,
  UploadEvRicevutaMutationVariables
> {
  document = UploadEvRicevutaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UploadEvRicevutaMutation = {
  __typename?: 'mutation_root';
} & {
  uploadEVricevuta: {
    __typename?: 'uploadEVricevutaOutput';
    message: string;
    success: boolean;
  };
};

export type UploadEvRicevutaMutationVariables = {
  pdf: string;
  rivecuta_number: string;
  wallet_id: string;
};

//----------

// Define the GraphQL mutation
export const DeleteDocumentDocument = gql`
  mutation deleteDoc($uuid: uuid!) {
    delete_documents_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteDocumentGQL extends Apollo.Mutation<DeleteDocumentMutation, DeleteDocumentMutationVariables> {
  document = DeleteDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteDocumentMutation = {
  __typename?: 'mutation_root';
} & {
  delete_documents_by_pk: {
    __typename?: 'documents';
    uuid: Scalars['uuid'];
  };
};

export type DeleteDocumentMutationVariables = {
  uuid: Scalars['uuid'];
};

//------------------

export const GetImpiantiOnMapDocument = gql`
  query getImpiantiOnMap {
    impianti {
      uuid
      description
      impianti_name
      latitude
      longitude
      impianti_user {
        user {
          users_registry {
            name
            surname
          }
          users_company {
            company_name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetImpiantiOnMapGQL extends Apollo.Query<GetImpiantiOnMapQuery, GetImpiantiOnMapQueryVariables> {
  document = GetImpiantiOnMapDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetImpiantiOnMapQuery = {
  __typename?: 'query_root';
} & {
  impianti: Array<{
    __typename?: 'impianti';
    uuid: Scalars['uuid'];
    description: Scalars['String'];
    impianti_name: Scalars['String'];
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
    impianti_user: {
      __typename?: 'impianti_user';
      user: {
        __typename?: 'users';
        users_registry: Array<{
          __typename?: 'users_registry';
          name: Scalars['String'];
          surname: Scalars['String'];
        }>;
        users_company: Array<{
          __typename?: 'users_company';
          company_name: Scalars['String'];
        }>;
      };
    };
  }>;
};

export type GetImpiantiOnMapQueryVariables = {};

//-------------

export const GetUsersDocument = gql`
  query getUsers($_eq: roles_enum!) {
    users(where: { role: { _eq: $_eq } }) {
      email
      id
      role
      state
      users_registry {
        name
        phone
        surname
        fiscal_code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
  document = GetUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetUsersQuery = {
  __typename?: 'query_root';
} & {
  users: Array<{
    __typename?: 'users';
    email: Scalars['String'];
    id: Scalars['uuid'];
    role: Scalars['String'];
    state: Scalars['String'];
    users_registry: Array<{
      __typename?: 'users_registry';
      name: Scalars['String'];
      phone: Scalars['String'];
      surname: Scalars['String'];
      fiscal_code: Scalars['String'];
    }>;
  }>;
};

export type GetUsersQueryVariables = {
  _eq: Scalars['String'];
};

//------------------


export const GetImpiantiDocument = gql`
  query getImpianti {
    impianti {
      uuid
      description
      impianti_name
      latitude
      longitude
      cap
      citta
      indirizzo
      provincia
      technician {
        id
        users_registry {
          name
          surname
        }
      }
      user {
        id
        users_registry {
          name
          surname
        }
      }
      manager {
        id
        users_registry {
          name
          surname
        }
      }
      company {
        partita
        id
        company_name
        codice_fiscale
      }
      devices_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetImpiantiGQL extends Apollo.Query<GetImpiantiQuery, GetImpiantiQueryVariables> {
  document = GetImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetImpiantiQuery = {
  __typename?: 'query_root';
} & {
  impianti: Array<{
    __typename?: 'impianti';
    uuid: Scalars['uuid'];
    description: Scalars['String'];
    impianti_name: Scalars['String'];
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
    cap: Scalars['String'];
    citta: Scalars['String'];
    indirizzo: Scalars['String'];
    provincia: Scalars['String'];
    technician: {
      __typename?: 'users';
      id: Scalars['uuid'];
      users_registry: Array<{
        __typename?: 'users_registry';
        name: Scalars['String'];
        surname: Scalars['String'];
      }>;
    };
    user: {
      __typename?: 'users';
      id: Scalars['uuid'];
      users_registry: Array<{
        __typename?: 'users_registry';
        name: Scalars['String'];
        surname: Scalars['String'];
      }>;
    };
    manager: {
      __typename?: 'users';
      id: Scalars['uuid'];
      users_registry: Array<{
        __typename?: 'users_registry';
        name: Scalars['String'];
        surname: Scalars['String'];
      }>;
    };
    company: {
      __typename?: 'company';
      partita: Scalars['String'];
      id: Scalars['uuid'];
      company_name: Scalars['String'];
      codice_fiscale: Scalars['String'];
    };
    devices_aggregate: {
      __typename?: 'devices_aggregate';
      aggregate: {
        __typename?: 'aggregate';
        count: Scalars['Int'];
      };
    };
  }>;
};

export type GetImpiantiQueryVariables = {};

//

/** =============================
 *  QUERY: GetAuthorizations for RFId
 *  =============================
 */
export const GetAuthorizationsDocument = gql`
  query GetAuthorizations {
    authorize(order_by: { createdat: desc }) {
      id
      idtag
      status
      user {
        id
        name
        surname
      }
    }
  }
`;



@Injectable({
  providedIn: 'root',
})
export class GetAuthorizationsGQL extends Apollo.Query<GetAuthorizationsQuery,GetAuthorizationsQueryVariables> {
  document = GetAuthorizationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export type GetAuthorizationsQuery = {
  __typename?: 'query_root';
  authorize: Array<{
    __typename?: 'authorize';
    id: string;
    idtag: string;
    status: string | null;
    user: {
      __typename?: 'users';
      id: string;
      name: string | null;
      surname: string | null;
    } | null;
  }>;
};

export type GetAuthorizationsQueryVariables = {};

/** =============================
 *  MUTATION: InsertAuthorize
 *  =============================
 */
export const InsertAuthorizeDocument = gql`
  mutation InsertAuthorize($object: authorize_insert_input!) {
    insert_authorize_one(object: $object) {
      id
      idtag
      status
      user {
        id
        name
        surname
      }
    }
  }
`;

export type InsertAuthorizeMutation = {
  __typename?: 'mutation_root';
  insert_authorize_one: {
    __typename?: 'authorize';
    id: string;
    idtag: string;
    status: string | null;
  } | null;
};

export type InsertAuthorizeMutationVariables = {
  object: {
    idtag: string;
    status?: string | null;
    user_id: string;
  };
};

@Injectable({
  providedIn: 'root',
})
export class InsertAuthorizeGQL extends Apollo.Mutation<
  InsertAuthorizeMutation,
  InsertAuthorizeMutationVariables
> {
  document = InsertAuthorizeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

/** =============================
 *  MUTATION: UpdateAuthorize
 *  =============================
 */
export const UpdateAuthorizeDocument = gql`
  mutation UpdateAuthorize($id: uuid!, $set: authorize_set_input!) {
    update_authorize_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      idtag
      status
      user {
        id
        name
        surname
      }
    }
  }
`;

export type UpdateAuthorizeMutation = {
  __typename?: 'mutation_root';
  update_authorize_by_pk: {
    __typename?: 'authorize';
    id: string;
    idtag: string;
    status: string | null;
  } | null;
};

export type UpdateAuthorizeMutationVariables = {
  id: string;
  set: {
    status?: string | null;
  };
};

@Injectable({
  providedIn: 'root',
})
export class UpdateAuthorizeGQL extends Apollo.Mutation<
  UpdateAuthorizeMutation,
  UpdateAuthorizeMutationVariables
> {
  document = UpdateAuthorizeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

/** =============================
 *  MUTATION: DeleteAuthorize
 *  =============================
 */
export const DeleteAuthorizeDocument = gql`
  mutation DeleteAuthorize($id: uuid!) {
    delete_authorize_by_pk(id: $id) {
      id
    }
  }
`;

export type DeleteAuthorizeMutation = {
  __typename?: 'mutation_root';
  delete_authorize_by_pk: { __typename?: 'authorize'; id: string } | null;
};

export type DeleteAuthorizeMutationVariables = {
  id: string;
};

@Injectable({
  providedIn: 'root',
})
export class DeleteAuthorizeGQL extends Apollo.Mutation<
  DeleteAuthorizeMutation,
  DeleteAuthorizeMutationVariables
> {
  document = DeleteAuthorizeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
//
export const GetAllAddressDocument = gql`
  query getAllAddress {
    companies {
      codice_ateco
      codice_fiscale
      company_name
      id
      partita
      sales_manager_id
      companies_adress {
        cap
        citta
        indirizzo
        provincia
        id
      }
      isPartner
      partner_company_name {
        company_name
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllAddressGQL extends Apollo.Query<GetAllAddressQuery, GetAllAddressQueryVariables> {
  document = GetAllAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllAddressQuery = {
  __typename?: 'query_root';
} & {
  companies: Array<{
    __typename?: 'company';
    codice_ateco: Scalars['String'];
    codice_fiscale: Scalars['String'];
    company_name: Scalars['String'];
    id: Scalars['uuid'];
    isPartner: Scalars['Boolean'];
    partita: Scalars['String'];
    sales_manager_id: Scalars['uuid'];
    partner_company_name: Array<{
      __typename?: 'partner_company_name';
      company_name: Scalars['String'];
      id: Scalars['uuid'];
    }>;
    companies_adress: Array<{
      __typename?: 'companies_adress';
      cap: Scalars['String'];
      citta: Scalars['String'];
      indirizzo: Scalars['String'];
      provincia: Scalars['String'];
    }>;
  }>;
};

export type GetAllAddressQueryVariables = {};

//-----------

export const InsertCompanyDocument = gql`
  mutation insertCompany($codice_ateco: String!, $codice_fiscale: String!, $company_name: String!, $partita: String!, $cap: String!, $citta: String!, $indirizzo: String!, $provincia: String!, $isPartner: Boolean!, $partner_company_id: uuid, $sales_manager_id: uuid) {
    insert_companies_one(object: {codice_ateco: $codice_ateco, codice_fiscale: $codice_fiscale, sales_manager_id: $sales_manager_id, company_name: $company_name, partita: $partita, companies_adress: {data: {cap: $cap, citta: $citta, indirizzo: $indirizzo, provincia: $provincia}}, isPartner: $isPartner, partner_company_id: $partner_company_id}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertCompanyGQL extends Apollo.Mutation<InsertCompanyMutation, InsertCompanyMutationVariables> {
  document = InsertCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertCompanyMutation = {
  __typename?: 'mutation_root';
} & {
  insert_companies_one: {
    __typename?: 'company';
    id: Scalars['uuid'];
  };
};

export type InsertCompanyMutationVariables = {
  codice_ateco: Scalars['String'];
  codice_fiscale: Scalars['String'];
  company_name: Scalars['String'];
  partita: Scalars['String'];
  cap: Scalars['String'];
  citta: Scalars['String'];
  indirizzo: Scalars['String'];
  provincia: Scalars['String'];
  isPartner: Scalars['Boolean'];
  partner_company_id: Scalars['uuid'];
  sales_manager_id: Scalars['uuid'];
};

//----------

export const DeleteCompanyDocument = gql`
  mutation deleteCompany($id: uuid!) {
    delete_companies_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteCompanyGQL extends Apollo.Mutation<DeleteCompanyMutation, DeleteCompanyMutationVariables> {
  document = DeleteCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteCompanyMutation = {
  __typename?: 'mutation_root';
} & {
  delete_companies_by_pk: {
    __typename?: 'company';
    id: Scalars['uuid'];
  };
};

export type DeleteCompanyMutationVariables = {
  id: Scalars['uuid'];
};

//------------

export const UpdateCompanyDocument = gql`
mutation updateCompany($id: uuid!, $codice_ateco: String!, $codice_fiscale: String!, $company_name: String!, $partita: String!, $isPartner: Boolean!, $partner_company_id: uuid, $sales_manager_id: uuid) {
  update_companies_by_pk(pk_columns: {id: $id}, _set: {codice_ateco: $codice_ateco, codice_fiscale: $codice_fiscale, company_name: $company_name, partita: $partita, isPartner: $isPartner, partner_company_id: $partner_company_id, sales_manager_id: $sales_manager_id}) {
    id
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
  document = UpdateCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateCompanyMutation = {
  __typename?: 'mutation_root';
} & {
  update_companies_by_pk: {
    __typename?: 'company';
    id: Scalars['uuid'];
  };
};

export type UpdateCompanyMutationVariables = {
  id: Scalars['uuid'];
  codice_ateco: Scalars['String'];
  codice_fiscale: Scalars['String'];
  company_name: Scalars['String'];
  partita: Scalars['String'];
  isPartner: Scalars['Boolean'];
  partner_company_id: Scalars['uuid'];
  sales_manager_id: Scalars['uuid'];
};
//----------------

export const UpdateAddressDocument = gql`
  mutation updateAddress($id: uuid!, $cap: String!, $citta: String!, $indirizzo: String!, $provincia: String!) {
    update_adresses_by_pk(pk_columns: {id: $id}, _set: {cap: $cap, citta: $citta, indirizzo: $indirizzo, provincia: $provincia}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateAddressGQL extends Apollo.Mutation<UpdateAddressMutation, UpdateAddressMutationVariables> {
  document = UpdateAddressDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateAddressMutation = {
  __typename?: 'mutation_root';
} & {
  update_adresses_by_pk: {
    __typename?: 'addresses';
    id: Scalars['uuid'];
  };
};

export type UpdateAddressMutationVariables = {
  id: Scalars['uuid'];
  cap: Scalars['String'];
  citta: Scalars['String'];
  indirizzo: Scalars['String'];
  provincia: Scalars['String'];
};


// -------------

export const RegisterNewUserDocument = gql`
mutation registrerNewUser($companyId: String, $email: String!, $fiscal_code: String!, $name: String!, $note: String, $password: String!, $phone: String!, $role: String!, $surname: String!, $partita: String, $sales_manager_id: String) {
  registerUser(data: {companyId: $companyId, email: $email, fiscal_code: $fiscal_code, name: $name, note: $note, password: $password, phone: $phone, role: $role, surname: $surname, partita: $partita, sales_manager_id: $sales_manager_id}) {
    success
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class RegisterNewUserGQL extends Apollo.Mutation<RegisterNewUserMutation, RegisterNewUserMutationVariables> {
  document = RegisterNewUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type RegisterNewUserMutation = {
  __typename?: 'mutation_root';
} & {
  registerUser: {
    __typename?: 'RegisterResponse';
    success: Scalars['Boolean'];
  };
};

export type RegisterNewUserMutationVariables = {
  companyId: Scalars['String'];
  email: Scalars['String'];
  fiscal_code: Scalars['String'];
  name: Scalars['String'];
  note: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  role: Scalars['String'];
  surname: Scalars['String'];
  partita: Scalars['String'];
  sales_manager_id: Scalars['String'];
};

//-------------


export const UpdateUserDetailDocument = gql`
mutation updateUserDetail($company_id: String, $email: String!, $fiscal_code: String, $id: String!, $name: String!, $note: String, $phone: String!, $role: String!, $surname: String!, $sales_manager_id: String, $state: String) {
  updateUserInfo(data: {email: $email, fiscal_code: $fiscal_code, id: $id, name: $name, note: $note, phone: $phone, role: $role, surname: $surname, company_id: $company_id, sales_manager_id: $sales_manager_id, state: $state}) {
    success
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUserDetailGQL extends Apollo.Mutation<UpdateUserDetailMutation, UpdateUserDetailMutationVariables> {
  document = UpdateUserDetailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateUserDetailMutation = {
  __typename?: 'mutation_root';
} & {
  updateUserInfo: {
    __typename?: 'UpdateResponse';
    success: Scalars['Boolean'];
  };
};

export type UpdateUserDetailMutationVariables = {
  company_id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fiscal_code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  surname: Scalars['String'];
  sales_manager_id: Scalars['String'];
  state: Scalars['String'];
};

//---------------------------------

export const GetMetricDeviceTypeDocument = gql`
  query getMetricDeviceType {
    metric_device_type {
      id
      type
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricDeviceTypeGQL extends Apollo.Query<GetMetricDeviceTypeQuery> {
  document = GetMetricDeviceTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricDeviceTypeQuery = {
  __typename?: 'query_root';
} & {
  metric_device_type: Array<{
    __typename?: 'metric_device_type';
    id: Scalars['String'];
    type: Scalars['String'];
  }>;
};

//--------------------

export const GetMetricsByTypeIdDocument = gql`
  query getMetricsByTypeId($_eq: uuid!) {
    device_metrics(where: {type_id: {_eq: $_eq}}) {
      label
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricsByTypeIdGQL extends Apollo.Query<GetMetricsByTypeIdQuery> {
  document = GetMetricsByTypeIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricsByTypeIdQuery = {
  __typename?: 'query_root';
} & {
  device_metrics: Array<{
    __typename?: 'device_metrics';
    label: Scalars['String'];
    uuid: Scalars['uuid'];
  }>;
};

//-------------

export const GetMetricsByDeviceIdDocument = gql`
  query getMetricsByDeviceId($_eq: uuid!) {
    device_metrics(where: { device_id: { _eq: $_eq } }) {
      affix
      blue
      decimalDigits
      green
      label
      maxValue
      minValue
      timeSeries_period
      uuid
      var_name
      widget_type
      device {
        device_name
        uuid
      }
      red
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricsByDeviceIdGQL extends Apollo.Query<GetMetricsByDeviceIdQuery, GetMetricsByDeviceIdQueryVariables> {
  document = GetMetricsByDeviceIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricsByDeviceIdQuery = {
  __typename?: 'query_root';
} & {
  device_metrics: Array<{
    __typename?: 'device_metrics';
    affix: Scalars['String'];
    blue: Scalars['Int'];
    decimalDigits: Scalars['Int'];
    green: Scalars['Int'];
    label: Scalars['String'];
    maxValue: Scalars['Float'];
    minValue: Scalars['Float'];
    timeSeries_period: Scalars['Int'];
    uuid: Scalars['uuid'];
    var_name: Scalars['String'];
    widget_type: Scalars['String'];
    device: {
      __typename?: 'devices';
      device_name: Scalars['String'];
      uuid: Scalars['uuid'];
    };
    red: Scalars['Int'];
    type_id: Scalars['uuid'];
  }>;
};

export type GetMetricsByDeviceIdQueryVariables = {
  _eq: Scalars['uuid'];
};

//-----------

export const GetDevicesByImpIdDocument = gql`
  query getDevicesByImpId($_eq: uuid!) {
    devices(where: { impianti_id: { _eq: $_eq } }) {
      connection_name
      device_name
      station_id
      system_name
      system_type
      start_since
      uuid
      impianti_id
      devices_impianti {
        impianti_name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDevicesByImpIdGQL extends Apollo.Query<GetDevicesByImpIdQuery, GetDevicesByImpIdQueryVariables> {
  document = GetDevicesByImpIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetDevicesByImpIdQuery = {
  __typename?: 'query_root';
} & {
  devices: Array<{
    __typename?: 'devices';
    connection_name: Scalars['String'];
    device_name: Scalars['String'];
    station_id: Scalars['uuid'];
    system_name: Scalars['String'];
    system_type: Scalars['String'];
    start_since: Scalars['String'];
    uuid: Scalars['uuid'];
    impianti_id: Scalars['uuid'];
    devices_impianti: Array<{
      __typename?: 'devices_impianti';
      impianti_name: Scalars['String'];
    }>;
    type_id: Scalars['uuid'];
  }>;
};

export type GetDevicesByImpIdQueryVariables = {
  _eq: Scalars['uuid'];
};

//------------

export const GetAllGroupsDocument = gql`
  query getAllgroups {
    groups {
      group_name
      uuid
      order
      device_id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllGroupsGQL extends Apollo.Query<GetAllGroupsQuery> {
  document = GetAllGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllGroupsQuery = {
  __typename?: 'query_root';
} & {
  groups: Array<{
    __typename?: 'groups';
    group_name: Scalars['String'];
    uuid: Scalars['uuid'];
    order: Scalars['Int'];
    device_id: Scalars['uuid'];
  }>;
};

//------------

export const GetMetricsGroupsDocument = gql`
  query GetMetricsGroups {
    metrics_groups {
      group_id
      metric_id
      uuid
      group {
        group_name
        order
        device_id
      }
      metric {
        label
        device {
          device_name
          system_name
          devices_impianti {
            impianti_name
          }
        }
      }
      order
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricsGroupsGQL extends Apollo.Query<GetMetricsGroupsQuery> {
  document = GetMetricsGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricsGroupsQuery = {
  __typename?: 'query_root';
} & {
  metrics_groups: Array<{
    __typename?: 'metrics_groups';
    group_id: Scalars['uuid'];
    metric_id: Scalars['uuid'];
    uuid: Scalars['uuid'];
    order: Scalars['Int'];
    group: {
      __typename?: 'metric_groups';
      group_name: Scalars['String'];
      order: Scalars['Int'];
      device_id: Scalars['uuid'];
    };
    metric: {
      __typename?: 'device_metrics';
      label: Scalars['String'];
      device: {
        __typename?: 'devices';
        device_name: Scalars['String'];
        system_name: Scalars['String'];
        devices_impianti: Array<{
          __typename?: 'devices_impianti';
          impianti_name: Scalars['String'];
        }>;
      };
    };
  }>;
};

//-----------

export const UpdateMetricGroupDocument = gql`
  mutation updateMetricGroup($uuid: uuid!, $group_id: uuid!, $order: String) {
    update_metrics_groups_by_pk(pk_columns: {uuid: $uuid}, _set: {group_id: $group_id, order: $order}) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateMetricGroupGQL extends Apollo.Mutation<UpdateMetricGroupMutation, UpdateMetricGroupMutationVariables> {
  document = UpdateMetricGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateMetricGroupMutation = {
  __typename?: 'mutation_root';
} & {
  update_metrics_groups_by_pk?: Maybe<{
    __typename?: 'metrics_groups';
    uuid: Scalars['uuid'];
  }>;
};

export type UpdateMetricGroupMutationVariables = {
  uuid: Scalars['uuid'];
  group_id: Scalars['uuid'];
  order: Scalars['String'];
};

//-----------

export const InsertMetricsGroupsDocument = gql`
  mutation insertMetricsGroups($group_id: uuid!, $metric_id: uuid!) {
    insert_metrics_groups_one(object: {group_id: $group_id, metric_id: $metric_id}) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertMetricsGroupsGQL extends Apollo.Mutation<InsertMetricsGroupsMutation, InsertMetricsGroupsMutationVariables> {
  document = InsertMetricsGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertMetricsGroupsMutation = {
  __typename?: 'mutation_root';
} & {
  insert_metrics_groups_one?: Maybe<{
    __typename?: 'metrics_groups';
    uuid: Scalars['uuid'];
  }>;
};

export type InsertMetricsGroupsMutationVariables = {
  group_id: Scalars['uuid'];
  metric_id: Scalars['uuid'];
};

//-----------

export const DeleteMetricGroupDocument = gql`
  mutation deleteMetricGroup($uuid: uuid!) {
    delete_metrics_groups_by_pk(uuid: $uuid) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteMetricGroupGQL extends Apollo.Mutation<DeleteMetricGroupMutation, DeleteMetricGroupMutationVariables> {
  document = DeleteMetricGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteMetricGroupMutation = {
  __typename?: 'mutation_root';
} & {
  delete_metrics_groups_by_pk?: Maybe<{
    __typename?: 'metrics_groups';
    uuid: Scalars['uuid'];
  }>;
};

export type DeleteMetricGroupMutationVariables = {
  uuid: Scalars['uuid'];
};

//--------------------------------------
// Query for fetching reports
export const GetReportDocument = gql`
  query getReport {
    reports {
      from
      id
      metric_name
      until
      url
      device {
        device_name
        system_name
        devices_impianti {
          impianti_name
          company {
            company_name
          }
          user {
            users_registry {
              name
              surname
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReportGQL extends Apollo.Query<GetReportQuery, GetReportQueryVariables> {
  document = GetReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetReportQuery = {
  __typename?: 'query_root';
} & {
  reports: Array<{
    __typename?: 'reports';
    from: Scalars['String'];
    id: Scalars['uuid'];
    metric_name: Scalars['String'];
    until: Scalars['String'];
    url: Scalars['String'];
    device: {
      __typename?: 'devices';
      device_name: Scalars['String'];
      system_name: Scalars['String'];
      devices_impianti: {
        __typename?: 'impianti';
        impianti_name: Scalars['String'];
        company: {
          __typename?: 'companies';
          company_name: Scalars['String'];
        };
        user: {
          __typename?: 'users';
          users_registry: {
            __typename?: 'users_registry';
            name: Scalars['String'];
            surname: Scalars['String'];
          };
        };
      };
    };
  }>;
};

export type GetReportQueryVariables = {}; // No variables required for this query


//--------------------------

// Query for creating a report
export const CreateReportDocument = gql`
  query createReport($deviceName: String!, $endDate: String!, $impiantoName: String!, $metricName: String!, $startDate: String!, $userId: String!, $absVal: Boolean!, $dailyProd: Boolean!) {
    createReportPdf(data: {deviceName: $deviceName, endDate: $endDate, impiantoName: $impiantoName, metricName: $metricName, startDate: $startDate, userId: $userId, absVal: $absVal, dailyProd: $dailyProd}) {
      data
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateReportGQL extends Apollo.Query<CreateReportQuery, CreateReportQueryVariables> {
  document = CreateReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type CreateReportQuery = {
  __typename?: 'query_root';
} & {
  createReportPdf: {
    __typename?: 'createReportPdfResponse';
    data:  Scalars['String'];
  };
};

export type CreateReportQueryVariables = {
  deviceName: Scalars['String'];
  endDate: Scalars['String'];
  impiantoName: Scalars['String'];
  metricName:Scalars['String'];
  startDate: Scalars['String'];
  userId: Scalars['String'];
  absVal: Scalars['Boolean'];
  dailyProd: Scalars['Boolean'];
};


//---------------

// Mutation for deleting a report
export const DeleteReportDocument = gql`
  mutation deleteReport($id: uuid!) {
    delete_reports_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteReportGQL extends Apollo.Mutation<DeleteReportMutation, DeleteReportMutationVariables> {
  document = DeleteReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteReportMutation = {
  __typename?: 'mutation_root';
} & {
  delete_reports_by_pk: {
    __typename?: 'reports';
    id: Scalars['String'];
  };
};

export type DeleteReportMutationVariables = {
  id: Scalars['String'];
};

//----------------------------

// Query for getting cron triggers
export const GetCronDocument = gql`
  query getCron {
    cron_triggers {
      absVal
      dailyProd
      frequency
      id
      metric_name
      period
      user_id
      device {
        uuid
        device_name
        system_name
        devices_impianti {
          impianti_name
          company {
            company_name
          }
          user {
            users_registry {
              name
              surname
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCronGQL extends Apollo.Query<GetCronQuery, GetCronQueryVariables> {
  document = GetCronDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetCronQuery = {
  __typename?: 'query_root';
} & {
  cron_triggers: Array<{
    __typename?: 'cron_triggers';
    absVal: Scalars['String'];
    dailyProd: Scalars['Boolean'];
    frequency: Scalars['Boolean'];
    id: Scalars['uuid'];
    metric_name: Scalars['String'];
    period: Scalars['String'];
    user_id: Scalars['uuid'];
    device: {
      __typename?: 'devices';
      uuid: Scalars['uuid'];
      device_name: Scalars['String'];
      system_name: Scalars['String'];
      devices_impianti: {
        __typename?: 'impianti';
        impianti_name: Scalars['String'];
        company: {
          __typename?: 'companies';
          company_name: Scalars['String'];
        };
        user: {
          __typename?: 'users';
          users_registry: {
            __typename?: 'users_registry';
            name: Scalars['String'];
            surname: Scalars['String'];
          };
        };
      };
    };
  }>;
};

export type GetCronQueryVariables = {}; // No variables required for this query


//-------------------

// Mutation for deleting a cron trigger
export const DeleteCronDocument = gql`
  mutation delCron($id: uuid!) {
    delete_cron_triggers_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteCronGQL extends Apollo.Mutation<DeleteCronMutation, DeleteCronMutationVariables> {
  document = DeleteCronDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteCronMutation = {
  __typename?: 'mutation_root';
} & {
  delete_cron_triggers_by_pk: {
    __typename?: 'cron_triggers';
    id: Scalars['uuid'];
  };
};

export type DeleteCronMutationVariables = {
  id: Scalars['uuid'];
};

//-----------------

// Mutation for inserting a new cron trigger
export const InsertCronDocument = gql`
  mutation insertCron($device_id: uuid, $frequency: String!, $metric_name: String, $period: String!, $user_id: uuid!, $absVal: Boolean!, $dailyProd: Boolean!) {
    insert_cron_triggers_one(object: {device_id: $device_id, frequency: $frequency, metric_name: $metric_name, period: $period, user_id: $user_id, absVal: $absVal, dailyProd: $dailyProd}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertCronGQL extends Apollo.Mutation<InsertCronMutation, InsertCronMutationVariables> {
  document = InsertCronDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertCronMutation = {
  __typename?: 'mutation_root';
} & {
  insert_cron_triggers_one: {
    __typename?: 'cron_triggers';
    id: Scalars['uuid'];
  };
};

export type InsertCronMutationVariables = {
  frequency: Scalars['String'];
  metric_name: Scalars['String'];
  device_id: Scalars['uuid'];
  period: Scalars['String'];
  user_id: Scalars['uuid'];
  absVal: Scalars['Boolean'];
  dailyProd: Scalars['Boolean'];
};

//----------------

// Mutation for updating a cron trigger
export const UpdateCromDocument = gql`
  mutation updateCrom($id: uuid!, $frequency: String!, $period: String!, $absVal: Boolean!, $dailyProd: Boolean!) {
    update_cron_triggers_by_pk(pk_columns: {id: $id}, _set: {frequency: $frequency, period: $period, absVal: $absVal, dailyProd: $dailyProd}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateCromGQL extends Apollo.Mutation<UpdateCromMutation, UpdateCromMutationVariables> {
  document = UpdateCromDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateCromMutation = {
  __typename?: 'mutation_root';
} & {
  update_cron_triggers_by_pk: {
    __typename?: 'cron_triggers';
    id: Scalars['uuid'];
  };
};

export type UpdateCromMutationVariables = {
  id: Scalars['uuid'];
  frequency: Scalars['String'];
  period: Scalars['String'];
  absVal: Scalars['Boolean'];
  dailyProd: Scalars['Boolean'];
};

//---------------------

// Query for getting dashboard report
export const GetDashboardReportDocument = gql`
  query getDashboardReport($from: String!, $until: String!, $deviceId: String!) {
    dashboardReport(data: {from: $from, until: $until, deviceId: $deviceId}) {
      results
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDashboardReportGQL extends Apollo.Query<GetDashboardReportQuery, GetDashboardReportQueryVariables> {
  document = GetDashboardReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetDashboardReportQuery = {
  __typename?: 'query_root';
} & {
  dashboardReport: {
    __typename?: 'DashboardReport';
    results: Scalars['String'];
  };
};

export type GetDashboardReportQueryVariables = {
  from: Scalars['String'];
  until: Scalars['String'];
  deviceId: Scalars['String'];
};

//----------------------------

// Query for getting impianti by user ID
export const GetImpiantiByUserIdDocument = gql`
  query getImpiantiByUserId($_eq: uuid!) {
    impianti(where: {impianti_users: {user_id: {_eq: $_eq}}}) {
      uuid
      description
      impianti_name
      latitude
      longitude
      technician {
        id
        users_registry {
          name
          surname
        }
      }
      user {
        id
        users_registry {
          name
          surname
        }
      }
      manager {
        id
        users_registry {
          name
          surname
        }
      }
      company {
        partita
        id
        company_name
        codice_fiscale
      }
      devices_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetImpiantiByUserIdGQL extends Apollo.Query<GetImpiantiByUserIdQuery, GetImpiantiByUserIdQueryVariables> {
  document = GetImpiantiByUserIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetImpiantiByUserIdQuery = {
  __typename?: 'query_root';
} & {
  impianti: Array<{
    __typename?: 'impianti';
    uuid: string;
    description: string;
    impianti_name: string;
    latitude: number;
    longitude: number;
    technician: {
      __typename?: 'technicians';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    user: {
      __typename?: 'users';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    manager: {
      __typename?: 'users';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    company: {
      __typename?: 'companies';
      partita: string;
      id: string;
      company_name: string;
      codice_fiscale: string;
    };
    devices_aggregate: {
      __typename?: 'devices_aggregate';
      aggregate: {
        __typename?: 'devices_aggregate_fields';
        count: number;
      };
    };
  }>;
};

export type GetImpiantiByUserIdQueryVariables = {
  _eq: string;
};

//--------------------------

// Query for getting impianti by Company ID
export const GetImpiantiByCompanyIdDocument = gql`
  query getImpiantiByCompanyId($_eq: uuid!) {
    impianti(where: {company_id: {_eq: $_eq}}) {
      uuid
      description
      impianti_name
      latitude
      longitude
      technician {
        id
        users_registry {
          name
          surname
        }
      }
      user {
        id
        users_registry {
          name
          surname
        }
      }
      manager {
        id
        users_registry {
          name
          surname
        }
      }
      company {
        partita
        id
        company_name
        codice_fiscale
      }
      devices_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetImpiantiByCompanyIdGQL extends Apollo.Query<GetImpiantiByCompanyIdQuery, GetImpiantiByCompanyIdQueryVariables> {
  document = GetImpiantiByCompanyIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetImpiantiByCompanyIdQuery = {
  __typename?: 'query_root';
} & {
  impianti: Array<{
    __typename?: 'impianti';
    uuid: string;
    description: string;
    impianti_name: string;
    latitude: number;
    longitude: number;
    technician: {
      __typename?: 'technicians';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    user: {
      __typename?: 'users';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    manager: {
      __typename?: 'users';
      id: string;
      users_registry: Array<{
        __typename?: 'users_registry';
        name: string;
        surname: string;
      }>;
    };
    company: {
      __typename?: 'companies';
      partita: string;
      id: string;
      company_name: string;
      codice_fiscale: string;
    };
    devices_aggregate: {
      __typename?: 'devices_aggregate';
      aggregate: {
        __typename?: 'devices_aggregate_fields';
        count: number;
      };
    };
  }>;
};

export type GetImpiantiByCompanyIdQueryVariables = {
  _eq: string;
};


//----------------------------

// Query for getting tabs
export const GetTabsDocument = gql`
  query getTabs {
    tabs_groups {
      id
      group {
        group_name
      }
      tab_device {
        tab_type {
          comment
          id
        }
        tab_name
        device {
          device_name
          system_name
          devices_impianti {
            impianti_name
            user {
              users_registry {
                name
                surname
              }
            }
            company {
              company_name
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabsGQL extends Apollo.Query<GetTabsQuery, GetTabsQueryVariables> {
  document = GetTabsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetTabsQuery = {
  __typename?: 'query_root';
} & {
  tabs_groups: Array<{
    id: string;
    __typename?: 'tabs_groups';
    group: {
      __typename?: 'groups';
      group_name: string;
    };
    tab_device: {
      __typename?: 'tab_device';
      tab_type: {
        __typename?: 'tabs_types';
        comment: Scalars['String'];
        id: Scalars['String'];
      };
      tab_name: string;
      device: {
        __typename?: 'devices';
        device_name: string;
        devices_impianti: Array<{
          __typename?: 'devices_impianti';
          impianti_name: string;
          user: {
            __typename?: 'users';
            users_registry: Array<{
              __typename?: 'users_registry';
              name: string;
              surname: string;
            }>;
          };
          company: {
            __typename?: 'companies';
            company_name: string;
          };
        }>;
      };
    };
  }>;
};

export type GetTabsQueryVariables = {};

//----------------------------

// Query for getting group name by device ID
export const GetGroupNameByDeviceIdDocument = gql`
  query getGroupNameByDeviceId($_eq: uuid!) {
    groups(where: {metrics_groups: {metric: {device: {uuid: {_eq: $_eq}}}}}) {
      group_name
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetGroupNameByDeviceIdGQL extends Apollo.Query<GetGroupNameByDeviceIdQuery, GetGroupNameByDeviceIdQueryVariables> {
  document = GetGroupNameByDeviceIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetGroupNameByDeviceIdQuery = {
  __typename?: 'query_root';
} & {
  groups: Array<{
    __typename?: 'groups';
    group_name: string;
    uuid: string;
  }>;
};

export type GetGroupNameByDeviceIdQueryVariables = {
  _eq: Scalars['uuid'];
};


//----------------------------

// Mutation for inserting a tab
export const InsertTabDocument = gql`
  mutation insertTab($device_id: uuid!, $tab_name: String!, $type: tabs_types_enum!) {
    insert_tabs_devices_one(object: {device_id: $device_id, tab_name: $tab_name, type: $type}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertTabGQL extends Apollo.Mutation<InsertTabMutation, InsertTabMutationVariables> {
  document = InsertTabDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertTabMutation = {
  __typename?: 'mutation_root';
} & {
  insert_tabs_devices_one?: {
    __typename?: 'tabs_devices';
    id: Scalars['uuid'];
  };
};

export type InsertTabMutationVariables = {
  device_id: Scalars['uuid'];
  tab_name: Scalars['String'];
  type: Scalars['String'];
}

//----------------------------

// Mutation for inserting a tab group
export const InsertTabGroupDocument = gql`
  mutation insertTabGroup($group_id: uuid!, $tab_id: uuid!) {
    insert_tabs_groups_one(object: {group_id: $group_id, tab_id: $tab_id}) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertTabGroupGQL extends Apollo.Mutation<InsertTabGroupMutation, InsertTabGroupMutationVariables> {
  document = InsertTabGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertTabGroupMutation = {
  __typename?: 'mutation_root';
} & {
  insert_tabs_groups_one?: {
    __typename?: 'tabs_groups';
    id: Scalars['uuid'];
  };
};

export type InsertTabGroupMutationVariables = {
  group_id: Scalars['uuid'];
  tab_id: Scalars['uuid'];
};

//----------------------------

// Mutation for deleting a tab device
export const DeleteTabDeviceDocument = gql`
  mutation deleteTabsDevices($id: uuid!) {
    delete_tabs_devices_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTabDeviceGQL extends Apollo.Mutation<DeleteTabDeviceMutation, DeleteTabDeviceMutationVariables> {
  document = DeleteTabDeviceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteTabDeviceMutation = {
  __typename?: 'mutation_root';
} & {
  delete_tabs_devices_by_pk: {
    __typename?: 'tabs_devices';
    id: Scalars['uuid'];
  };
};

export type DeleteTabDeviceMutationVariables = {
  id: Scalars['uuid'];
};
//----------------------------

// Query for getting tab types
export const GetTabTypesDocument = gql`
  query getTabTypes {
    tabs_types {
      comment
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabTypesGQL extends Apollo.Query<GetTabTypesQuery, GetTabTypesQueryVariables> {
  document = GetTabTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetTabTypesQuery = {
  __typename?: 'query_root';
} & {
  tabs_types: Array<{
    __typename?: 'tabs_types';
    comment: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetTabTypesQueryVariables = {}; // No variables required for this query

//----------------

// Mutation for inserting a group
export const InsertGroupDocument = gql`
  mutation insertGroup($group_name: String!, $order: Int!, $device_id: uuid!) {
    insert_groups_one(object: {group_name: $group_name, order: $order, device_id: $device_id}) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertGroupGQL extends Apollo.Mutation<InsertGroupMutation, InsertGroupMutationVariables> {
  document = InsertGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertGroupMutation = {
  __typename?: 'mutation_root';
} & {
  insert_groups_one?: Maybe<{
    __typename?: 'groups';
    uuid: Scalars['uuid'];
  }>;
};

export type InsertGroupMutationVariables = {
  group_name: Scalars['String'];
  order: Scalars['Int'];
  device_id: Scalars['uuid'];
};

//------------------------

// Query for getting groups by group_name and device_id
export const GetGroupsDocument = gql`
  query getGroups($group_name: String!, $device_id: uuid!) {
    groups(where: {_and: {group_name: {_eq: $group_name}, device_id: {_eq: $device_id}}}) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetGroupsGQL extends Apollo.Query<GetGroupsQuery, GetGroupsQueryVariables> {
  document = GetGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetGroupsQuery = {
  __typename?: 'query_root';
} & {
  groups: Array<{
    __typename?: 'groups';
    uuid: Scalars['uuid'];
  }>;
};

export type GetGroupsQueryVariables = {
  group_name: Scalars['String'];
  device_id: Scalars['uuid'];
};

//-----------------

// Mutation for updating a group
export const UpdateGroupDocument = gql`
  mutation updateGroup($uuid: uuid!, $group_name: String!, $order: Int) {
    update_groups_by_pk(pk_columns: {uuid: $uuid}, _set: {group_name: $group_name, order: $order}) {
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateGroupGQL extends Apollo.Mutation<UpdateGroupMutation, UpdateGroupMutationVariables> {
  document = UpdateGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateGroupMutation = {
  __typename?: 'mutation_root';
} & {
  update_groups_by_pk?: Maybe<{
    __typename?: 'groups';
    uuid: Scalars['uuid'];
  }>;
};

export type UpdateGroupMutationVariables = {
  uuid: Scalars['uuid'];
  group_name: Scalars['String'];
  order?: Scalars['Int'];
};

//--------------

// Query for getting devices
export const GetDevicesDocument = gql`
  query getDevices {
    devices {
      connection_name
      device_name
      system_name
      system_type
      uuid
      impianti_id
      devices_impianti {
        impianti_name
        user {
          users_registry {
            surname
            name
          }
        }
        company {
          company_name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDevicesGQL extends Apollo.Query<GetDevicesQuery, GetDevicesQueryVariables> {
  document = GetDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetDevicesQuery = {
  __typename?: 'query_root';
} & {
  devices: Array<{
    __typename?: 'devices';
    connection_name: string;
    device_name: string;
    system_name: string;
    system_type: string;
    uuid: string;
    impianti_id: string;
    devices_impianti: {
      __typename?: 'impianti';
      impianti_name: string;
      user: {
        __typename?: 'users';
        users_registry: Array<{
          __typename?: 'users_registry';
          surname: string;
          name: string;
        }>;
      };
      company: {
        __typename?: 'companies';
        company_name: string;
      };
    };
  }>;
};

export type GetDevicesQueryVariables = {};

//---------------


export const GetTabDocument = gql`
  query getTabs($_eq: String!) {
    tabs_devices(where: {device: {device_name: {_eq: $_eq}}}) {
      tab_name
      type
      tabs_groups {
        group {
          group_name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabGQL extends Apollo.Query<GetTabQuery, GetTabQueryVariables> {
  document = GetTabDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetTabQuery = {
  __typename?: 'query_root';
} & {
  tabs_devices: Array<{
    __typename?: 'tabs_devices';
    tab_name: string;
    type: string;
    tabs_groups: Array<{
      __typename?: 'tabs_groups';
      group: {
        __typename?: 'groups';
        group_name: string;
      };
    }>;
  }>;
};

export type GetTabQueryVariables = {
  _eq: Scalars['String'];
};


//--------------

export const GetMetricGroupDocument = gql`
  query getMetricGroup($device_name: String!, $group_name: String!) {
    groups(
      order_by: { order: asc },
      where: {
        metrics_groups: {
          metric: {
            device: { device_name: { _eq: $device_name } }
          }
        },
        group_name: { _eq: $group_name }
      }
    ) {
      group_name
      metrics_groups(
        where: {
          metric: {
            device: { device_name: { _eq: $device_name } },
            visible: { _eq: true }
          }
        },
        order_by: { order: asc }
      ) {
        metric {
          affix
          blue
          decimalDigits
          device {
            connection_name
            device_name
          }
          function
          green
          label
          maxValue
          minValue
          red
          timeSeries_period
          unit_conversion
          uuid
          var_name
          visible
          widget_type
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricGroupGQL extends Apollo.Query<GetMetricGroupQuery, GetMetricGroupQueryVariables> {
  document = GetMetricGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricGroupQuery = {
  __typename?: 'query_root';
} & {
  groups: Array<{
    __typename?: 'groups';
    group_name: string;
    metrics_groups: Array<{
      __typename?: 'metrics_groups';
      metric: {
        __typename?: 'metrics';
        affix: string;
        blue: string;
        decimalDigits: number;
        device: {
          __typename?: 'devices';
          connection_name: string;
          device_name: string;
        };
        function: string;
        green: string;
        label: string;
        maxValue: number;
        minValue: number;
        red: string;
        timeSeries_period: string;
        unit_conversion: string;
        uuid: string;
        var_name: string;
        visible: boolean;
        widget_type: string;
      };
    }>;
  }>;
};

export type GetMetricGroupQueryVariables = {
  device_name: Scalars['String'];
  group_name: Scalars['String'];
};

//-----------------

// Query for getting groups by group_name and device_id
export const GetTabsByTabNameDocument = gql`
  query getTabs($tab_name: String!, $device_id: uuid!, $tab_type: tabs_types_enum!) {
  tabs_devices(where: {_and: {tab_name: {_eq: $tab_name}, device_id: {_eq: $device_id}, type: {_eq: $tab_type}}}) {
    id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabsByTabNameGQL extends Apollo.Query<GetTabsByTabNameQuery, GetTabsByTabNameQueryVariables> {
  document = GetTabsByTabNameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetTabsByTabNameQuery = {
  __typename?: 'query_root';
} & {
  tabs_devices: Array<{
    __typename?: 'tabs_devices';
    id: Scalars['uuid'];
  }>;
};

export type GetTabsByTabNameQueryVariables = {
  tab_name: Scalars['String'];
  tab_type: Scalars['String'];
  device_id: Scalars['uuid'];
};


//-----------------

// Query for getting metric types
export const GetMetricTypeDocument = gql`
  query metricType {
    metric_type {
      comment
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMetricTypeGQL extends Apollo.Query<GetMetricTypeQuery, GetMetricTypeQueryVariables> {
  document = GetMetricTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetMetricTypeQuery = {
  __typename?: 'query_root';
} & {
  metric_type: Array<{
    __typename?: 'metric_type';
    comment: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetMetricTypeQueryVariables = {}; // No variables required for this query

//-----------------------------

// Query for getting system types
export const GetSystemTypeDocument = gql`
  query systemType {
    system_type {
      comment
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSystemTypeGQL extends Apollo.Query<GetSystemTypeQuery, GetSystemTypeQueryVariables> {
  document = GetSystemTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetSystemTypeQuery = {
  __typename?: 'query_root';
} & {
  system_type: Array<{
    __typename?: 'system_type';
    comment: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetSystemTypeQueryVariables = {}; // No variables required for this query


//-----------------

export const InsertTabsGroupsOneDocument = gql`
  mutation insertTabsGroupsOne($group_id: uuid!, $metric_id: uuid!, $metric_order: numeric!, $tab_id: uuid!, $high_metric_id: uuid!, $group_name: String!, $group_order: numeric!) {
  insert_tabs_groups_one(object: {group_id: $group_id, metric_id: $metric_id, metric_order: $metric_order, tab_id: $tab_id, high_metric_id: $high_metric_id, group_name: $group_name, group_order: $group_order}) {
    id
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class InsertTabsGroupsOneGQL extends Apollo.Mutation<
  InsertTabsGroupsOneMutation,
  InsertTabsGroupsOneMutationVariables
> {
  document = InsertTabsGroupsOneDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertTabsGroupsOneMutation = {
  __typename?: 'mutation_root';
} & {
  insert_tabs_groups_one?: Maybe<{
    __typename?: 'tabs_groups';
    id: Scalars['uuid'];
  }>;
};

export type InsertTabsGroupsOneMutationVariables = {
  group_id: Scalars['uuid'];
  metric_id: Scalars['uuid'];
  metric_order: Scalars['Float']; // Use 'Float' for numeric types
  group_order: Scalars['Float']; // Use 'Float' for numeric types
  group_name: Scalars['String']; // Use 'Float' for numeric types
  tab_id: Scalars['uuid'];
  high_metric_id: Scalars['uuid'];
};

//---------------

// Define the GraphQL query
export const GetAllTabsWithGroupsDocument = gql`
  query getAllTabs {
    tabs_devices {
      id
      tab_name
      tab_type {
        comment
        id
      }
      device {
        uuid
        device_name
        system_name
        system_type
        devices_impianti {
          impianti_name
          user {
            users_registry {
              name
              surname
            }
          }
          company {
            company_name
          }
        }
      }
      tabs_groups(order_by: { metric_order: asc }) {
        high_metric_id
        metric_id
        id
        metric_order
        group_name
        group_order
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllTabsWithGroupsGQL extends Apollo.Query<GetAllTabsWithGroupsQuery, GetAllTabsWithGroupsQueryVariables> {
  document = GetAllTabsWithGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllTabsWithGroupsQuery = {
  __typename?: 'query_root';
} & {
  tabs_devices: Array<{
    __typename?: 'tabs_devices';
    id: Scalars['uuid'];
    tab_name: Scalars['String'];
    tab_type: {
      __typename?: 'tabs_types';
      comment: Scalars['String'];
      id: Scalars['uuid'];
    };
    device: {
      __typename?: 'devices';
      uuid: Scalars['uuid'];
      device_name: Scalars['String'];
      system_name: Scalars['String'];
      system_type: Scalars['String'];
      devices_impianti: Array<{
        __typename?: 'devices_impianti';
        impianti_name: Scalars['String'];
        user: {
          __typename?: 'users';
          users_registry: Array<{
            __typename?: 'users_registry';
            name: Scalars['String'];
            surname: Scalars['String'];
          }>;
        };
        company: {
          __typename?: 'companies';
          company_name: Scalars['String'];
        };
      }>;
    };
    tabs_groups: Array<{
      __typename?: 'tabs_groups';
      high_metric_id: Scalars['uuid'];
      group_id: Scalars['uuid'];
      metric_id: Scalars['uuid'];
      id: Scalars['uuid'];
      metric_order: Scalars['Int'];
      group_name: Scalars['String'];
      group_order: Scalars['Int'];
    }>;
  }>;
};

export type GetAllTabsWithGroupsQueryVariables = {};

//---------------------

// Define the GraphQL mutation
export const DeleteTabDocument = gql`
  mutation deleteTab($id: uuid!) {
    delete_tabs_devices_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTabGQL extends Apollo.Mutation<DeleteTabMutation, DeleteTabMutationVariables> {
  document = DeleteTabDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteTabMutation = {
  __typename?: 'mutation_root';
} & {
  delete_tabs_devices_by_pk: {
    __typename?: 'tabs_devices';
    id: Scalars['uuid'];
  };
};

export type DeleteTabMutationVariables = {
  id: Scalars['uuid'];
};

//-----------------

export const GetAllUsersDocument = gql`
  query getUsers($userRole: String, $userId: String!) {
    getAllUsers(userData: { userId: $userId, userRole: $userRole }) {
      email
      fiscal_code
      id
      name
      phone
      role
      state
      surname
      created_at
      address_id
      cap
      citta
      codice_ateco
      codice_fiscale
      company_id
      company_name
      indirizzo
      note
      partita
      provincia
      role_comment
      role_id
      manager_id
      zone_coperta
      rfid_status
      credit
      unused_balance
      registry_id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllUsersGQL extends Apollo.Query<GetAllUsersQuery, GetAllUsersQueryVariables> {
  document = GetAllUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllUsersQuery = {
  __typename?: 'query_root';
} & {
  getAllUsers: Array<{
    __typename?: 'users';
    email: string;
    fiscal_code: string;
    id: string;
    name: string;
    phone: string;
    role: string;
    state: string;
    surname: string;
    address_id: string;
    cap: string;
    citta: string;
    codice_ateco: string;
    codice_fiscale: string;
    company_id: string;
    company_name: string;
    indirizzo: string;
    note: string;
    partita: string;
    provincia: string;
    role_comment: string;
    role_id: string;
    manager_id: string;
    rfid_status: string;
    credit: string;
    unused_balance: string;
    registry_id: string;

  }>;
};

export type GetAllUsersQueryVariables = {
  userId: string;
  userRole: string;
};
//-----------------

export const GetAllImpiantiDocument = gql`
  query getAllImpianti($userId: String!) {
    getAllImpianti(userId: { userId: $userId }) {
      codice_fiscale
      company_id
      company_name
      description
      id
      impianti_name
      latitude
      longitude
      manager_id
      manager_name
      manager_surname
      partita
      technician_id
      technician_name
      user_surname
      user_name
      user_id
      technician_surname
      cap
      citta
      provincia
      indirizzo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllImpiantiGQL extends Apollo.Query<GetAllImpiantiQuery, GetAllImpiantiQueryVariables> {
  document = GetAllImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllImpiantiQuery = {
  __typename?: 'query_root';
} & {
  getAllImpianti: Array<{
    __typename?: 'impianti';
    codice_fiscale: string;
    company_id: string;
    company_name: string;
    description: string;
    id: string;
    impianti_name: string;
    latitude: number;
    longitude: number;
    manager_id: string;
    manager_name: string;
    manager_surname: string;
    partita: string;
    technician_id: string;
    technician_name: string;
    technician_surname: string;
    user_id: string;
    user_name: string;
    user_surname: string;
    cap: string;
    citta: string;
    provincia: string;
    indirizzo: string;
  }>;
};

export type GetAllImpiantiQueryVariables = {
  userId: string;
};

//-----------------

export const GetAllDevicesDocument = gql`
  query getAllDevices($userId: String!) {
    getAllDevices(userId: { userId: $userId }) {
      company_name
      connection_name
      device_name
      id
      impianti_id
      impianti_name
      system_name
      system_type
      user_name
      user_surname
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllDevicesGQL extends Apollo.Query<GetAllDevicesQuery, GetAllDevicesQueryVariables> {
  document = GetAllDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllDevicesQuery = {
  __typename?: 'query_root';
} & {
  getAllDevices: Array<{
    __typename?: 'devices';
    company_name: string;
    connection_name: string;
    device_name: string;
    id: string;
    impianti_id: string;
    impianti_name: string;
    system_name: string;
    system_type: string;
    user_name: string;
    user_surname: string;
  }>;
};

export type GetAllDevicesQueryVariables = {
  userId: string;
};

//--------------

//----------------------------
// Query for getting all devices (extended)
//----------------------------

export const GetAllDevicesExtendedDocument = gql`
  query getAllDevices {
    devices {
      connection_name
      connector_id
      cost_per_kwh
      created_at
      credential
      description
      device_name
      deye_station
      serial_number
      impianti_id
      max_power
      order
      provider_id
      public
      status
      start_since
      station_id
      system_name
      system_type
      type_charger
      uuid
      devices_impianti {
        impianti_name
      }
      devices_provider {
        name
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllDevicesExtendedGQL extends Apollo.Query<
  GetAllDevicesExtendedQuery,
  GetAllDevicesExtendedQueryVariables
> {
  document = GetAllDevicesExtendedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllDevicesExtendedQuery = {
  __typename?: 'query_root';
} & {
  devices: Array<{
    __typename?: 'devices';
    connection_name: Scalars['String'];
    connector_id: Scalars['String'];
    cost_per_kwh: Scalars['Float'];
    created_at: Scalars['String'];
    credential: Scalars['String'];
    description: Scalars['String'];
    device_name: Scalars['String'];
    deye_station: Scalars['String'];
    impianti_id: Scalars['uuid'];
    max_power: Scalars['Float'];
    order: Scalars['Int'];
    provider_id: Scalars['uuid'];
    public: Scalars['Boolean'];
    status: Scalars['String'];
    serial_number: Scalars['String'];
    start_since: Scalars['String'];
    station_id: Scalars['uuid'];
    system_name: Scalars['String'];
    system_type: Scalars['String'];
    type_charger: Scalars['String'];
    uuid: Scalars['uuid'];
    devices_impianti: {
      __typename?: 'impianti';
      impianti_name: Scalars['String'];
    };
    devices_provider: {
      __typename?: 'provider';
      name: Scalars['String'];
      code: Scalars['String'];
    };
  }>;
};

export type GetAllDevicesExtendedQueryVariables = {}; // No variables required

//------------------

export const GetAllTabsDocument = gql`
  query getAllTabs($userId: String!) {
    getAllTabs(userId: { userId: $userId }) {
      company_name
      device_id
      device_name
      id
      impianti_name
      system_name
      system_type
      tab_name
      tab_type_comment
      tab_type_id
      user_name
      user_surname
      tabs_groups {
        group_name
        group_order
        high_metric_id
        metric_id
        metric_order
        tabs_groups_id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllTabsGQL extends Apollo.Query<GetAllTabsQuery, GetAllTabsQueryVariables> {
  document = GetAllTabsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllTabsQuery = {
  __typename?: 'query_root';
} & {
  getAllTabs: Array<{
    __typename?: 'tabs';
    company_name: string;
    device_id: string;
    device_name: string;
    id: string;
    impianti_name: string;
    system_name: string;
    system_type: string;
    tab_name: string;
    tab_type_comment: string;
    tab_type_id: string;
    user_name: string;
    user_surname: string;
    tabs_groups: Array<{
      group_name: string;
      group_order: number;
      high_metric_id: string;
      metric_id: string;
      metric_order: number;
      tabs_groups_id: string;
    }>;
  }>;
};

export type GetAllTabsQueryVariables = {
  userId: string;
};

//--------

export const GetAllReportsDocument = gql`
  query MyQuery($userId: String!) {
    getAllReports(userData: { userId: $userId }) {
      company_name
      device_name
      from
      id
      impianti_name
      metric_name
      system_name
      until
      url
      user_name
      user_surname
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllReportsGQL extends Apollo.Query<GetAllReportsQuery, GetAllReportsQueryVariables> {
  document = GetAllReportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllReportsQuery = {
  __typename?: 'query_root';
} & {
  getAllReports: Array<{
    __typename?: 'reports';
    company_name: string;
    device_name: string;
    from: string;
    id: string;
    impianti_name: string;
    metric_name: string;
    system_name: string;
    until: string;
    url: string;
    user_name: string;
    user_surname: string;
  }>;
};

export type GetAllReportsQueryVariables = {
  userId: string;
};

//----------------

export const GetAllReportsCronDocument = gql`
  query getAllReportsCron($userId: String!) {
    getAllReportsCron(userData: { userId: $userId }) {
      absVal
      company
      dailyProd
      device_id
      device_name
      frequency
      id
      impianti_name
      metric_name
      user_surname
      user_name
      user_id
      system_name
      period
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllReportsCronGQL extends Apollo.Query<GetAllReportsCronQuery, GetAllReportsCronQueryVariables> {
  document = GetAllReportsCronDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllReportsCronQuery = {
  __typename?: 'query_root';
} & {
  getAllReportsCron: Array<{
    __typename?: 'reports_cron';
    absVal: boolean;
    company: string;
    dailyProd: boolean;
    device_id: string;
    device_name: string;
    frequency: string;
    id: string;
    impianti_name: string;
    metric_name: string;
    user_surname: string;
    user_name: string;
    user_id: string;
    system_name: string;
    period: string;
  }>;
};

export type GetAllReportsCronQueryVariables = {
  userId: string;
};

//--------------

export const GetPartnerCompaniesDocument = gql`
query getPartnerCompanies {
  companies(where: {isPartner: {_eq: true}}) {
    company_name
    id
  }
}
`;

@Injectable({
  providedIn: 'root',
})
export class GetPartnerCompaniesGQL extends Apollo.Query<GetPartnerCompaniesQuery, GetPartnerCompaniesQueryVariables> {
  document = GetPartnerCompaniesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetPartnerCompaniesQuery = {
  __typename?: 'query_root';
} & {
  companies: Array<{
    __typename?: 'company';
    company_name: Scalars['String'];
    id: Scalars['uuid'];
  }>;
};

export type GetPartnerCompaniesQueryVariables = {};

//--------------

export const GetUsersImpinatoDocument = gql`
  query MyQuery($impianto_id: uuid!) {
    impianti_users(where: {impianto_id: {_eq: $impianto_id}}) {
      user_id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUsersImpinatoGQL extends Apollo.Query<GetUsersImpinatoQuery, GetUsersImpinatoVariables> {
  document = GetUsersImpinatoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetUsersImpinatoQuery = {
  __typename?: 'query_root';
} & {
  impianti_users: Array<{
    __typename?: 'impianti_users';
    id: Scalars['uuid'];
  }>;
};

export type GetUsersImpinatoVariables = {
  impianto_id: string;
};


//--------------

export interface Impianti_users_insert_input {
  impianto_id: string;
  user_id: string;

}

export const InsertImpiantiUsersDocument = gql`
  mutation insertImpiantiUsers($objects: [impianti_users_insert_input!]!) {
    insert_impianti_users(objects: $objects) {
      affected_rows
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertImpiantiUsersGQL extends Apollo.Mutation<
  InsertImpiantiUsersMutation,
  InsertImpiantiUsersMutationVariables
> {
  document = InsertImpiantiUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertImpiantiUsersMutation = {
  __typename?: 'mutation_root';
} & {
  insert_impianti_users: {
    __typename?: 'impianti_users_mutation_response';
    affected_rows: number;
  };
};

export type InsertImpiantiUsersMutationVariables = {
  objects: Array<Impianti_users_insert_input>;
};

//----------------


export interface Impianti_users_insert_input {
  impianto_id: string;
  user_id: string;

}

export const InsertImpiantiUsersOneDocument = gql`
  mutation insertImpiantiUsers($object: impianti_users_insert_input!) {
    insert_impianti_users_one(object: $object) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertImpiantiUsersOneGQL extends Apollo.Mutation<
  InsertImpiantiUsersOneMutation,
  InsertImpiantiUsersOneMutationVariables
> {
  document = InsertImpiantiUsersOneDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertImpiantiUsersOneMutation = {
  __typename?: 'mutation_root';
} & {
  insert_impianti_users_one: {
    __typename?: 'impianti_users';
    id: Scalars['uuid'];
  };
};

export type InsertImpiantiUsersOneMutationVariables = {
  object: Impianti_users_insert_input;
};

//--------------

export const DeleteImpiantiUserDocument = gql`
  mutation DeleteImpiantiUser($_eq: uuid!) {
    delete_impianti_users(where: { impianto_id: { _eq: $_eq } }) {
      affected_rows
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteImpiantiUserGQL extends Apollo.Mutation<
  DeleteImpiantiUserMutation,
  DeleteImpiantiUserMutationVariables
> {
  document = DeleteImpiantiUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteImpiantiUserMutation = {
  __typename?: 'mutation_root';
} & {
  delete_impianti_users: {
    __typename?: 'impianti_users_mutation_response';
    affected_rows: number;
  };
};

export type DeleteImpiantiUserMutationVariables = {
  _eq: Scalars['uuid'];
};

//-----------------------
@Injectable({
  providedIn: 'root',
})
export class InsertImpiantiGQL extends Apollo.Mutation<
  InsertImpiantiMutation,
  InsertImpiantiMutationVariables
> {
  document = InsertImpiantiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const InsertImpiantiDocument = gql`
mutation insertImpianti($description: String, $impianti_name: String!, $latitude: String!, $longitude: String!, $technician_id: uuid, $manager_id: uuid, $user_id: uuid, $company_id: uuid, $provincia: String, $indirizzo: String, $citta: String, $cap: String) {
  insert_impianti_one(object: {description: $description, impianti_name: $impianti_name, latitude: $latitude, longitude: $longitude, technician_id: $technician_id, manager_id: $manager_id, user_id: $user_id, company_id: $company_id, cap: $cap, citta: $citta, indirizzo: $indirizzo, provincia: $provincia}) {
    impianti_name
    latitude
    longitude
    description
    uuid
  }
}
`;

export type InsertImpiantiMutation = {
  __typename?: 'mutation_root';
} & {
  insert_impianti_one: {
    __typename?: 'impianti';
    impianti_name: Scalars['String'];
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
    description: Scalars['String'];
    uuid: Scalars['uuid'];

    cap: Scalars['String'];
    citta: Scalars['String'];
    indirizzo: Scalars['String'];
    provincia: Scalars['String'];
  };
};

export type InsertImpiantiMutationVariables = {
  description: Scalars['String'];
  impianti_name: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  technician_id: Scalars['uuid'];
  manager_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
  company_id: Scalars['uuid'];

  cap: Scalars['String'];
  citta: Scalars['String'];
  indirizzo: Scalars['String'];
  provincia: Scalars['String'];
};


//------------------
//----------------------------
// GetAllTransaction Query
//----------------------------

export const GetAllTransactionDocument = gql`
  query getAllTransaction {
    charging_transactions(order_by: {start_time: desc}, where: {status: {_eq: "finished"}}) {
      cost
      energy_consumed
      idtag
      station_id
      user_id
      start_time
      end_time
      duration
      station {
        id
        charge_point_model
        devices {
          device_name
          impianti_id
          devices_impianti {
            impianti_name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllTransactionGQL extends Apollo.Query<GetAllTransactionQuery, GetAllTransactionQueryVariables> {
  document = GetAllTransactionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllTransactionQuery = {
  __typename?: 'query_root';
  charging_transactions: Array<{
    __typename?: 'charging_transactions';
    cost: number;
    energy_consumed: number;
    idtag: string | null;
    station_id: string;
    user_id: string;
    start_time: string;
    end_time: string;
    station: {
      __typename?: 'stations';
      id: string;
      charge_point_model: string;
    };
  }>;
};

export type GetAllTransactionQueryVariables = {};

//----------------------------



export const IncreaseCreditDocument = gql`
  mutation increaseCredit($balance: String!, $creatorId: String!, $userId: String!) {
    increaseCredit(data: { balance: $balance, creatorId: $creatorId, userId: $userId }) {
      code
      uuid
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class IncreaseCreditGQL extends Apollo.Mutation<
  IncreaseCreditMutation,
  IncreaseCreditMutationVariables
> {
  document = IncreaseCreditDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type IncreaseCreditMutation = {
  __typename?: 'mutation_root';
} & {
  increaseCredit: {
    __typename?: 'increaseCreditResponse'; // name guessed, adjust if needed
    code: string;
    uuid: string;
  };
};

export type IncreaseCreditMutationVariables = {
  balance: string;
  creatorId: string;
  userId: string;
};

//----------------------------

export const GetAllProviderDocument = gql`
  query getAllProvider {
    providers {
      id
      code
      name
      order
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllProviderGQL extends Apollo.Query<
  GetAllProviderQuery,
  GetAllProviderQueryVariables
> {
  document = GetAllProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllProviderQuery = {
  __typename?: 'query_root';
} & {
  providers: Array<{
    __typename?: 'providers';
    id: Scalars['uuid'];
    code: Scalars['String'];
    name: Scalars['String'];
    order: Scalars['Int'];
  }>;
};

export type GetAllProviderQueryVariables = {}; // No variables required


//----------------------------



//----------------------------
// Mutation for inserting a station
//----------------------------

export const InsertStationDocument = gql`
  mutation insertStation(
    $address: String
    $charge_point_model: String
    $charge_point_serial_number: String
    $charge_point_vendor: String
    $latitude: numeric
    $longitude: numeric
    $url: String
    $ws_key: String
  ) {
    insert_stations_one(
      object: {
        address: $address
        charge_point_model: $charge_point_model
        charge_point_serial_number: $charge_point_serial_number
        charge_point_vendor: $charge_point_vendor
        latitude: $latitude
        longitude: $longitude
        url: $url
        ws_key: $ws_key
      }
    ) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertStationGQL extends Apollo.Mutation<
  InsertStationMutation,
  InsertStationMutationVariables
> {
  document = InsertStationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type InsertStationMutation = {
  __typename?: 'mutation_root';
} & {
  insert_stations_one?: {
    __typename?: 'stations';
    id: Scalars['uuid'];
  };
};

export type InsertStationMutationVariables = {
  address?: Scalars['String'];
  charge_point_model?: Scalars['String'];
  charge_point_serial_number?: Scalars['String'];
  charge_point_vendor?: Scalars['String'];
  latitude?: Scalars['Float'];   // numeric → Float (same pattern you used before)
  longitude?: Scalars['Float'];  // numeric → Float
  url?: Scalars['String'];
  ws_key?: Scalars['String'];
};



//----------------------------


//----------------------------
// Query for getting all stations with devices
//----------------------------

export const GetAllStationsWithDevicesDocument = gql`
  query GetAllStationsWithDevices {
    stations {
      id
      address
      status
      latitude
      longitude
      charge_point_model
      charge_point_serial_number
      charge_point_vendor
      url
      ws_key
      devices {
        station_id
        type_charger
        device_name
        status
        userid
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllStationsWithDevicesGQL extends Apollo.Query<
  GetAllStationsWithDevicesQuery,
  GetAllStationsWithDevicesQueryVariables
> {
  document = GetAllStationsWithDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type GetAllStationsWithDevicesQuery = {
  __typename?: 'query_root';
} & {
  stations: Array<{
    __typename?: 'stations';
    id: Scalars['uuid'];
    address: Scalars['String'];
    status: Scalars['String'];
    latitude: Scalars['Float'];
    longitude: Scalars['Float'];
    charge_point_model: Scalars['String'];
    charge_point_serial_number: Scalars['String'];
    charge_point_vendor: Scalars['String'];
    url: Scalars['String'];
    ws_key: Scalars['String'];
    devices: Array<{
      __typename?: 'devices';
      station_id: Scalars['uuid'];
      type_charger: Scalars['String'];
      device_name: Scalars['String'];
      status: Scalars['String'];
      userid: Scalars['String'];
    }>;
  }>;
};

export type GetAllStationsWithDevicesQueryVariables = {}; // No variables


//----------------------------


//----------------------------
// Mutation for updating a station
//----------------------------

export const UpdateStationDocument = gql`
  mutation updateStation(
    $id: uuid!
    $address: String
    $charge_point_model: String
    $charge_point_serial_number: String
    $charge_point_vendor: String
    $latitude: numeric
    $longitude: numeric
    $url: String
    $ws_key: String
  ) {
    update_stations_by_pk(
      pk_columns: { id: $id }
      _set: {
        address: $address
        charge_point_model: $charge_point_model
        charge_point_serial_number: $charge_point_serial_number
        charge_point_vendor: $charge_point_vendor
        latitude: $latitude
        longitude: $longitude
        url: $url
        ws_key: $ws_key
      }
    ) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateStationGQL extends Apollo.Mutation<
  UpdateStationMutation,
  UpdateStationMutationVariables
> {
  document = UpdateStationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type UpdateStationMutation = {
  __typename?: 'mutation_root';
} & {
  update_stations_by_pk?: {
    __typename?: 'stations';
    id: Scalars['uuid'];
  };
};

export type UpdateStationMutationVariables = {
  id: Scalars['uuid'];
  address?: Scalars['String'];
  charge_point_model?: Scalars['String'];
  charge_point_serial_number?: Scalars['String'];
  charge_point_vendor?: Scalars['String'];
  latitude?: Scalars['Float'];   // numeric → Float (consistent with your pattern)
  longitude?: Scalars['Float'];  // numeric → Float
  url?: Scalars['String'];
  ws_key?: Scalars['String'];
};

//----------------------------

//----------------------------
// Mutation for deleting a station
//----------------------------

export const DeleteStationDocument = gql`
  mutation deleteStation($id: uuid!) {
    delete_stations_by_pk(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteStationGQL extends Apollo.Mutation<
  DeleteStationMutation,
  DeleteStationMutationVariables
> {
  document = DeleteStationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export type DeleteStationMutation = {
  __typename?: 'mutation_root';
} & {
  delete_stations_by_pk: {
    __typename?: 'stations';
    id: Scalars['uuid'];
  };
};

export type DeleteStationMutationVariables = {
  id: Scalars['uuid'];
};
